// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type ServerSentEventsResult, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { AcceptFasPredictionsData, AcceptFasPredictionsErrors, AcceptFasPredictionsResponses, AcceptLedgerPredictionsData, AcceptLedgerPredictionsErrors, AcceptLedgerPredictionsResponses, AcceptTermsData, AcceptTermsErrors, AcceptTermsResponses, AcknowledgeAgbwIssuesData, AcknowledgeAgbwIssuesErrors, AcknowledgeAgbwIssuesResponses, AddAccountMappingLevel3TargetData, AddAccountMappingLevel3TargetErrors, AddAccountMappingLevel3TargetResponses, AddDepartmentAdminData, AddDepartmentAdminErrors, AddDepartmentAdminResponses, AddEmailWhitelistPatternData, AddEmailWhitelistPatternErrors, AddEmailWhitelistPatternResponses, AddProjectMemberData, AddProjectMemberErrors, AddProjectMemberResponses, AnalyzeWorkflowActionSqlParametersData, AnalyzeWorkflowActionSqlParametersErrors, AnalyzeWorkflowActionSqlParametersResponses, ApproveData, ApproveErrors, ApproveIndividualWorkflowData, ApproveIndividualWorkflowErrors, ApproveIndividualWorkflowResponses, ApprovePromotionRequestData, ApprovePromotionRequestErrors, ApprovePromotionRequestResponses, ApproveResponses, ArchiveProjectData, ArchiveProjectErrors, ArchiveProjectResponses, ArchiveStatementTaxonomyData, ArchiveStatementTaxonomyErrors, ArchiveStatementTaxonomyResponses, AssignUserRoleData, AssignUserRoleErrors, AssignUserRoleResponses, BatchCreateClientsData, BatchCreateClientsErrors, BatchCreateClientsResponses, BulkCreateOriginDatasourcesData, BulkCreateOriginDatasourcesErrors, BulkCreateOriginDatasourcesResponses, BulkUpdateClientTagsData, BulkUpdateClientTagsErrors, BulkUpdateClientTagsResponses, CancelData, CancelErrors, CancelPromotionRequestData, CancelPromotionRequestErrors, CancelPromotionRequestResponses, CancelResponses, CancelRunData, CancelRunErrors, CancelRunResponses, ClassifyAccountMappingsData, ClassifyAccountMappingsErrors, ClassifyAccountMappingsResponses, ClassifyScopedAccountMappingsData, ClassifyScopedAccountMappingsErrors, ClassifyScopedAccountMappingsResponses, ClearAccountMappingsData, ClearAccountMappingsErrors, ClearAccountMappingsResponses, ClearBatchFilesData, ClearBatchFilesErrors, ClearBatchFilesResponses, ClearCamtFilesData, ClearCamtFilesErrors, ClearCamtFilesResponses, ClearLedgerClassificationsData, ClearLedgerClassificationsErrors, ClearLedgerClassificationsResponses, CloneWorkflowActionData, CloneWorkflowActionErrors, CloneWorkflowActionResponses, CloneWorkflowData, CloneWorkflowErrors, CloneWorkflowResponses, CloneWorkflowSetData, CloneWorkflowSetErrors, CloneWorkflowSetResponses, CompareDocumentsData, CompareDocumentsErrors, CompareDocumentsResponses, ConfirmAuditPreviousReportStageData, ConfirmAuditPreviousReportStageErrors, ConfirmAuditPreviousReportStageResponses, ConfirmAuditStatementExtractionStageData, ConfirmAuditStatementExtractionStageErrors, ConfirmAuditStatementExtractionStageResponses, ConfirmStatementExtractionStageData, ConfirmStatementExtractionStageErrors, ConfirmStatementExtractionStageResponses, ConfirmUploadData, ConfirmUploadErrors, ConfirmUploadResponses, CopyAccountMappingsData, CopyAccountMappingsErrors, CopyAccountMappingsResponses, CopyAuditFilesFromPreviousDossierData, CopyAuditFilesFromPreviousDossierErrors, CopyAuditFilesFromPreviousDossierResponses, CopyClassificationsData, CopyClassificationsErrors, CopyClassificationsResponses, CopyLedgerClassificationsData, CopyLedgerClassificationsErrors, CopyLedgerClassificationsResponses, CopyWorkflowActionData, CopyWorkflowActionErrors, CopyWorkflowActionResponses, CreateArticleData, CreateArticleErrors, CreateArticleResponses, CreateArticleTemplateData, CreateArticleTemplateErrors, CreateArticleTemplateResponses, CreateBugReportData, CreateBugReportErrors, CreateBugReportResponses, CreateChatFromExecutionData, CreateChatFromExecutionErrors, CreateChatFromExecutionResponses, CreateClassificationTemplateData, CreateClassificationTemplateErrors, CreateClassificationTemplateResponses, CreateClientTagData, CreateClientTagErrors, CreateClientTagResponses, CreateCollectionData, CreateCollectionErrors, CreateCollectionResponses, CreateDashboardChainWidgetData, CreateDashboardChainWidgetErrors, CreateDashboardChainWidgetResponses, CreateDashboardData, CreateDashboardErrors, CreateDashboardResponses, CreateDashboardWidgetData, CreateDashboardWidgetErrors, CreateDashboardWidgetResponses, CreateDatasourceData, CreateDatasourceErrors, CreateDatasourceResponses, CreateDepartmentData, CreateDepartmentErrors, CreateDepartmentResponses, CreateDocumentAnalysisTemplateData, CreateDocumentAnalysisTemplateErrors, CreateDocumentAnalysisTemplateResponses, CreateFaqData, CreateFaqErrors, CreateFaqResponses, CreateFeedbackData, CreateFeedbackErrors, CreateFeedbackResponses, CreateFinancialExplorerChatData, CreateFinancialExplorerChatErrors, CreateFinancialExplorerChatResponses, CreateLedgerClassificationTemplateData, CreateLedgerClassificationTemplateErrors, CreateLedgerClassificationTemplateResponses, CreateOrganizationData, CreateOrganizationErrors, CreateOrganizationResponses, CreateOriginData, CreateOriginErrors, CreateOriginResponses, CreateOrUpdateCommentData, CreateOrUpdateCommentErrors, CreateOrUpdateCommentResponses, CreateOrUpdateConfirmationData, CreateOrUpdateConfirmationErrors, CreateOrUpdateConfirmationResponses, CreateProjectData, CreateProjectErrors, CreateProjectHierarchyData, CreateProjectHierarchyErrors, CreateProjectHierarchyResponses, CreateProjectResponses, CreatePromotionRequestData, CreatePromotionRequestErrors, CreatePromotionRequestResponses, CreatePromptData, CreatePromptErrors, CreatePromptResponses, CreateReleaseNoteData, CreateReleaseNoteErrors, CreateReleaseNoteResponses, CreateScheduleData, CreateScheduleErrors, CreateScheduleResponses, CreateStatementTaxonomyData, CreateStatementTaxonomyErrors, CreateStatementTaxonomyResponses, CreateTemplateVersionData, CreateTemplateVersionErrors, CreateTemplateVersionResponses, CreateTopicData, CreateTopicErrors, CreateTopicResponses, CreateWidgetChatData, CreateWidgetChatErrors, CreateWidgetChatResponses, CreateWorkflowActionData, CreateWorkflowActionErrors, CreateWorkflowActionResponses, CreateWorkflowData, CreateWorkflowErrors, CreateWorkflowResponses, CreateWorkflowSetData, CreateWorkflowSetErrors, CreateWorkflowSetResponses, DeconfirmAuditPreviousReportStageData, DeconfirmAuditPreviousReportStageErrors, DeconfirmAuditPreviousReportStageResponses, DeconfirmAuditStatementExtractionStageData, DeconfirmAuditStatementExtractionStageErrors, DeconfirmAuditStatementExtractionStageResponses, DeconfirmStatementExtractionStageData, DeconfirmStatementExtractionStageErrors, DeconfirmStatementExtractionStageResponses, DeleteAllTrialBalanceEntriesData, DeleteAllTrialBalanceEntriesErrors, DeleteAllTrialBalanceEntriesResponses, DeleteAnalysisRunData, DeleteAnalysisRunErrors, DeleteAnalysisRunResponses, DeleteArticleData, DeleteArticleErrors, DeleteArticleResponses, DeleteArticleTemplateData, DeleteArticleTemplateErrors, DeleteArticleTemplateResponses, DeleteAuditCheckData, DeleteAuditCheckErrors, DeleteAuditCheckResponses, DeleteAuditFilesData, DeleteAuditFilesErrors, DeleteAuditFilesResponses, DeleteClassificationTemplateData, DeleteClassificationTemplateErrors, DeleteClassificationTemplateResponses, DeleteClientTagData, DeleteClientTagErrors, DeleteClientTagResponses, DeleteCollectionData, DeleteCollectionErrors, DeleteCollectionResponses, DeleteCommentData, DeleteCommentErrors, DeleteCommentResponses, DeleteConfirmationData, DeleteConfirmationErrors, DeleteConfirmationResponses, DeleteConversationData, DeleteConversationErrors, DeleteConversationResponses, DeleteDashboardData, DeleteDashboardErrors, DeleteDashboardResponses, DeleteDashboardWidgetData, DeleteDashboardWidgetErrors, DeleteDashboardWidgetResponses, DeleteDatasourcesData, DeleteDatasourcesErrors, DeleteDatasourcesResponses, DeleteDocumentAnalysisTemplateData, DeleteDocumentAnalysisTemplateErrors, DeleteDocumentAnalysisTemplateResponses, DeleteFaqData, DeleteFaqErrors, DeleteFaqResponses, DeleteMediaData, DeleteMediaErrors, DeleteMediaResponses, DeleteOrganizationData, DeleteOrganizationErrors, DeleteOrganizationFileData, DeleteOrganizationFileErrors, DeleteOrganizationFileResponses, DeleteOrganizationResponses, DeleteOriginData, DeleteOriginErrors, DeleteOriginResponses, DeleteProjectData, DeleteProjectErrors, DeleteProjectResponses, DeletePromptData, DeletePromptErrors, DeletePromptResponses, DeleteReleaseNoteData, DeleteReleaseNoteErrors, DeleteReleaseNoteResponses, DeleteScheduleData, DeleteScheduleErrors, DeleteScheduleResponses, DeleteTopicData, DeleteTopicErrors, DeleteTopicResponses, DeleteTrainingCompletionData, DeleteTrainingCompletionErrors, DeleteTrainingCompletionResponses, DeleteTrialBalanceEntryData, DeleteTrialBalanceEntryErrors, DeleteTrialBalanceEntryResponses, DeleteUserData, DeleteUserErrors, DeleteUserResponses, DeleteWorkflowActionData, DeleteWorkflowActionErrors, DeleteWorkflowActionResponses, DeleteWorkflowData, DeleteWorkflowErrors, DeleteWorkflowResponses, DeleteWorkflowSetData, DeleteWorkflowSetErrors, DeleteWorkflowSetResponses, DemoteData, DemoteErrors, DemoteResponses, DisconnectProjectVectorizedDatasourceData, DisconnectProjectVectorizedDatasourceErrors, DisconnectProjectVectorizedDatasourceResponses, DislikeArticleData, DislikeArticleErrors, DislikeArticleResponses, DocumentAnalysisSearchData, DocumentAnalysisSearchErrors, DocumentAnalysisSearchResponses, DownloadAuditFileData, DownloadAuditFileErrors, DownloadAuditFileResponses, DownloadMediaData, DownloadMediaErrors, DownloadMediaResponses, DuplicateDocumentAnalysisTemplateData, DuplicateDocumentAnalysisTemplateErrors, DuplicateDocumentAnalysisTemplateResponses, ExecuteAuditWorkflowData, ExecuteAuditWorkflowErrors, ExecuteAuditWorkflowResponse, ExecuteAuditWorkflowResponses, ExportAccountMappingsData, ExportAccountMappingsErrors, ExportAccountMappingsResponses, ExportAccountsDrilldownData, ExportAccountsDrilldownErrors, ExportAccountsDrilldownResponses, ExportAgbwOutputData, ExportAgbwOutputErrors, ExportAgbwOutputResponses, ExportAuditReconciliationData, ExportAuditReconciliationErrors, ExportAuditReconciliationExcelData, ExportAuditReconciliationExcelErrors, ExportAuditReconciliationExcelResponses, ExportAuditReconciliationResponses, ExportBatchDrilldownData, ExportBatchDrilldownErrors, ExportBatchDrilldownResponses, ExportChangedIbanDrilldownData, ExportChangedIbanDrilldownErrors, ExportChangedIbanDrilldownResponses, ExportClassificationResultsExcelData, ExportClassificationResultsExcelErrors, ExportClassificationResultsExcelResponses, ExportClassificationsData, ExportClassificationsErrors, ExportClassificationsResponses, ExportContinuousAuditorTransactionsData, ExportContinuousAuditorTransactionsErrors, ExportContinuousAuditorTransactionsResponses, ExportCorporateFinanceWorkbookData, ExportCorporateFinanceWorkbookErrors, ExportCorporateFinanceWorkbookResponses, ExportCpiPaymentsDrilldownData, ExportCpiPaymentsDrilldownErrors, ExportCpiPaymentsDrilldownResponses, ExportCpiReceivedDrilldownData, ExportCpiReceivedDrilldownErrors, ExportCpiReceivedDrilldownResponses, ExportCreditcardStatementsDrilldownData, ExportCreditcardStatementsDrilldownErrors, ExportCreditcardStatementsDrilldownResponses, ExportDataData, ExportDataErrors, ExportDataResponses, ExportDatasourceData, ExportDatasourceErrors, ExportDatasourceResponses, ExportDocumentAnalysisRunResultsAsExcelData, ExportDocumentAnalysisRunResultsAsExcelErrors, ExportDocumentAnalysisRunResultsAsExcelResponses, ExportDocumentAnalysisRunResultsAsPdfData, ExportDocumentAnalysisRunResultsAsPdfErrors, ExportDocumentAnalysisRunResultsAsPdfResponses, ExportForeignCurrencyDrilldownData, ExportForeignCurrencyDrilldownErrors, ExportForeignCurrencyDrilldownResponses, ExportGovernmentDrilldownData, ExportGovernmentDrilldownErrors, ExportGovernmentDrilldownResponses, ExportIbanSalaryOtherPaymentsDrilldownData, ExportIbanSalaryOtherPaymentsDrilldownErrors, ExportIbanSalaryOtherPaymentsDrilldownResponses, ExportIntercompanyPaymentsDrilldownData, ExportIntercompanyPaymentsDrilldownErrors, ExportIntercompanyPaymentsDrilldownResponses, ExportLedgerClassificationsData, ExportLedgerClassificationsErrors, ExportLedgerClassificationsResponses, ExportMissingIbanPaymentsDrilldownData, ExportMissingIbanPaymentsDrilldownErrors, ExportMissingIbanPaymentsDrilldownResponses, ExportMissingIbanReceivedDrilldownData, ExportMissingIbanReceivedDrilldownErrors, ExportMissingIbanReceivedDrilldownResponses, ExportNameChangeDrilldownData, ExportNameChangeDrilldownErrors, ExportNameChangeDrilldownResponses, ExportNewPartyDrilldownData, ExportNewPartyDrilldownErrors, ExportNewPartyDrilldownResponses, ExportNotableDescriptionDrilldownData, ExportNotableDescriptionDrilldownErrors, ExportNotableDescriptionDrilldownResponses, ExportRecurrentPaymentsDrilldownData, ExportRecurrentPaymentsDrilldownErrors, ExportRecurrentPaymentsDrilldownResponses, ExportSameIbanTransactionsDrilldownData, ExportSameIbanTransactionsDrilldownErrors, ExportSameIbanTransactionsDrilldownResponses, ExportTrialBalanceData, ExportTrialBalanceErrors, ExportTrialBalanceResponses, ExportValidationResultsData, ExportValidationResultsErrors, ExportValidationResultsResponses, ExportWeekVacationDaysDrilldownData, ExportWeekVacationDaysDrilldownErrors, ExportWeekVacationDaysDrilldownResponses, GenerateActionTechnicalExplanationData, GenerateActionTechnicalExplanationErrors, GenerateActionTechnicalExplanationResponses, GenerateTwoFaData, GenerateTwoFaErrors, GenerateTwoFaResponses, GetAccountMappingExportStatusData, GetAccountMappingExportStatusErrors, GetAccountMappingExportStatusResponses, GetAccountsDrilldownData, GetAccountsDrilldownErrors, GetAccountsDrilldownResponses, GetAccountsSummaryData, GetAccountsSummaryErrors, GetAccountsSummaryResponses, GetActiveProjectPipelineData, GetActiveProjectPipelineErrors, GetActiveProjectPipelineResponses, GetAgbwContinueAcknowledgmentData, GetAgbwContinueAcknowledgmentErrors, GetAgbwContinueAcknowledgmentResponses, GetAgbwPipelineStatusData, GetAgbwPipelineStatusErrors, GetAgbwPipelineStatusResponses, GetAgbwProgressData, GetAgbwProgressErrors, GetAgbwProgressResponses, GetAllOrganizationsData, GetAllOrganizationsErrors, GetAllOrganizationsResponses, GetAllUsersData, GetAllUsersErrors, GetAllUsersResponses, GetAnalysisRunResultsData, GetAnalysisRunResultsErrors, GetAnalysisRunResultsResponses, GetAnnualReportPipelineStatusData, GetAnnualReportPipelineStatusErrors, GetAnnualReportPipelineStatusResponses, GetArticleData, GetArticleErrors, GetArticleResponses, GetArticlesData, GetArticlesErrors, GetArticlesResponses, GetArticleTemplateData, GetArticleTemplateErrors, GetArticleTemplateResponses, GetArticleTemplatesData, GetArticleTemplatesErrors, GetArticleTemplatesResponses, GetAuditChecksData, GetAuditChecksErrors, GetAuditChecksResponses, GetAuditReconciliationExportStatusData, GetAuditReconciliationExportStatusErrors, GetAuditReconciliationExportStatusResponses, GetBatchDrilldownData, GetBatchDrilldownErrors, GetBatchDrilldownResponses, GetBatchPurchaseOverviewData, GetBatchPurchaseOverviewErrors, GetBatchPurchaseOverviewResponses, GetBatchSalaryOverviewData, GetBatchSalaryOverviewErrors, GetBatchSalaryOverviewResponses, GetBatchSummaryData, GetBatchSummaryErrors, GetBatchSummaryResponses, GetChangedIbanAggregationData, GetChangedIbanAggregationErrors, GetChangedIbanAggregationResponses, GetChangedIbanDrilldownData, GetChangedIbanDrilldownErrors, GetChangedIbanDrilldownResponses, GetClassificationPipelineStatusData, GetClassificationPipelineStatusErrors, GetClassificationPipelineStatusResponses, GetClassificationStatsData, GetClassificationStatsErrors, GetClassificationStatsResponses, GetClassificationTemplateData, GetClassificationTemplateErrors, GetClassificationTemplateResponses, GetClientAnalysisRunsData, GetClientAnalysisRunsErrors, GetClientAnalysisRunsResponses, GetCollectionData, GetCollectionErrors, GetCollectionFiltersData, GetCollectionFiltersErrors, GetCollectionFiltersResponses, GetCollectionResponses, GetCollectionShareData, GetCollectionShareErrors, GetCollectionShareResponses, GetCommentData, GetCommentErrors, GetCommentResponses, GetCommentsForDashboardData, GetCommentsForDashboardErrors, GetCommentsForDashboardResponses, GetConfirmationData, GetConfirmationErrors, GetConfirmationResponses, GetConfirmationsForDashboardData, GetConfirmationsForDashboardErrors, GetConfirmationsForDashboardResponses, GetContinuousAuditorRefreshPipelineStatusData, GetContinuousAuditorRefreshPipelineStatusErrors, GetContinuousAuditorRefreshPipelineStatusResponses, GetConversationsData, GetConversationsErrors, GetConversationsResponses, GetCpiPaymentsAggregationData, GetCpiPaymentsAggregationErrors, GetCpiPaymentsAggregationResponses, GetCpiPaymentsDrilldownData, GetCpiPaymentsDrilldownErrors, GetCpiPaymentsDrilldownResponses, GetCpiPreferenceData, GetCpiPreferenceErrors, GetCpiPreferenceResponses, GetCpiReceivementsAggregationData, GetCpiReceivementsAggregationErrors, GetCpiReceivementsAggregationResponses, GetCpiReceivementsDrilldownData, GetCpiReceivementsDrilldownErrors, GetCpiReceivementsDrilldownResponses, GetCreditcardStatementsAggregationData, GetCreditcardStatementsAggregationErrors, GetCreditcardStatementsAggregationResponses, GetCreditcardStatementsDrilldownData, GetCreditcardStatementsDrilldownErrors, GetCreditcardStatementsDrilldownResponses, GetCurrentTermsData, GetCurrentTermsErrors, GetCurrentTermsResponses, GetCurrentUserData, GetCurrentUserErrors, GetCurrentUserInvitationsData, GetCurrentUserInvitationsErrors, GetCurrentUserInvitationsResponses, GetCurrentUserPermissionData, GetCurrentUserPermissionErrors, GetCurrentUserPermissionResponses, GetCurrentUserResponses, GetDashboardData, GetDashboardErrors, GetDashboardFilterValuesData, GetDashboardFilterValuesErrors, GetDashboardFilterValuesResponses, GetDashboardResponses, GetDashboardsData, GetDashboardsErrors, GetDashboardsResponses, GetDatasourceByIdData, GetDatasourceByIdErrors, GetDatasourceByIdResponses, GetDatasourceFileData, GetDatasourceFileErrors, GetDatasourceFileResponses, GetDatasourceFiltersData, GetDatasourceFiltersErrors, GetDatasourceFiltersResponses, GetDatasourcesPageData, GetDatasourcesPageErrors, GetDatasourcesPageResponses, GetDocumentAnalysisSettingsData, GetDocumentAnalysisSettingsErrors, GetDocumentAnalysisSettingsResponses, GetDocumentAnalysisTemplateData, GetDocumentAnalysisTemplateErrors, GetDocumentAnalysisTemplateResponses, GetDocumentAnalysisTemplatesData, GetDocumentAnalysisTemplatesErrors, GetDocumentAnalysisTemplatesResponses, GetEmailWhitelistPatternsData, GetEmailWhitelistPatternsErrors, GetEmailWhitelistPatternsResponses, GetEventsData, GetEventsErrors, GetEventsResponses, GetExecutionReportData, GetExecutionReportErrors, GetExecutionReportResponses, GetExecutionResultsData, GetExecutionResultsErrors, GetExecutionResultsResponses, GetFaqsData, GetFaqsErrors, GetFaqsResponses, GetFinancialExplorerData, GetFinancialExplorerErrors, GetFinancialExplorerReconciliationData, GetFinancialExplorerReconciliationErrors, GetFinancialExplorerReconciliationResponses, GetFinancialExplorerResponses, GetFinancialExplorerTransactionFilterValuesData, GetFinancialExplorerTransactionFilterValuesErrors, GetFinancialExplorerTransactionFilterValuesResponses, GetFinancialExplorerTransactionsData, GetFinancialExplorerTransactionsErrors, GetFinancialExplorerTransactionsResponses, GetForeignCurrencyAggregationData, GetForeignCurrencyAggregationErrors, GetForeignCurrencyAggregationResponses, GetForeignCurrencyDrilldownData, GetForeignCurrencyDrilldownErrors, GetForeignCurrencyDrilldownResponses, GetGovernmentAggregationData, GetGovernmentAggregationErrors, GetGovernmentAggregationResponses, GetGovernmentDrilldownData, GetGovernmentDrilldownErrors, GetGovernmentDrilldownResponses, GetIbanSalaryOtherPaymentsAggregationData, GetIbanSalaryOtherPaymentsAggregationErrors, GetIbanSalaryOtherPaymentsAggregationResponses, GetIbanSalaryOtherPaymentsDrilldownData, GetIbanSalaryOtherPaymentsDrilldownErrors, GetIbanSalaryOtherPaymentsDrilldownResponses, GetIntercompanyPaymentsAggregationData, GetIntercompanyPaymentsAggregationErrors, GetIntercompanyPaymentsAggregationResponses, GetIntercompanyPaymentsDrilldownData, GetIntercompanyPaymentsDrilldownErrors, GetIntercompanyPaymentsDrilldownResponses, GetLatestClassificationTemplateVersionData, GetLatestClassificationTemplateVersionErrors, GetLatestClassificationTemplateVersionResponses, GetLedgerExportStatusData, GetLedgerExportStatusErrors, GetLedgerExportStatusResponses, GetLedgerStatsData, GetLedgerStatsErrors, GetLedgerStatsResponses, GetMaterialityPreferenceData, GetMaterialityPreferenceErrors, GetMaterialityPreferenceResponses, GetMediaMetadataData, GetMediaMetadataErrors, GetMediaMetadataResponses, GetMissingIbanPaymentsAggregationData, GetMissingIbanPaymentsAggregationErrors, GetMissingIbanPaymentsAggregationResponses, GetMissingIbanPaymentsDrilldownData, GetMissingIbanPaymentsDrilldownErrors, GetMissingIbanPaymentsDrilldownResponses, GetMissingIbanReceivedAggregationData, GetMissingIbanReceivedAggregationErrors, GetMissingIbanReceivedAggregationResponses, GetMissingIbanReceivedDrilldownData, GetMissingIbanReceivedDrilldownErrors, GetMissingIbanReceivedDrilldownResponses, GetMultipleIbansPerKvkData, GetMultipleIbansPerKvkErrors, GetMultipleIbansPerKvkResponses, GetNameChangeAggregationData, GetNameChangeAggregationErrors, GetNameChangeAggregationResponses, GetNameChangeDrilldownData, GetNameChangeDrilldownErrors, GetNameChangeDrilldownResponses, GetNewPartyAggregationData, GetNewPartyAggregationErrors, GetNewPartyAggregationResponses, GetNewPartyDrilldownData, GetNewPartyDrilldownErrors, GetNewPartyDrilldownResponses, GetOrganizationData, GetOrganizationDepartmentsData, GetOrganizationDepartmentsErrors, GetOrganizationDepartmentsResponses, GetOrganizationErrors, GetOrganizationFileData, GetOrganizationFileErrors, GetOrganizationFileResponses, GetOrganizationInvitationsData, GetOrganizationInvitationsErrors, GetOrganizationInvitationsResponses, GetOrganizationProjectParametersData, GetOrganizationProjectParametersErrors, GetOrganizationProjectParametersResponses, GetOrganizationResponses, GetOrganizationUserPermissionsData, GetOrganizationUserPermissionsErrors, GetOrganizationUserPermissionsResponses, GetOrganizationUserProfileData, GetOrganizationUserProfileErrors, GetOrganizationUserProfileResponses, GetOrganizationUserProfilesData, GetOrganizationUserProfilesErrors, GetOrganizationUserProfilesResponses, GetOrganizationUsersData, GetOrganizationUsersErrors, GetOrganizationUsersResponses, GetOrgReviewSessionDetailData, GetOrgReviewSessionDetailErrors, GetOrgReviewSessionDetailResponses, GetOrgReviewToolOutputData, GetOrgReviewToolOutputErrors, GetOrgReviewToolOutputResponses, GetOrgReviewTurnInspectorData, GetOrgReviewTurnInspectorErrors, GetOrgReviewTurnInspectorResponses, GetOriginData, GetOriginErrors, GetOriginResponses, GetPaymentCategoryPivotData, GetPaymentCategoryPivotErrors, GetPaymentCategoryPivotResponses, GetPaymentOverviewData, GetPaymentOverviewErrors, GetPaymentOverviewResponses, GetPaymentTypesData, GetPaymentTypesErrors, GetPaymentTypesResponses, GetPendingDocumentAnalysisTemplateForPromotionReviewData, GetPendingDocumentAnalysisTemplateForPromotionReviewErrors, GetPendingDocumentAnalysisTemplateForPromotionReviewResponses, GetPermissionsData, GetPermissionsErrors, GetPermissionsResponses, GetPersonalAnalysisRunsData, GetPersonalAnalysisRunsErrors, GetPersonalAnalysisRunsResponses, GetPossibleDuplicatePaymentsData, GetPossibleDuplicatePaymentsErrors, GetPossibleDuplicatePaymentsResponses, GetPreviewData, GetPreviewErrors, GetPreviewResponses, GetProjectAuditFileGlCoverageData, GetProjectAuditFileGlCoverageErrors, GetProjectAuditFileGlCoverageResponses, GetProjectDatasourcesData, GetProjectDatasourcesErrors, GetProjectDatasourcesResponses, GetProjectExecutionHistoryData, GetProjectExecutionHistoryErrors, GetProjectExecutionHistoryResponses, GetProjectFiltersData, GetProjectFiltersErrors, GetProjectFiltersResponses, GetProjectHierarchyData, GetProjectHierarchyErrors, GetProjectHierarchyResponses, GetProjectMembersData, GetProjectMembersErrors, GetProjectMembersResponses, GetProjectParametersData, GetProjectParametersErrors, GetProjectParametersResponses, GetProjectsData, GetProjectsErrors, GetProjectsResponses, GetPromotionRequestData, GetPromotionRequestErrors, GetPromotionRequestResponses, GetPromptData, GetPromptErrors, GetPromptLibraryData, GetPromptLibraryErrors, GetPromptLibraryResponses, GetPromptResponses, GetPromptSharesData, GetPromptSharesErrors, GetPromptSharesResponses, GetReceivablesByCounterpartyOverviewData, GetReceivablesByCounterpartyOverviewErrors, GetReceivablesByCounterpartyOverviewResponses, GetRecurrentPaymentsAggregationData, GetRecurrentPaymentsAggregationErrors, GetRecurrentPaymentsAggregationResponses, GetRecurrentPaymentsDrilldownData, GetRecurrentPaymentsDrilldownErrors, GetRecurrentPaymentsDrilldownResponses, GetRefreshAfasDataPipelineStatusData, GetRefreshAfasDataPipelineStatusErrors, GetRefreshAfasDataPipelineStatusResponses, GetRefreshAuditFilePipelineStatusData, GetRefreshAuditFilePipelineStatusErrors, GetRefreshAuditFilePipelineStatusResponses, GetReleaseNoteByIdData, GetReleaseNoteByIdErrors, GetReleaseNoteByIdResponses, GetReleaseNotesData, GetReleaseNotesErrors, GetReleaseNotesResponses, GetRolesData, GetRolesErrors, GetRolesResponses, GetRunData, GetRunErrors, GetRunResponses, GetSameIbanTransactionsAggregationData, GetSameIbanTransactionsAggregationErrors, GetSameIbanTransactionsAggregationResponses, GetSameIbanTransactionsDrilldownData, GetSameIbanTransactionsDrilldownErrors, GetSameIbanTransactionsDrilldownResponses, GetScheduleData, GetScheduleErrors, GetScheduleResponses, GetSharedDashboardData, GetSharedDashboardErrors, GetSharedDashboardResponses, GetSharedDatasourceData, GetSharedDatasourceErrors, GetSharedDatasourceResponses, GetSourceStatusData, GetSourceStatusErrors, GetSourceStatusResponses, GetSpecialDescriptionAggregationData, GetSpecialDescriptionAggregationErrors, GetSpecialDescriptionAggregationResponses, GetSpecialDescriptionDrilldownData, GetSpecialDescriptionDrilldownErrors, GetSpecialDescriptionDrilldownResponses, GetTemplateAnalysisRunsData, GetTemplateAnalysisRunsErrors, GetTemplateAnalysisRunsResponses, GetTermsAcceptanceStatusData, GetTermsAcceptanceStatusErrors, GetTermsAcceptanceStatusResponses, GetTermsDocumentData, GetTermsDocumentErrors, GetTermsDocumentResponses, GetTopicsData, GetTopicsErrors, GetTopicsResponses, GetTrainingOverviewData, GetTrainingOverviewErrors, GetTrainingOverviewResponses, GetTransactionDrilldownData, GetTransactionDrilldownErrors, GetTransactionDrilldownResponses, GetTransactionFilterValuesData, GetTransactionFilterValuesErrors, GetTransactionFilterValuesResponses, GetTransactionOverviewData, GetTransactionOverviewErrors, GetTransactionOverviewResponses, GetTransactionsData, GetTransactionsErrors, GetTransactionsResponses, GetTrialBalanceEntriesData, GetTrialBalanceEntriesErrors, GetTrialBalanceEntriesResponses, GetTrialBalancePipelineStatusData, GetTrialBalancePipelineStatusErrors, GetTrialBalancePipelineStatusResponses, GetUniqueCounterpartiesMultipleIbansData, GetUniqueCounterpartiesMultipleIbansErrors, GetUniqueCounterpartiesMultipleIbansResponses, GetUsageSessionDetailData, GetUsageSessionDetailErrors, GetUsageSessionDetailResponses, GetUsageToolOutputData, GetUsageToolOutputErrors, GetUsageToolOutputResponses, GetUsageTurnInspectorData, GetUsageTurnInspectorErrors, GetUsageTurnInspectorResponses, GetUserData, GetUserErrors, GetUserResponses, GetWeekVacationDaysAggregationData, GetWeekVacationDaysAggregationErrors, GetWeekVacationDaysAggregationResponses, GetWeekVacationDaysDrilldownData, GetWeekVacationDaysDrilldownErrors, GetWeekVacationDaysDrilldownResponses, GetWorkflowActionData, GetWorkflowActionErrors, GetWorkflowActionResponses, GetWorkflowActionsData, GetWorkflowActionsErrors, GetWorkflowActionsResponses, GetWorkflowSetsData, GetWorkflowSetsErrors, GetWorkflowSetsResponses, HardDeletePromotionRequestData, HardDeletePromotionRequestErrors, HardDeletePromotionRequestResponses, HealthData, HealthErrors, HealthResponses, ImportPriorYearClassificationsData, ImportPriorYearClassificationsErrors, ImportPriorYearClassificationsResponses, ImprovePromptData, ImprovePromptErrors, ImprovePromptResponses, IncrementArticleViewsData, IncrementArticleViewsErrors, IncrementArticleViewsResponses, IncrementFaqViewsData, IncrementFaqViewsErrors, IncrementFaqViewsResponses, InfoData, InfoErrors, InfoResponses, InviteUserToOrganizationByEmailData, InviteUserToOrganizationByEmailErrors, InviteUserToOrganizationByEmailResponses, JwtForgotPasswordData, JwtForgotPasswordErrors, JwtForgotPasswordResponses, JwtLoginData, JwtLoginErrors, JwtLoginResponses, JwtLogoutData, JwtLogoutErrors, JwtLogoutResponses, JwtRefreshData, JwtRefreshErrors, JwtRefreshResponses, JwtRegisterData, JwtRegisterErrors, JwtRegisterResponses, JwtRequestVerifyTokenData, JwtRequestVerifyTokenErrors, JwtRequestVerifyTokenResponses, JwtResetPasswordData, JwtResetPasswordErrors, JwtResetPasswordResponses, JwtVerifyData, JwtVerifyErrors, JwtVerifyResponses, LatestAuditBudgetReconciliationData, LatestAuditBudgetReconciliationErrors, LatestAuditBudgetReconciliationResponses, LatestAuditStatementExtractionData, LatestAuditStatementExtractionErrors, LatestAuditStatementExtractionJobsData, LatestAuditStatementExtractionJobsErrors, LatestAuditStatementExtractionJobsResponses, LatestAuditStatementExtractionResponses, LatestAuditStatementReferenceReconciliationData, LatestAuditStatementReferenceReconciliationErrors, LatestAuditStatementReferenceReconciliationResponses, LatestStatementExtractionData, LatestStatementExtractionErrors, LatestStatementExtractionResponses, LikeArticleData, LikeArticleErrors, LikeArticleResponses, ListAccountMappingsData, ListAccountMappingsErrors, ListAccountMappingsResponses, ListAuditFilesData, ListAuditFilesErrors, ListAuditFilesResponses, ListClassificationsData, ListClassificationsErrors, ListClassificationsResponses, ListClassificationTemplatesData, ListClassificationTemplatesErrors, ListClassificationTemplatesResponses, ListClassificationTemplateVersionsData, ListClassificationTemplateVersionsErrors, ListClassificationTemplateVersionsResponses, ListClientTagsData, ListClientTagsErrors, ListClientTagsResponses, ListCollectionsPageData, ListCollectionsPageErrors, ListCollectionsPageResponses, ListCopyClassificationSourcesData, ListCopyClassificationSourcesErrors, ListCopyClassificationSourcesResponses, ListDepartmentAdminsData, ListDepartmentAdminsErrors, ListDepartmentAdminsResponses, ListGroupedAuditOriginGroupsData, ListGroupedAuditOriginGroupsErrors, ListGroupedAuditOriginGroupsResponses, ListLedgerAccountsData, ListLedgerAccountsErrors, ListLedgerAccountsResponses, ListLedgerCopySourcesData, ListLedgerCopySourcesErrors, ListLedgerCopySourcesResponses, ListLedgerTargetsData, ListLedgerTargetsErrors, ListLedgerTargetsResponses, ListNotificationsData, ListNotificationsErrors, ListNotificationsResponses, ListOrgReviewSessionsData, ListOrgReviewSessionsErrors, ListOrgReviewSessionsResponses, ListOrgReviewSessionUsersData, ListOrgReviewSessionUsersErrors, ListOrgReviewSessionUsersResponses, ListOrgRunsData, ListOrgRunsErrors, ListOrgRunsResponses, ListOriginsData, ListOriginsErrors, ListOriginsResponses, ListOriginTablesData, ListOriginTablesErrors, ListOriginTablesResponses, ListProjectTypesData, ListProjectTypesErrors, ListProjectTypesResponses, ListProjectVectorizedDatasourcesData, ListProjectVectorizedDatasourcesErrors, ListProjectVectorizedDatasourcesResponses, ListPromotionRequestsData, ListPromotionRequestsErrors, ListPromotionRequestsResponses, ListRunsData, ListRunsErrors, ListRunsResponses, ListSchedulesData, ListSchedulesErrors, ListSchedulesResponses, ListStatementTaxonomiesData, ListStatementTaxonomiesErrors, ListStatementTaxonomiesResponses, ListUsageSessionsData, ListUsageSessionsErrors, ListUsageSessionsResponses, ListUsageSessionUsersData, ListUsageSessionUsersErrors, ListUsageSessionUsersResponses, LivenessData, LivenessErrors, LivenessResponses, MarkAllReadData, MarkAllReadErrors, MarkAllReadResponses, MarkReadData, MarkReadErrors, MarkReadResponses, MoveResourcesToOrganizationData, MoveResourcesToOrganizationErrors, MoveResourcesToOrganizationResponses, MoveUserToOrganizationData, MoveUserToOrganizationErrors, MoveUserToOrganizationResponses, MoveWorkflowActionData, MoveWorkflowActionErrors, MoveWorkflowActionResponses, NewMessageFeedbackData, NewMessageFeedbackErrors, NewMessageFeedbackResponses, NewMessageStreamingData, NewMessageStreamingErrors, NewMessageStreamingResponse, NewMessageStreamingResponses, PatchCollectionShareData, PatchCollectionShareErrors, PatchCollectionShareResponses, PatchPromptSharesData, PatchPromptSharesErrors, PatchPromptSharesResponses, PatchSharedDashboardData, PatchSharedDashboardErrors, PatchSharedDashboardResponses, PatchSharedDatasourceData, PatchSharedDatasourceErrors, PatchSharedDatasourceResponses, PlaceWorkflowData, PlaceWorkflowErrors, PlaceWorkflowResponses, PlaceWorkflowSetData, PlaceWorkflowSetErrors, PlaceWorkflowSetResponses, PredictClassificationsData, PredictClassificationsErrors, PredictClassificationsResponses, PredictFasClassificationsData, PredictFasClassificationsErrors, PredictFasClassificationsResponses, PredictLedgerClassificationsData, PredictLedgerClassificationsErrors, PredictLedgerClassificationsResponses, PublishArticleData, PublishArticleErrors, PublishArticleResponses, PublishFaqData, PublishFaqErrors, PublishFaqResponses, PublishPromptData, PublishPromptErrors, PublishPromptResponses, PublishReleaseNoteData, PublishReleaseNoteErrors, PublishReleaseNoteResponses, PublishStatementTaxonomyData, PublishStatementTaxonomyErrors, PublishStatementTaxonomyResponses, PutOrgReviewFeedbackData, PutOrgReviewFeedbackErrors, PutOrgReviewFeedbackResponses, PutUsageReviewFeedbackData, PutUsageReviewFeedbackErrors, PutUsageReviewFeedbackResponses, QueryClassificationTemplateDataData, QueryClassificationTemplateDataErrors, QueryClassificationTemplateDataResponses, ReadDefaultStatementTaxonomyData, ReadDefaultStatementTaxonomyErrors, ReadDefaultStatementTaxonomyResponses, ReadFasClassificationsData, ReadFasClassificationsErrors, ReadFasClassificationsResponses, ReadinessData, ReadinessErrors, ReadinessResponses, ReadLedgerTemplateQueryData, ReadLedgerTemplateQueryErrors, ReadLedgerTemplateQueryResponses, ReadProjectStatementTaxonomyData, ReadProjectStatementTaxonomyErrors, ReadProjectStatementTaxonomyResponses, ReadStatementTaxonomyData, ReadStatementTaxonomyErrors, ReadStatementTaxonomyResponses, RecordTrainingCompletionsData, RecordTrainingCompletionsErrors, RecordTrainingCompletionsResponses, RecoverTwoFaData, RecoverTwoFaErrors, RecoverTwoFaResponses, RefreshClassificationsData, RefreshClassificationsErrors, RefreshClassificationsResponses, RefreshDashboardData, RefreshDashboardErrors, RefreshDashboardResponses, RefreshDashboardWidgetData, RefreshDashboardWidgetErrors, RefreshDashboardWidgetResponses, RefreshLedgerAccountsData, RefreshLedgerAccountsErrors, RefreshLedgerAccountsResponses, ReindexPdfDatasourcesData, ReindexPdfDatasourcesErrors, ReindexPdfDatasourcesResponses, RejectData, RejectErrors, RejectIndividualWorkflowData, RejectIndividualWorkflowErrors, RejectIndividualWorkflowResponses, RejectPromotionRequestData, RejectPromotionRequestErrors, RejectPromotionRequestResponses, RejectResponses, RemoveDepartmentAdminData, RemoveDepartmentAdminErrors, RemoveDepartmentAdminResponses, RemoveEmailWhitelistPatternData, RemoveEmailWhitelistPatternErrors, RemoveEmailWhitelistPatternResponses, RemoveInvitationData, RemoveInvitationErrors, RemoveInvitationResponses, RemoveProjectMemberData, RemoveProjectMemberErrors, RemoveProjectMemberResponses, RemoveUserFromOrganizationData, RemoveUserFromOrganizationErrors, RemoveUserFromOrganizationResponses, RenameClientTagData, RenameClientTagErrors, RenameClientTagResponses, ReorderWorkflowActionData, ReorderWorkflowActionErrors, ReorderWorkflowActionResponses, ReorderWorkflowData, ReorderWorkflowErrors, ReorderWorkflowResponses, ReorderWorkflowSetData, ReorderWorkflowSetErrors, ReorderWorkflowSetResponses, ReplaceAllTrialBalanceEntriesData, ReplaceAllTrialBalanceEntriesErrors, ReplaceAllTrialBalanceEntriesResponses, ReplaceAuditPreviousReportStageData, ReplaceAuditPreviousReportStageErrors, ReplaceAuditPreviousReportStageResponses, ReplaceAuditStatementExtractionCategoriesData, ReplaceAuditStatementExtractionCategoriesErrors, ReplaceAuditStatementExtractionCategoriesResponses, ReplaceAuditStatementExtractionStageData, ReplaceAuditStatementExtractionStageErrors, ReplaceAuditStatementExtractionStageResponses, ReplaceStatementExtractionStageData, ReplaceStatementExtractionStageErrors, ReplaceStatementExtractionStageResponses, RequestUploadUrlsData, RequestUploadUrlsErrors, RequestUploadUrlsResponses, RerunClientChecksData, RerunClientChecksErrors, RerunClientChecksResponses, RerunSingleCheckForClientData, RerunSingleCheckForClientErrors, RerunSingleCheckForClientResponses, RerunValidationCheckData, RerunValidationCheckErrors, RerunValidationCheckResponses, ResetIndividualWorkflowApprovalData, ResetIndividualWorkflowApprovalErrors, ResetIndividualWorkflowApprovalResponses, ResetOrganizationUserTwoFaData, ResetOrganizationUserTwoFaErrors, ResetOrganizationUserTwoFaResponses, ResetUserAiLimitData, ResetUserAiLimitErrors, ResetUserAiLimitResponses, ResetUserTwoFaData, ResetUserTwoFaErrors, ResetUserTwoFaResponses, ResponseUserToInvitationData, ResponseUserToInvitationErrors, ResponseUserToInvitationResponses, RestartAuditStatementExtractionJobData, RestartAuditStatementExtractionJobErrors, RestartAuditStatementExtractionJobResponses, RestoreProjectData, RestoreProjectErrors, RestoreProjectResponses, RestoreUserData, RestoreUserErrors, RestoreUserResponses, ResumeData, ResumeErrors, ResumeResponses, RevertPromotionRequestData, RevertPromotionRequestErrors, RevertPromotionRequestResponses, RevokeUserRoleData, RevokeUserRoleErrors, RevokeUserRoleResponses, RunContinuousAuditorRefreshPipelineData, RunContinuousAuditorRefreshPipelineErrors, RunContinuousAuditorRefreshPipelineResponses, RunDebugQueryData, RunDebugQueryErrors, RunDebugQueryResponses, RunDocumentAnalysisPipelineData, RunDocumentAnalysisPipelineErrors, RunDocumentAnalysisPipelineResponses, RunRefreshAfasDataPipelineData, RunRefreshAfasDataPipelineErrors, RunRefreshAfasDataPipelineResponses, RunRefreshAuditFilePipelineData, RunRefreshAuditFilePipelineErrors, RunRefreshAuditFilePipelineResponses, SaveAccountMappingsData, SaveAccountMappingsErrors, SaveAccountMappingsResponses, SaveAgbwProgressData, SaveAgbwProgressErrors, SaveAgbwProgressResponses, SaveClassificationsData, SaveClassificationsErrors, SaveClassificationsResponses, SaveFasClassificationsData, SaveFasClassificationsErrors, SaveFasClassificationsResponses, SaveLedgerClassificationsData, SaveLedgerClassificationsErrors, SaveLedgerClassificationsResponses, SearchProjectEntitiesData, SearchProjectEntitiesErrors, SearchProjectEntitiesResponses, SelectProjectStatementTaxonomyData, SelectProjectStatementTaxonomyErrors, SelectProjectStatementTaxonomyResponses, SendContactMessageData, SendContactMessageErrors, SendContactMessageResponses, SetAuditCheckData, SetAuditCheckErrors, SetAuditCheckResponses, SetClientTagsData, SetClientTagsErrors, SetClientTagsResponses, SetDepartmentMembersData, SetDepartmentMembersErrors, SetDepartmentMembersResponses, SetPipelineExecutionStatusData, SetPipelineExecutionStatusErrors, SetPipelineExecutionStatusResponses, SetWorkflowClientTagsData, SetWorkflowClientTagsErrors, SetWorkflowClientTagsResponses, SetWorkflowExcelTemplateData, SetWorkflowExcelTemplateErrors, SetWorkflowExcelTemplateResponses, SnapshotClassificationsData, SnapshotClassificationsErrors, SnapshotClassificationsResponses, SnapshotLedgerAccountsData, SnapshotLedgerAccountsErrors, SnapshotLedgerAccountsResponses, StartAgbwPrechecksPipelineData, StartAgbwPrechecksPipelineErrors, StartAgbwPrechecksPipelineResponses, StartAuditPreviousReportExtractionData, StartAuditPreviousReportExtractionErrors, StartAuditPreviousReportExtractionResponses, StartAuditStatementExtractionData, StartAuditStatementExtractionErrors, StartAuditStatementExtractionResponses, StartStatementExtractionData, StartStatementExtractionDeepStageData, StartStatementExtractionDeepStageErrors, StartStatementExtractionDeepStageResponses, StartStatementExtractionErrors, StartStatementExtractionResponses, SubmitForApprovalData, SubmitForApprovalErrors, SubmitForApprovalResponses, SubmitIndividualWorkflowData, SubmitIndividualWorkflowErrors, SubmitIndividualWorkflowResponses, TestOriginConnectionData, TestOriginConnectionErrors, TestOriginConnectionResponses, ToggleConfirmationData, ToggleConfirmationErrors, ToggleConfirmationResponses, ToggleHelpdeskAgentStatusData, ToggleHelpdeskAgentStatusErrors, ToggleHelpdeskAgentStatusResponses, ToggleSuperuserStatusData, ToggleSuperuserStatusErrors, ToggleSuperuserStatusResponses, ToMaintenanceData, ToMaintenanceErrors, ToMaintenanceResponses, TriggerManualRunData, TriggerManualRunErrors, TriggerManualRunResponses, UnapproveData, UnapproveErrors, UnapproveResponses, UnpublishArticleData, UnpublishArticleErrors, UnpublishArticleResponses, UnpublishFaqData, UnpublishFaqErrors, UnpublishFaqResponses, UnpublishReleaseNoteData, UnpublishReleaseNoteErrors, UnpublishReleaseNoteResponses, UnreadCountData, UnreadCountErrors, UnreadCountResponses, UnsuspendUserData, UnsuspendUserErrors, UnsuspendUserResponses, UpdateArticleData, UpdateArticleErrors, UpdateArticleResponses, UpdateArticleTemplateData, UpdateArticleTemplateErrors, UpdateArticleTemplateResponses, UpdateCollectionData, UpdateCollectionErrors, UpdateCollectionResponses, UpdateConversationData, UpdateConversationErrors, UpdateConversationResponses, UpdateCpiPreferenceData, UpdateCpiPreferenceErrors, UpdateCpiPreferenceResponses, UpdateCurrentUserData, UpdateCurrentUserErrors, UpdateCurrentUserResponses, UpdateDashboardData, UpdateDashboardErrors, UpdateDashboardResponses, UpdateDashboardWidgetNameData, UpdateDashboardWidgetNameErrors, UpdateDashboardWidgetNameResponses, UpdateDashboardWidgetPositionData, UpdateDashboardWidgetPositionErrors, UpdateDashboardWidgetPositionResponses, UpdateDashboardWidgetTypeData, UpdateDashboardWidgetTypeErrors, UpdateDashboardWidgetTypeResponses, UpdateDatasourceData, UpdateDatasourceErrors, UpdateDatasourceResponses, UpdateDepartmentData, UpdateDepartmentErrors, UpdateDepartmentResponses, UpdateDocumentAnalysisRecordData, UpdateDocumentAnalysisRecordErrors, UpdateDocumentAnalysisRecordResponses, UpdateDocumentAnalysisSettingsData, UpdateDocumentAnalysisSettingsErrors, UpdateDocumentAnalysisSettingsResponses, UpdateDocumentAnalysisTemplateData, UpdateDocumentAnalysisTemplateErrors, UpdateDocumentAnalysisTemplateResponses, UpdateFaqData, UpdateFaqErrors, UpdateFaqResponses, UpdateLedgerTemplateQueryData, UpdateLedgerTemplateQueryErrors, UpdateLedgerTemplateQueryResponses, UpdateMaterialityPreferenceData, UpdateMaterialityPreferenceErrors, UpdateMaterialityPreferenceResponses, UpdateMaterialityThresholdsData, UpdateMaterialityThresholdsErrors, UpdateMaterialityThresholdsResponses, UpdateOrganizationData, UpdateOrganizationErrors, UpdateOrganizationResponses, UpdateOrganizationUserContextData, UpdateOrganizationUserContextErrors, UpdateOrganizationUserContextResponses, UpdateOrganizationWorkosIdData, UpdateOrganizationWorkosIdErrors, UpdateOrganizationWorkosIdResponses, UpdateOriginData, UpdateOriginErrors, UpdateOriginResponses, UpdatePendingDocumentAnalysisTemplateForPromotionReviewData, UpdatePendingDocumentAnalysisTemplateForPromotionReviewErrors, UpdatePendingDocumentAnalysisTemplateForPromotionReviewResponses, UpdateProjectData, UpdateProjectErrors, UpdateProjectResponses, UpdateProjectStatusData, UpdateProjectStatusErrors, UpdateProjectStatusResponses, UpdatePromptData, UpdatePromptErrors, UpdatePromptResponses, UpdateReleaseNoteData, UpdateReleaseNoteErrors, UpdateReleaseNoteResponses, UpdateScheduleData, UpdateScheduleErrors, UpdateScheduleResponses, UpdateStatementTaxonomyData, UpdateStatementTaxonomyErrors, UpdateStatementTaxonomyResponses, UpdateTopicData, UpdateTopicErrors, UpdateTopicResponses, UpdateUserData, UpdateUserEmailData, UpdateUserEmailErrors, UpdateUserEmailResponses, UpdateUserErrors, UpdateUserInOrganizationData, UpdateUserInOrganizationErrors, UpdateUserInOrganizationResponses, UpdateUserResponses, UpdateWorkflowActionData, UpdateWorkflowActionErrors, UpdateWorkflowActionResponses, UpdateWorkflowData, UpdateWorkflowErrors, UpdateWorkflowResponses, UpdateWorkflowSetData, UpdateWorkflowSetErrors, UpdateWorkflowSetResponses, UploadAuditFilesData, UploadAuditFilesErrors, UploadAuditFilesResponses, UploadHelpCenterMediaData, UploadHelpCenterMediaErrors, UploadHelpCenterMediaResponses, UpsertProjectFileDatasourceData, UpsertProjectFileDatasourceErrors, UpsertProjectFileDatasourceResponses, UseArticleTemplateData, UseArticleTemplateErrors, UseArticleTemplateResponses, VerifyTwoFaData, VerifyTwoFaErrors, VerifyTwoFaResponses, VerifyTwoFaSigninData, VerifyTwoFaSigninErrors, VerifyTwoFaSigninResponses, VerifyUserData, VerifyUserErrors, VerifyUserResponses, WorkosAuthorizeData, WorkosAuthorizeErrors, WorkosAuthorizeResponses, WorkosCallbackData, WorkosCallbackErrors, WorkosCallbackResponses, WorkosLogoutData, WorkosLogoutErrors, WorkosLogoutResponses, WorkosRefreshData, WorkosRefreshErrors, WorkosRefreshResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Liveness
 *
 * Liveness probe. 200 means the process is running.
 *
 * Kept intentionally trivial so a downstream blip (DB, Redis) does not
 * cascade into kubelet restarting every pod. Use /readyz for dependency
 * awareness.
 */
export const liveness = <ThrowOnError extends boolean = false>(options?: Options<LivenessData, ThrowOnError>): RequestResult<LivenessResponses, LivenessErrors, ThrowOnError> => (options?.client ?? client).get<LivenessResponses, LivenessErrors, ThrowOnError>({ url: '/livez', ...options });

/**
 * Health
 *
 * Liveness probe. 200 means the process is running.
 *
 * Kept intentionally trivial so a downstream blip (DB, Redis) does not
 * cascade into kubelet restarting every pod. Use /readyz for dependency
 * awareness.
 */
export const health = <ThrowOnError extends boolean = false>(options?: Options<HealthData, ThrowOnError>): RequestResult<HealthResponses, HealthErrors, ThrowOnError> => (options?.client ?? client).get<HealthResponses, HealthErrors, ThrowOnError>({ url: '/health', ...options });

/**
 * Readiness
 *
 * Readiness probe. 200 only when Postgres responds.
 *
 * 503 here removes the pod from Service endpoints (no traffic) but does
 * not restart the container; if the dependency returns the pod rejoins.
 *
 * The probe runs on its own single-connection engine: through the shared app
 * pool, pool exhaustion 503s every pod at once and turns degradation into a
 * total outage (2026-08-10 incident). Only postgres itself being down should
 * fail readiness.
 *
 * Redis is probed for observability only and never fails readiness: it is
 * a shared dependency, so failing on it pulls every pod out of rotation at
 * once and turns a redis blip into a total outage (2026-07-21 incident).
 */
export const readiness = <ThrowOnError extends boolean = false>(options?: Options<ReadinessData, ThrowOnError>): RequestResult<ReadinessResponses, ReadinessErrors, ThrowOnError> => (options?.client ?? client).get<ReadinessResponses, ReadinessErrors, ThrowOnError>({ url: '/readyz', ...options });

/**
 * Info
 */
export const info = <ThrowOnError extends boolean = false>(options?: Options<InfoData, ThrowOnError>): RequestResult<InfoResponses, InfoErrors, ThrowOnError> => (options?.client ?? client).get<InfoResponses, InfoErrors, ThrowOnError>({ url: '/info', ...options });

/**
 * Delete Conversation
 */
export const deleteConversation = <ThrowOnError extends boolean = false>(options: Options<DeleteConversationData, ThrowOnError>): RequestResult<DeleteConversationResponses, DeleteConversationErrors, ThrowOnError> => (options.client ?? client).delete<DeleteConversationResponses, DeleteConversationErrors, ThrowOnError>({ url: '/tracker/conversation/{conversation_id}', ...options });

/**
 * Get Events
 */
export const getEvents = <ThrowOnError extends boolean = false>(options: Options<GetEventsData, ThrowOnError>): RequestResult<GetEventsResponses, GetEventsErrors, ThrowOnError> => (options.client ?? client).get<GetEventsResponses, GetEventsErrors, ThrowOnError>({ url: '/tracker/conversation/{conversation_id}', ...options });

/**
 * Update Conversation
 */
export const updateConversation = <ThrowOnError extends boolean = false>(options: Options<UpdateConversationData, ThrowOnError>): RequestResult<UpdateConversationResponses, UpdateConversationErrors, ThrowOnError> => (options.client ?? client).put<UpdateConversationResponses, UpdateConversationErrors, ThrowOnError>({
  url: '/tracker/conversation/{conversation_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Conversations
 */
export const getConversations = <ThrowOnError extends boolean = false>(options?: Options<GetConversationsData, ThrowOnError>): RequestResult<GetConversationsResponses, GetConversationsErrors, ThrowOnError> => (options?.client ?? client).get<GetConversationsResponses, GetConversationsErrors, ThrowOnError>({ url: '/tracker/conversation', ...options });

/**
 * New Message Streaming
 */
export const newMessageStreaming = <ThrowOnError extends boolean = false>(options: Options<NewMessageStreamingData, ThrowOnError, NewMessageStreamingResponse>): Promise<ServerSentEventsResult<NewMessageStreamingResponses>> => (options.client ?? client).sse.post<NewMessageStreamingResponses, NewMessageStreamingErrors, ThrowOnError>({
  url: '/tracker/message/stream',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Improve Prompt
 *
 * Rewrite the user's prompt against the context they attached.
 *
 * Nothing is executed and nothing is stored: the caller keeps the original and
 * can discard the result at any point before sending it.
 */
export const improvePrompt = <ThrowOnError extends boolean = false>(options: Options<ImprovePromptData, ThrowOnError>): RequestResult<ImprovePromptResponses, ImprovePromptErrors, ThrowOnError> => (options.client ?? client).post<ImprovePromptResponses, ImprovePromptErrors, ThrowOnError>({
  url: '/tracker/prompt/improve',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Current User Invitations
 */
export const getCurrentUserInvitations = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserInvitationsData, ThrowOnError>): RequestResult<GetCurrentUserInvitationsResponses, GetCurrentUserInvitationsErrors, ThrowOnError> => (options?.client ?? client).get<GetCurrentUserInvitationsResponses, GetCurrentUserInvitationsErrors, ThrowOnError>({ url: '/user/me/invitations', ...options });

/**
 * Get Current User
 */
export const getCurrentUser = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserData, ThrowOnError>): RequestResult<GetCurrentUserResponses, GetCurrentUserErrors, ThrowOnError> => (options?.client ?? client).get<GetCurrentUserResponses, GetCurrentUserErrors, ThrowOnError>({ url: '/user/me', ...options });

/**
 * Update Current User
 */
export const updateCurrentUser = <ThrowOnError extends boolean = false>(options: Options<UpdateCurrentUserData, ThrowOnError>): RequestResult<UpdateCurrentUserResponses, UpdateCurrentUserErrors, ThrowOnError> => (options.client ?? client).patch<UpdateCurrentUserResponses, UpdateCurrentUserErrors, ThrowOnError>({
  url: '/user/me',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Current User Permission
 */
export const getCurrentUserPermission = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserPermissionData, ThrowOnError>): RequestResult<GetCurrentUserPermissionResponses, GetCurrentUserPermissionErrors, ThrowOnError> => (options?.client ?? client).get<GetCurrentUserPermissionResponses, GetCurrentUserPermissionErrors, ThrowOnError>({ url: '/user/me/permissions', ...options });

/**
 * Get User
 */
export const getUser = <ThrowOnError extends boolean = false>(options: Options<GetUserData, ThrowOnError>): RequestResult<GetUserResponses, GetUserErrors, ThrowOnError> => (options.client ?? client).get<GetUserResponses, GetUserErrors, ThrowOnError>({ url: '/user/{id}', ...options });

/**
 * Update User
 */
export const updateUser = <ThrowOnError extends boolean = false>(options: Options<UpdateUserData, ThrowOnError>): RequestResult<UpdateUserResponses, UpdateUserErrors, ThrowOnError> => (options.client ?? client).patch<UpdateUserResponses, UpdateUserErrors, ThrowOnError>({
  url: '/user/{id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Jwt Register
 */
export const jwtRegister = <ThrowOnError extends boolean = false>(options: Options<JwtRegisterData, ThrowOnError>): RequestResult<JwtRegisterResponses, JwtRegisterErrors, ThrowOnError> => (options.client ?? client).post<JwtRegisterResponses, JwtRegisterErrors, ThrowOnError>({
  url: '/auth/register',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Jwt Request Verify Token
 */
export const jwtRequestVerifyToken = <ThrowOnError extends boolean = false>(options?: Options<JwtRequestVerifyTokenData, ThrowOnError>): RequestResult<JwtRequestVerifyTokenResponses, JwtRequestVerifyTokenErrors, ThrowOnError> => (options?.client ?? client).post<JwtRequestVerifyTokenResponses, JwtRequestVerifyTokenErrors, ThrowOnError>({ url: '/auth/request-verify-token', ...options });

/**
 * Jwt Verify
 */
export const jwtVerify = <ThrowOnError extends boolean = false>(options: Options<JwtVerifyData, ThrowOnError>): RequestResult<JwtVerifyResponses, JwtVerifyErrors, ThrowOnError> => (options.client ?? client).post<JwtVerifyResponses, JwtVerifyErrors, ThrowOnError>({
  url: '/auth/verify',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Jwt Forgot Password
 */
export const jwtForgotPassword = <ThrowOnError extends boolean = false>(options: Options<JwtForgotPasswordData, ThrowOnError>): RequestResult<JwtForgotPasswordResponses, JwtForgotPasswordErrors, ThrowOnError> => (options.client ?? client).post<JwtForgotPasswordResponses, JwtForgotPasswordErrors, ThrowOnError>({
  url: '/auth/forgot-password',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Jwt Reset Password
 */
export const jwtResetPassword = <ThrowOnError extends boolean = false>(options: Options<JwtResetPasswordData, ThrowOnError>): RequestResult<JwtResetPasswordResponses, JwtResetPasswordErrors, ThrowOnError> => (options.client ?? client).post<JwtResetPasswordResponses, JwtResetPasswordErrors, ThrowOnError>({
  url: '/auth/reset-password',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Generate Two Fa
 */
export const generateTwoFa = <ThrowOnError extends boolean = false>(options?: Options<GenerateTwoFaData, ThrowOnError>): RequestResult<GenerateTwoFaResponses, GenerateTwoFaErrors, ThrowOnError> => (options?.client ?? client).post<GenerateTwoFaResponses, GenerateTwoFaErrors, ThrowOnError>({ url: '/auth/two-fa/generate', ...options });

/**
 * Verify Two Fa
 */
export const verifyTwoFa = <ThrowOnError extends boolean = false>(options: Options<VerifyTwoFaData, ThrowOnError>): RequestResult<VerifyTwoFaResponses, VerifyTwoFaErrors, ThrowOnError> => (options.client ?? client).post<VerifyTwoFaResponses, VerifyTwoFaErrors, ThrowOnError>({
  url: '/auth/two-fa/verify',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Verify Two Fa Signin
 */
export const verifyTwoFaSignin = <ThrowOnError extends boolean = false>(options: Options<VerifyTwoFaSigninData, ThrowOnError>): RequestResult<VerifyTwoFaSigninResponses, VerifyTwoFaSigninErrors, ThrowOnError> => (options.client ?? client).post<VerifyTwoFaSigninResponses, VerifyTwoFaSigninErrors, ThrowOnError>({
  url: '/auth/two-fa/verify-signin',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Recover Two Fa
 */
export const recoverTwoFa = <ThrowOnError extends boolean = false>(options: Options<RecoverTwoFaData, ThrowOnError>): RequestResult<RecoverTwoFaResponses, RecoverTwoFaErrors, ThrowOnError> => (options.client ?? client).post<RecoverTwoFaResponses, RecoverTwoFaErrors, ThrowOnError>({
  url: '/auth/two-fa/recover',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Jwt Login
 */
export const jwtLogin = <ThrowOnError extends boolean = false>(options: Options<JwtLoginData, ThrowOnError>): RequestResult<JwtLoginResponses, JwtLoginErrors, ThrowOnError> => (options.client ?? client).post<JwtLoginResponses, JwtLoginErrors, ThrowOnError>({
  ...urlSearchParamsBodySerializer,
  url: '/auth/jwt/login',
  ...options,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    ...options.headers
  }
});

/**
 * Jwt Logout
 */
export const jwtLogout = <ThrowOnError extends boolean = false>(options?: Options<JwtLogoutData, ThrowOnError>): RequestResult<JwtLogoutResponses, JwtLogoutErrors, ThrowOnError> => (options?.client ?? client).post<JwtLogoutResponses, JwtLogoutErrors, ThrowOnError>({ url: '/auth/jwt/logout', ...options });

/**
 * Jwt Refresh
 */
export const jwtRefresh = <ThrowOnError extends boolean = false>(options?: Options<JwtRefreshData, ThrowOnError>): RequestResult<JwtRefreshResponses, JwtRefreshErrors, ThrowOnError> => (options?.client ?? client).post<JwtRefreshResponses, JwtRefreshErrors, ThrowOnError>({ url: '/auth/jwt/refresh', ...options });

/**
 * Get Current Terms
 *
 * Metadata of the currently effective user terms.
 *
 * Unauthenticated on purpose: the registration page and the blocking
 * login modal both need it before the user can proceed. Fetch the document
 * itself from `/terms/{version}/document`.
 */
export const getCurrentTerms = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentTermsData, ThrowOnError>): RequestResult<GetCurrentTermsResponses, GetCurrentTermsErrors, ThrowOnError> => (options?.client ?? client).get<GetCurrentTermsResponses, GetCurrentTermsErrors, ThrowOnError>({ url: '/terms/current', ...options });

/**
 * Get Terms Document
 *
 * Serve a terms version as the PDF legal signed off on.
 *
 * Unauthenticated for the same reason as `/current`, and served inline so
 * the acceptance modal can embed it rather than downloading it. Any
 * published version is readable, so a user can re-read what they accepted.
 */
export const getTermsDocument = <ThrowOnError extends boolean = false>(options: Options<GetTermsDocumentData, ThrowOnError>): RequestResult<GetTermsDocumentResponses, GetTermsDocumentErrors, ThrowOnError> => (options.client ?? client).get<GetTermsDocumentResponses, GetTermsDocumentErrors, ThrowOnError>({ url: '/terms/{version}/document', ...options });

/**
 * Accept Terms
 *
 * Record the current user's acceptance of a terms version.
 *
 * Idempotent per version (a repeat returns the original acceptance), and
 * rejects versions older than the currently effective one so a stale modal
 * cannot accept outdated terms.
 */
export const acceptTerms = <ThrowOnError extends boolean = false>(options: Options<AcceptTermsData, ThrowOnError>): RequestResult<AcceptTermsResponses, AcceptTermsErrors, ThrowOnError> => (options.client ?? client).post<AcceptTermsResponses, AcceptTermsErrors, ThrowOnError>({ url: '/terms/{version}/acceptances', ...options });

/**
 * Get All Organizations
 */
export const getAllOrganizations = <ThrowOnError extends boolean = false>(options?: Options<GetAllOrganizationsData, ThrowOnError>): RequestResult<GetAllOrganizationsResponses, GetAllOrganizationsErrors, ThrowOnError> => (options?.client ?? client).get<GetAllOrganizationsResponses, GetAllOrganizationsErrors, ThrowOnError>({ url: '/superuser/organizations', ...options });

/**
 * Delete Organization
 *
 * Delete an organization (superuser only).
 */
export const deleteOrganization = <ThrowOnError extends boolean = false>(options: Options<DeleteOrganizationData, ThrowOnError>): RequestResult<DeleteOrganizationResponses, DeleteOrganizationErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOrganizationResponses, DeleteOrganizationErrors, ThrowOnError>({ url: '/superuser/organization/{org_id}/delete', ...options });

/**
 * Update Organization Workos Id
 *
 * Set or clear the WorkOS organization ID for SSO auto-linking (superuser only).
 */
export const updateOrganizationWorkosId = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationWorkosIdData, ThrowOnError>): RequestResult<UpdateOrganizationWorkosIdResponses, UpdateOrganizationWorkosIdErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationWorkosIdResponses, UpdateOrganizationWorkosIdErrors, ThrowOnError>({
  url: '/superuser/organization/{org_id}/workos',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get All Users
 *
 * Get all users + pending invitations across the system (superuser only).
 */
export const getAllUsers = <ThrowOnError extends boolean = false>(options?: Options<GetAllUsersData, ThrowOnError>): RequestResult<GetAllUsersResponses, GetAllUsersErrors, ThrowOnError> => (options?.client ?? client).get<GetAllUsersResponses, GetAllUsersErrors, ThrowOnError>({ url: '/superuser/user', ...options });

/**
 * Toggle Superuser Status
 *
 * Toggle the is_superuser flag on `user_id`.
 */
export const toggleSuperuserStatus = <ThrowOnError extends boolean = false>(options: Options<ToggleSuperuserStatusData, ThrowOnError>): RequestResult<ToggleSuperuserStatusResponses, ToggleSuperuserStatusErrors, ThrowOnError> => (options.client ?? client).patch<ToggleSuperuserStatusResponses, ToggleSuperuserStatusErrors, ThrowOnError>({ url: '/superuser/user/{user_id}/superuser', ...options });

/**
 * Toggle Helpdesk Agent Status
 *
 * Toggle help-center authorship on `user_id`.
 *
 * Superuser-only by design: the content it governs is global, so this is not
 * delegated to org admins the way org-scoped roles are.
 */
export const toggleHelpdeskAgentStatus = <ThrowOnError extends boolean = false>(options: Options<ToggleHelpdeskAgentStatusData, ThrowOnError>): RequestResult<ToggleHelpdeskAgentStatusResponses, ToggleHelpdeskAgentStatusErrors, ThrowOnError> => (options.client ?? client).patch<ToggleHelpdeskAgentStatusResponses, ToggleHelpdeskAgentStatusErrors, ThrowOnError>({ url: '/superuser/user/{user_id}/helpdesk-agent', ...options });

/**
 * Verify User
 *
 * Toggle the is_verified flag on `user_id`.
 */
export const verifyUser = <ThrowOnError extends boolean = false>(options: Options<VerifyUserData, ThrowOnError>): RequestResult<VerifyUserResponses, VerifyUserErrors, ThrowOnError> => (options.client ?? client).patch<VerifyUserResponses, VerifyUserErrors, ThrowOnError>({ url: '/superuser/user/{user_id}/verify', ...options });

/**
 * Update User Email
 *
 * Move a user's account to a different email address (superuser only).
 *
 * Refused for SSO-linked accounts: WorkOS is the source of truth for those,
 * and `_upsert_user` overwrites `User.email` from the profile on the next
 * login, so a local change would silently revert. Change it in WorkOS instead.
 *
 * The account is marked unverified, pending invitations follow the address,
 * and existing sessions are revoked; an email change is an identity change.
 */
export const updateUserEmail = <ThrowOnError extends boolean = false>(options: Options<UpdateUserEmailData, ThrowOnError>): RequestResult<UpdateUserEmailResponses, UpdateUserEmailErrors, ThrowOnError> => (options.client ?? client).patch<UpdateUserEmailResponses, UpdateUserEmailErrors, ThrowOnError>({
  url: '/superuser/user/{user_id}/email',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Reset User Ai Limit
 */
export const resetUserAiLimit = <ThrowOnError extends boolean = false>(options: Options<ResetUserAiLimitData, ThrowOnError>): RequestResult<ResetUserAiLimitResponses, ResetUserAiLimitErrors, ThrowOnError> => (options.client ?? client).post<ResetUserAiLimitResponses, ResetUserAiLimitErrors, ThrowOnError>({ url: '/superuser/user/{user_id}/ai-limit/reset', ...options });

/**
 * Reset User Two Fa
 *
 * Reset a user's 2FA enrollment and invalidate their active sessions.
 */
export const resetUserTwoFa = <ThrowOnError extends boolean = false>(options: Options<ResetUserTwoFaData, ThrowOnError>): RequestResult<ResetUserTwoFaResponses, ResetUserTwoFaErrors, ThrowOnError> => (options.client ?? client).post<ResetUserTwoFaResponses, ResetUserTwoFaErrors, ThrowOnError>({ url: '/superuser/user/{user_id}/two-fa/reset', ...options });

/**
 * Delete User
 *
 * Soft-delete a user and hard-delete their sessions / invitations / RBAC grants.
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>): RequestResult<DeleteUserResponses, DeleteUserErrors, ThrowOnError> => (options.client ?? client).delete<DeleteUserResponses, DeleteUserErrors, ThrowOnError>({ url: '/superuser/user/{user_id}', ...options });

/**
 * Restore User
 *
 * Restore a soft-deleted user; optionally re-invite them to `organization_id`.
 */
export const restoreUser = <ThrowOnError extends boolean = false>(options: Options<RestoreUserData, ThrowOnError>): RequestResult<RestoreUserResponses, RestoreUserErrors, ThrowOnError> => (options.client ?? client).post<RestoreUserResponses, RestoreUserErrors, ThrowOnError>({ url: '/superuser/user/{user_id}/restore', ...options });

/**
 * Unsuspend User
 *
 * Lift a security suspension after manual review (superuser only).
 */
export const unsuspendUser = <ThrowOnError extends boolean = false>(options: Options<UnsuspendUserData, ThrowOnError>): RequestResult<UnsuspendUserResponses, UnsuspendUserErrors, ThrowOnError> => (options.client ?? client).post<UnsuspendUserResponses, UnsuspendUserErrors, ThrowOnError>({ url: '/superuser/user/{user_id}/unsuspend', ...options });

/**
 * Move User To Organization
 *
 * Move a user into another organization (superuser only).
 *
 * Drops the user's membership, roles and per-resource grants in their current
 * organization and re-creates membership in `organization_id` with `roles`
 * (defaulting to `org_member`). Personal prompts, workflow sets and document
 * analysis templates move with them. The transfer is rejected while the user
 * owns department- or organization-placed prompts in the source organization.
 */
export const moveUserToOrganization = <ThrowOnError extends boolean = false>(options: Options<MoveUserToOrganizationData, ThrowOnError>): RequestResult<MoveUserToOrganizationResponses, MoveUserToOrganizationErrors, ThrowOnError> => (options.client ?? client).post<MoveUserToOrganizationResponses, MoveUserToOrganizationErrors, ThrowOnError>({ url: '/superuser/user/{user_id}/organization', ...options });

/**
 * Move Resources To Organization
 *
 * Move a batch of resources into another organization (superuser only).
 *
 * Datasources, collections, document analysis templates, workflow sets and
 * dashboards move together as one batch. Links *between* resources in the
 * batch survive; every link out of a moved resource into something left
 * behind is cut, because nothing else in the schema stops a moved resource
 * from reading the previous tenant's data.
 *
 * Workflow sets bring nested sets with them and templates bring their whole
 * version chain, so the returned id lists can be longer than the request.
 */
export const moveResourcesToOrganization = <ThrowOnError extends boolean = false>(options: Options<MoveResourcesToOrganizationData, ThrowOnError>): RequestResult<MoveResourcesToOrganizationResponses, MoveResourcesToOrganizationErrors, ThrowOnError> => (options.client ?? client).post<MoveResourcesToOrganizationResponses, MoveResourcesToOrganizationErrors, ThrowOnError>({
  url: '/superuser/resources/organization',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Revoke User Role
 *
 * Revoke a role from `user_id` in `organization_id` (superuser only).
 *
 * Pass `resource_type` + `resource_id` to revoke a scoped assignment;
 * omit both to revoke an org-wide one. `super_admin` is not a role
 * here, it's a flag on `User` toggled via `PATCH /user/{id}/superuser`.
 */
export const revokeUserRole = <ThrowOnError extends boolean = false>(options: Options<RevokeUserRoleData, ThrowOnError>): RequestResult<RevokeUserRoleResponses, RevokeUserRoleErrors, ThrowOnError> => (options.client ?? client).delete<RevokeUserRoleResponses, RevokeUserRoleErrors, ThrowOnError>({ url: '/superuser/user/{user_id}/roles', ...options });

/**
 * Get Roles
 *
 * List direct role assignments for a user in an organization.
 */
export const getRoles = <ThrowOnError extends boolean = false>(options: Options<GetRolesData, ThrowOnError>): RequestResult<GetRolesResponses, GetRolesErrors, ThrowOnError> => (options.client ?? client).get<GetRolesResponses, GetRolesErrors, ThrowOnError>({ url: '/superuser/user/{user_id}/roles', ...options });

/**
 * Assign User Role
 *
 * Assign a role to `user_id` in `organization_id` (superuser only).
 *
 * Pass `resource_type` + `resource_id` for scoped-only roles
 * (e.g. `project_admin` scoped to `project_type.<audit type uuid>`).
 * Org-wide roles must omit both. `super_admin` is intentionally not a
 * role in this endpoint; it maps to `User.is_superuser` which is
 * toggled via `PATCH /user/{id}/superuser`.
 */
export const assignUserRole = <ThrowOnError extends boolean = false>(options: Options<AssignUserRoleData, ThrowOnError>): RequestResult<AssignUserRoleResponses, AssignUserRoleErrors, ThrowOnError> => (options.client ?? client).post<AssignUserRoleResponses, AssignUserRoleErrors, ThrowOnError>({ url: '/superuser/user/{user_id}/roles', ...options });

/**
 * Get Permissions
 */
export const getPermissions = <ThrowOnError extends boolean = false>(options: Options<GetPermissionsData, ThrowOnError>): RequestResult<GetPermissionsResponses, GetPermissionsErrors, ThrowOnError> => (options.client ?? client).get<GetPermissionsResponses, GetPermissionsErrors, ThrowOnError>({ url: '/superuser/{user_id}/permissions', ...options });

/**
 * Reindex Pdf Datasources
 *
 * Delete and re-index all PDF datasources (superuser only).
 *
 * Drops existing embeddings and queues a fresh vectorization job for every
 * active datasource with data_type == "vectorized". Optionally scoped to a
 * single organization via the organization_id query param.
 *
 * Soft-deleted datasources (deleted_at IS NOT NULL) are excluded by default;
 * pass include_deleted=true to reindex them too.
 *
 * Datasources whose processing job is still queued or running are skipped;
 * when that leaves nothing to queue the request fails with 409. A `pending`
 * row without a live job (e.g. its worker was killed) is reclaimed.
 */
export const reindexPdfDatasources = <ThrowOnError extends boolean = false>(options?: Options<ReindexPdfDatasourcesData, ThrowOnError>): RequestResult<ReindexPdfDatasourcesResponses, ReindexPdfDatasourcesErrors, ThrowOnError> => (options?.client ?? client).post<ReindexPdfDatasourcesResponses, ReindexPdfDatasourcesErrors, ThrowOnError>({ url: '/superuser/datasources/reindex', ...options });

/**
 * Get Terms Acceptance Status
 *
 * Terms acceptance state of every non-deleted user (superuser only).
 */
export const getTermsAcceptanceStatus = <ThrowOnError extends boolean = false>(options?: Options<GetTermsAcceptanceStatusData, ThrowOnError>): RequestResult<GetTermsAcceptanceStatusResponses, GetTermsAcceptanceStatusErrors, ThrowOnError> => (options?.client ?? client).get<GetTermsAcceptanceStatusResponses, GetTermsAcceptanceStatusErrors, ThrowOnError>({ url: '/superuser/terms-acceptance', ...options });

/**
 * Get Email Whitelist Patterns
 *
 * List all whitelisted email patterns (superuser only).
 */
export const getEmailWhitelistPatterns = <ThrowOnError extends boolean = false>(options?: Options<GetEmailWhitelistPatternsData, ThrowOnError>): RequestResult<GetEmailWhitelistPatternsResponses, GetEmailWhitelistPatternsErrors, ThrowOnError> => (options?.client ?? client).get<GetEmailWhitelistPatternsResponses, GetEmailWhitelistPatternsErrors, ThrowOnError>({ url: '/superuser/email-whitelist', ...options });

/**
 * Add Email Whitelist Pattern
 *
 * Add an email pattern to the whitelist (superuser only).
 */
export const addEmailWhitelistPattern = <ThrowOnError extends boolean = false>(options: Options<AddEmailWhitelistPatternData, ThrowOnError>): RequestResult<AddEmailWhitelistPatternResponses, AddEmailWhitelistPatternErrors, ThrowOnError> => (options.client ?? client).post<AddEmailWhitelistPatternResponses, AddEmailWhitelistPatternErrors, ThrowOnError>({
  url: '/superuser/email-whitelist',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Remove Email Whitelist Pattern
 *
 * Remove an email pattern from the whitelist (superuser only).
 */
export const removeEmailWhitelistPattern = <ThrowOnError extends boolean = false>(options: Options<RemoveEmailWhitelistPatternData, ThrowOnError>): RequestResult<RemoveEmailWhitelistPatternResponses, RemoveEmailWhitelistPatternErrors, ThrowOnError> => (options.client ?? client).delete<RemoveEmailWhitelistPatternResponses, RemoveEmailWhitelistPatternErrors, ThrowOnError>({ url: '/superuser/email-whitelist/{pattern}', ...options });

/**
 * List Usage Sessions
 *
 * List conversations with turn counts, duration, and cost when tracing supplies it.
 *
 * ``org_id`` keeps only sessions of that organization's users.
 */
export const listUsageSessions = <ThrowOnError extends boolean = false>(options?: Options<ListUsageSessionsData, ThrowOnError>): RequestResult<ListUsageSessionsResponses, ListUsageSessionsErrors, ThrowOnError> => (options?.client ?? client).get<ListUsageSessionsResponses, ListUsageSessionsErrors, ThrowOnError>({ url: '/usage/sessions', ...options });

/**
 * List Usage Session Users
 *
 * Users with at least one conversation, optionally only those of one organization.
 */
export const listUsageSessionUsers = <ThrowOnError extends boolean = false>(options?: Options<ListUsageSessionUsersData, ThrowOnError>): RequestResult<ListUsageSessionUsersResponses, ListUsageSessionUsersErrors, ThrowOnError> => (options?.client ?? client).get<ListUsageSessionUsersResponses, ListUsageSessionUsersErrors, ThrowOnError>({ url: '/usage/session-users', ...options });

/**
 * Get Usage Session Detail
 *
 * Conversation drilldown: header context and transcript with per-turn chips.
 */
export const getUsageSessionDetail = <ThrowOnError extends boolean = false>(options: Options<GetUsageSessionDetailData, ThrowOnError>): RequestResult<GetUsageSessionDetailResponses, GetUsageSessionDetailErrors, ThrowOnError> => (options.client ?? client).get<GetUsageSessionDetailResponses, GetUsageSessionDetailErrors, ThrowOnError>({ url: '/usage/sessions/{session_id}', ...options });

/**
 * Get Usage Turn Inspector
 *
 * Inspector for one chat turn: tool calls, data, context, and agents when traced.
 */
export const getUsageTurnInspector = <ThrowOnError extends boolean = false>(options: Options<GetUsageTurnInspectorData, ThrowOnError>): RequestResult<GetUsageTurnInspectorResponses, GetUsageTurnInspectorErrors, ThrowOnError> => (options.client ?? client).get<GetUsageTurnInspectorResponses, GetUsageTurnInspectorErrors, ThrowOnError>({ url: '/usage/sessions/{session_id}/turns/{turn_id}', ...options });

/**
 * Get Usage Tool Output
 *
 * Full, untruncated payload of one tool call for lazy modal loading.
 */
export const getUsageToolOutput = <ThrowOnError extends boolean = false>(options: Options<GetUsageToolOutputData, ThrowOnError>): RequestResult<GetUsageToolOutputResponses, GetUsageToolOutputErrors, ThrowOnError> => (options.client ?? client).get<GetUsageToolOutputResponses, GetUsageToolOutputErrors, ThrowOnError>({ url: '/usage/sessions/{session_id}/turns/{turn_id}/tool-calls/{tool_call_id}', ...options });

/**
 * Put Usage Review Feedback
 *
 * The superuser's own rating of an assistant turn; the owner's rating is untouched.
 */
export const putUsageReviewFeedback = <ThrowOnError extends boolean = false>(options: Options<PutUsageReviewFeedbackData, ThrowOnError>): RequestResult<PutUsageReviewFeedbackResponses, PutUsageReviewFeedbackErrors, ThrowOnError> => (options.client ?? client).put<PutUsageReviewFeedbackResponses, PutUsageReviewFeedbackErrors, ThrowOnError>({
  url: '/usage/sessions/{session_id}/turns/{turn_id}/feedback',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * List Org Review Sessions
 *
 * Conversations of the organization's users, with cost when tracing supplies it.
 *
 * When ``department_id`` is set, only sessions of that department's members are returned.
 */
export const listOrgReviewSessions = <ThrowOnError extends boolean = false>(options: Options<ListOrgReviewSessionsData, ThrowOnError>): RequestResult<ListOrgReviewSessionsResponses, ListOrgReviewSessionsErrors, ThrowOnError> => (options.client ?? client).get<ListOrgReviewSessionsResponses, ListOrgReviewSessionsErrors, ThrowOnError>({ url: '/organization/{org_id}/review/sessions', ...options });

/**
 * List Org Review Session Users
 *
 * The organization's users with at least one conversation, optionally of one department only.
 */
export const listOrgReviewSessionUsers = <ThrowOnError extends boolean = false>(options: Options<ListOrgReviewSessionUsersData, ThrowOnError>): RequestResult<ListOrgReviewSessionUsersResponses, ListOrgReviewSessionUsersErrors, ThrowOnError> => (options.client ?? client).get<ListOrgReviewSessionUsersResponses, ListOrgReviewSessionUsersErrors, ThrowOnError>({ url: '/organization/{org_id}/review/session-users', ...options });

/**
 * Get Org Review Session Detail
 *
 * Conversation drilldown, only for sessions owned by the organization's users.
 */
export const getOrgReviewSessionDetail = <ThrowOnError extends boolean = false>(options: Options<GetOrgReviewSessionDetailData, ThrowOnError>): RequestResult<GetOrgReviewSessionDetailResponses, GetOrgReviewSessionDetailErrors, ThrowOnError> => (options.client ?? client).get<GetOrgReviewSessionDetailResponses, GetOrgReviewSessionDetailErrors, ThrowOnError>({ url: '/organization/{org_id}/review/sessions/{session_id}', ...options });

/**
 * Get Org Review Turn Inspector
 *
 * Inspector for a turn of an org-owned session.
 */
export const getOrgReviewTurnInspector = <ThrowOnError extends boolean = false>(options: Options<GetOrgReviewTurnInspectorData, ThrowOnError>): RequestResult<GetOrgReviewTurnInspectorResponses, GetOrgReviewTurnInspectorErrors, ThrowOnError> => (options.client ?? client).get<GetOrgReviewTurnInspectorResponses, GetOrgReviewTurnInspectorErrors, ThrowOnError>({ url: '/organization/{org_id}/review/sessions/{session_id}/turns/{turn_id}', ...options });

/**
 * Get Org Review Tool Output
 *
 * Full tool payload for a turn of an org-owned session.
 */
export const getOrgReviewToolOutput = <ThrowOnError extends boolean = false>(options: Options<GetOrgReviewToolOutputData, ThrowOnError>): RequestResult<GetOrgReviewToolOutputResponses, GetOrgReviewToolOutputErrors, ThrowOnError> => (options.client ?? client).get<GetOrgReviewToolOutputResponses, GetOrgReviewToolOutputErrors, ThrowOnError>({ url: '/organization/{org_id}/review/sessions/{session_id}/turns/{turn_id}/tool-calls/{tool_call_id}', ...options });

/**
 * Put Org Review Feedback
 *
 * The reviewer's own rating of an assistant turn in an org-owned session; the owner's rating is untouched.
 */
export const putOrgReviewFeedback = <ThrowOnError extends boolean = false>(options: Options<PutOrgReviewFeedbackData, ThrowOnError>): RequestResult<PutOrgReviewFeedbackResponses, PutOrgReviewFeedbackErrors, ThrowOnError> => (options.client ?? client).put<PutOrgReviewFeedbackResponses, PutOrgReviewFeedbackErrors, ThrowOnError>({
  url: '/organization/{org_id}/review/sessions/{session_id}/turns/{turn_id}/feedback',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Organization
 *
 * Get organization by ID.
 */
export const getOrganization = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationData, ThrowOnError>): RequestResult<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError>({ url: '/organization/{org_id}', ...options });

/**
 * Update Organization
 *
 * Update organization details.
 *
 * Only fields present in the request body are touched, so an explicit `null`
 * clears `email`, `context` or `image_url` rather than being read as "omitted".
 */
export const updateOrganization = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationData, ThrowOnError>): RequestResult<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError> => (options.client ?? client).put<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError>({
  url: '/organization/{org_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Remove User From Organization
 *
 * Remove a user from an organization.
 */
export const removeUserFromOrganization = <ThrowOnError extends boolean = false>(options: Options<RemoveUserFromOrganizationData, ThrowOnError>): RequestResult<RemoveUserFromOrganizationResponses, RemoveUserFromOrganizationErrors, ThrowOnError> => (options.client ?? client).delete<RemoveUserFromOrganizationResponses, RemoveUserFromOrganizationErrors, ThrowOnError>({ url: '/organization/{org_id}/user', ...options });

/**
 * Get Organization Users
 *
 * Get all members and pending invitations for an organization.
 */
export const getOrganizationUsers = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationUsersData, ThrowOnError>): RequestResult<GetOrganizationUsersResponses, GetOrganizationUsersErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationUsersResponses, GetOrganizationUsersErrors, ThrowOnError>({ url: '/organization/{org_id}/user', ...options });

/**
 * Get Organization User Profiles
 *
 * Return simplified profiles for every member of the organization.
 *
 * Used by the UI for sharing datasources, transferring ownership, and
 * assigning members to projects. Under the scoped role model any active
 * org member can be assigned to a project (their scoped role is set at
 * assignment time), so there's no longer an audit-roles-only filter.
 */
export const getOrganizationUserProfiles = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationUserProfilesData, ThrowOnError>): RequestResult<GetOrganizationUserProfilesResponses, GetOrganizationUserProfilesErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationUserProfilesResponses, GetOrganizationUserProfilesErrors, ThrowOnError>({ url: '/organization/{org_id}/user-profiles', ...options });

/**
 * Get Organization Invitations
 *
 * Get all members and pending invitations for an organization.
 */
export const getOrganizationInvitations = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationInvitationsData, ThrowOnError>): RequestResult<GetOrganizationInvitationsResponses, GetOrganizationInvitationsErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationInvitationsResponses, GetOrganizationInvitationsErrors, ThrowOnError>({ url: '/organization/{org_id}/invitations', ...options });

/**
 * Get Organization User Permissions
 *
 * Get user permissions within an organization.
 */
export const getOrganizationUserPermissions = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationUserPermissionsData, ThrowOnError>): RequestResult<GetOrganizationUserPermissionsResponses, GetOrganizationUserPermissionsErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationUserPermissionsResponses, GetOrganizationUserPermissionsErrors, ThrowOnError>({ url: '/organization/{org_id}/user/{user_id}', ...options });

/**
 * Update User In Organization
 *
 * Update user information and roles in an organization.
 */
export const updateUserInOrganization = <ThrowOnError extends boolean = false>(options: Options<UpdateUserInOrganizationData, ThrowOnError>): RequestResult<UpdateUserInOrganizationResponses, UpdateUserInOrganizationErrors, ThrowOnError> => (options.client ?? client).put<UpdateUserInOrganizationResponses, UpdateUserInOrganizationErrors, ThrowOnError>({
  url: '/organization/{org_id}/user/{user_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Organization User Profile
 *
 * Return a member profile and reveal context only to its owner.
 */
export const getOrganizationUserProfile = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationUserProfileData, ThrowOnError>): RequestResult<GetOrganizationUserProfileResponses, GetOrganizationUserProfileErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationUserProfileResponses, GetOrganizationUserProfileErrors, ThrowOnError>({ url: '/organization/{org_id}/user/{user_id}/profile', ...options });

/**
 * Update Organization User Context
 *
 * Update a member's private context when the member is the caller.
 */
export const updateOrganizationUserContext = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationUserContextData, ThrowOnError>): RequestResult<UpdateOrganizationUserContextResponses, UpdateOrganizationUserContextErrors, ThrowOnError> => (options.client ?? client).put<UpdateOrganizationUserContextResponses, UpdateOrganizationUserContextErrors, ThrowOnError>({
  url: '/organization/{org_id}/user/{user_id}/context',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Reset Organization User Two Fa
 *
 * Reset a member's 2FA enrollment and invalidate their active sessions.
 */
export const resetOrganizationUserTwoFa = <ThrowOnError extends boolean = false>(options: Options<ResetOrganizationUserTwoFaData, ThrowOnError>): RequestResult<ResetOrganizationUserTwoFaResponses, ResetOrganizationUserTwoFaErrors, ThrowOnError> => (options.client ?? client).post<ResetOrganizationUserTwoFaResponses, ResetOrganizationUserTwoFaErrors, ThrowOnError>({ url: '/organization/{org_id}/user/{user_id}/two-fa/reset', ...options });

/**
 * Get Organization Departments
 *
 * Get the departments in an organization the caller may read.
 *
 * The permission check above is type-level, which a department-scoped role
 * satisfies for the type as a whole, so the caller's reach is narrowed here
 * rather than in the gate. Org-wide holders get `"*"` and see everything.
 */
export const getOrganizationDepartments = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationDepartmentsData, ThrowOnError>): RequestResult<GetOrganizationDepartmentsResponses, GetOrganizationDepartmentsErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationDepartmentsResponses, GetOrganizationDepartmentsErrors, ThrowOnError>({ url: '/organization/{org_id}/department', ...options });

/**
 * Create Department
 *
 * Create a new department in an organization.
 */
export const createDepartment = <ThrowOnError extends boolean = false>(options: Options<CreateDepartmentData, ThrowOnError>): RequestResult<CreateDepartmentResponses, CreateDepartmentErrors, ThrowOnError> => (options.client ?? client).post<CreateDepartmentResponses, CreateDepartmentErrors, ThrowOnError>({
  url: '/organization/{org_id}/department',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Update Department
 *
 * Update a department.
 */
export const updateDepartment = <ThrowOnError extends boolean = false>(options: Options<UpdateDepartmentData, ThrowOnError>): RequestResult<UpdateDepartmentResponses, UpdateDepartmentErrors, ThrowOnError> => (options.client ?? client).put<UpdateDepartmentResponses, UpdateDepartmentErrors, ThrowOnError>({
  url: '/organization/{org_id}/department/{department_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Set Department Members
 *
 * Replace the department's roster with the given organization members.
 *
 * The body is the department's full intended membership: anyone currently in
 * the department but not listed is removed from it, so an empty list empties
 * the department.
 */
export const setDepartmentMembers = <ThrowOnError extends boolean = false>(options: Options<SetDepartmentMembersData, ThrowOnError>): RequestResult<SetDepartmentMembersResponses, SetDepartmentMembersErrors, ThrowOnError> => (options.client ?? client).put<SetDepartmentMembersResponses, SetDepartmentMembersErrors, ThrowOnError>({
  url: '/organization/{org_id}/department/{department_id}/members',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * List Department Admins
 *
 * List the users administering one department.
 *
 * A delegated grant has to be discoverable to be revocable; without this the
 * only way to revoke is to already know who holds it.
 */
export const listDepartmentAdmins = <ThrowOnError extends boolean = false>(options: Options<ListDepartmentAdminsData, ThrowOnError>): RequestResult<ListDepartmentAdminsResponses, ListDepartmentAdminsErrors, ThrowOnError> => (options.client ?? client).get<ListDepartmentAdminsResponses, ListDepartmentAdminsErrors, ThrowOnError>({ url: '/organization/{org_id}/department/{department_id}/admin', ...options });

/**
 * Remove Department Admin
 *
 * Revoke `user_id`'s administration of one department.
 */
export const removeDepartmentAdmin = <ThrowOnError extends boolean = false>(options: Options<RemoveDepartmentAdminData, ThrowOnError>): RequestResult<RemoveDepartmentAdminResponses, RemoveDepartmentAdminErrors, ThrowOnError> => (options.client ?? client).delete<RemoveDepartmentAdminResponses, RemoveDepartmentAdminErrors, ThrowOnError>({ url: '/organization/{org_id}/department/{department_id}/admin/{user_id}', ...options });

/**
 * Add Department Admin
 *
 * Appoint `user_id` as an administrator of one department.
 *
 * Gated on `assign_role` for the specific department, which org_admin and
 * org_owner hold and `department_admin` deliberately does not, so the role
 * cannot appoint more of itself.
 */
export const addDepartmentAdmin = <ThrowOnError extends boolean = false>(options: Options<AddDepartmentAdminData, ThrowOnError>): RequestResult<AddDepartmentAdminResponses, AddDepartmentAdminErrors, ThrowOnError> => (options.client ?? client).post<AddDepartmentAdminResponses, AddDepartmentAdminErrors, ThrowOnError>({ url: '/organization/{org_id}/department/{department_id}/admin/{user_id}', ...options });

/**
 * Invite User To Organization By Email
 *
 * Invite a user to join an organization.
 */
export const inviteUserToOrganizationByEmail = <ThrowOnError extends boolean = false>(options: Options<InviteUserToOrganizationByEmailData, ThrowOnError>): RequestResult<InviteUserToOrganizationByEmailResponses, InviteUserToOrganizationByEmailErrors, ThrowOnError> => (options.client ?? client).put<InviteUserToOrganizationByEmailResponses, InviteUserToOrganizationByEmailErrors, ThrowOnError>({
  url: '/organization/{org_id}/invitation/{user_email}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Remove Invitation
 *
 * Delete an invitation.
 */
export const removeInvitation = <ThrowOnError extends boolean = false>(options: Options<RemoveInvitationData, ThrowOnError>): RequestResult<RemoveInvitationResponses, RemoveInvitationErrors, ThrowOnError> => (options.client ?? client).delete<RemoveInvitationResponses, RemoveInvitationErrors, ThrowOnError>({ url: '/organization/{org_id}/invitation/{invitation_id}', ...options });

/**
 * Response User To Invitation
 *
 * Accept or decline an invitation.
 */
export const responseUserToInvitation = <ThrowOnError extends boolean = false>(options: Options<ResponseUserToInvitationData, ThrowOnError>): RequestResult<ResponseUserToInvitationResponses, ResponseUserToInvitationErrors, ThrowOnError> => (options.client ?? client).post<ResponseUserToInvitationResponses, ResponseUserToInvitationErrors, ThrowOnError>({ url: '/organization/{org_id}/invitation/{invitation_id}/{decision}', ...options });

/**
 * Create Organization
 *
 * Create a new organization.
 */
export const createOrganization = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationData, ThrowOnError>): RequestResult<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError> => (options.client ?? client).post<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError>({
  url: '/organization',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Training Overview
 *
 * Who completed the training, their department, and the service lines they are active in.
 */
export const getTrainingOverview = <ThrowOnError extends boolean = false>(options: Options<GetTrainingOverviewData, ThrowOnError>): RequestResult<GetTrainingOverviewResponses, GetTrainingOverviewErrors, ThrowOnError> => (options.client ?? client).get<GetTrainingOverviewResponses, GetTrainingOverviewErrors, ThrowOnError>({ url: '/organization/{org_id}/training/overview', ...options });

/**
 * Record Training Completions
 *
 * Record that the listed users completed the training on one day.
 */
export const recordTrainingCompletions = <ThrowOnError extends boolean = false>(options: Options<RecordTrainingCompletionsData, ThrowOnError>): RequestResult<RecordTrainingCompletionsResponses, RecordTrainingCompletionsErrors, ThrowOnError> => (options.client ?? client).post<RecordTrainingCompletionsResponses, RecordTrainingCompletionsErrors, ThrowOnError>({
  url: '/organization/{org_id}/training/completions',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Training Completion
 *
 * Remove a completion that was recorded by mistake.
 */
export const deleteTrainingCompletion = <ThrowOnError extends boolean = false>(options: Options<DeleteTrainingCompletionData, ThrowOnError>): RequestResult<DeleteTrainingCompletionResponses, DeleteTrainingCompletionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTrainingCompletionResponses, DeleteTrainingCompletionErrors, ThrowOnError>({ url: '/organization/{org_id}/training/completions/{completion_id}', ...options });

/**
 * Get Projects
 */
export const getProjects = <ThrowOnError extends boolean = false>(options: Options<GetProjectsData, ThrowOnError>): RequestResult<GetProjectsResponses, GetProjectsErrors, ThrowOnError> => (options.client ?? client).get<GetProjectsResponses, GetProjectsErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client', ...options });

/**
 * Create Project
 */
export const createProject = <ThrowOnError extends boolean = false>(options: Options<CreateProjectData, ThrowOnError>): RequestResult<CreateProjectResponses, CreateProjectErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectResponses, CreateProjectErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/client',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Search Project Entities
 */
export const searchProjectEntities = <ThrowOnError extends boolean = false>(options: Options<SearchProjectEntitiesData, ThrowOnError>): RequestResult<SearchProjectEntitiesResponses, SearchProjectEntitiesErrors, ThrowOnError> => (options.client ?? client).get<SearchProjectEntitiesResponses, SearchProjectEntitiesErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/entity-search', ...options });

/**
 * Get Project Parameters
 *
 * deprecated: answers the organization-wide discovery; kept only until the frontend moves.
 *
 * @deprecated
 */
export const getProjectParameters = <ThrowOnError extends boolean = false>(options: Options<GetProjectParametersData, ThrowOnError>): RequestResult<GetProjectParametersResponses, GetProjectParametersErrors, ThrowOnError> => (options.client ?? client).get<GetProjectParametersResponses, GetProjectParametersErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/parameters', ...options });

/**
 * Get Organization Project Parameters
 *
 * parameter key names of the projects the caller may read, for workflow action placeholders
 */
export const getOrganizationProjectParameters = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationProjectParametersData, ThrowOnError>): RequestResult<GetOrganizationProjectParametersResponses, GetOrganizationProjectParametersErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationProjectParametersResponses, GetOrganizationProjectParametersErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/parameters', ...options });

/**
 * Get Project Filters
 */
export const getProjectFilters = <ThrowOnError extends boolean = false>(options: Options<GetProjectFiltersData, ThrowOnError>): RequestResult<GetProjectFiltersResponses, GetProjectFiltersErrors, ThrowOnError> => (options.client ?? client).get<GetProjectFiltersResponses, GetProjectFiltersErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/filters', ...options });

/**
 * Get Project Hierarchy
 */
export const getProjectHierarchy = <ThrowOnError extends boolean = false>(options: Options<GetProjectHierarchyData, ThrowOnError>): RequestResult<GetProjectHierarchyResponses, GetProjectHierarchyErrors, ThrowOnError> => (options.client ?? client).get<GetProjectHierarchyResponses, GetProjectHierarchyErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/hierarchy', ...options });

/**
 * Create Project Hierarchy
 */
export const createProjectHierarchy = <ThrowOnError extends boolean = false>(options: Options<CreateProjectHierarchyData, ThrowOnError>): RequestResult<CreateProjectHierarchyResponses, CreateProjectHierarchyErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectHierarchyResponses, CreateProjectHierarchyErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/client/hierarchy',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Batch Create Clients
 *
 * Batch create/update audit projects from a CSV-derived JSON array.
 *
 * Audit-only; the endpoint hardcodes `project_type="audit"` and uses
 * the audit type's UUID for the permission scope. Idempotent: re-running
 * with the same data updates existing projects (matched by company_id +
 * booking_year).
 *
 * The configured format requires a mode (create, update, or upsert). Null
 * fields preserve existing values; supplied project tags are appended without
 * duplicates. Other supplied lists replace existing values, including membership.
 * Empty tag lists preserve tags; other empty lists clear selected fields. New
 * dossiers default to the CompanyID as their name and AGBW as their module.
 * The legacy full-row format remains supported. Tasks ERP and Task Audit
 * File are mutually exclusive.
 */
export const batchCreateClients = <ThrowOnError extends boolean = false>(options: Options<BatchCreateClientsData, ThrowOnError>): RequestResult<BatchCreateClientsResponses, BatchCreateClientsErrors, ThrowOnError> => (options.client ?? client).post<BatchCreateClientsResponses, BatchCreateClientsErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/client/batch',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Bulk Update Client Tags
 *
 * Add and remove tags across several root projects in one transaction.
 *
 * A delta rather than a replacement, so clients that start with different
 * tags keep their differences. Adding a tag a client already has, or removing
 * one it lacks, is a no-op; anything unknown, foreign, not a root or of
 * another type's vocabulary rejects the whole call and writes nothing. The
 * caller needs the tag management grant of every project type involved.
 */
export const bulkUpdateClientTags = <ThrowOnError extends boolean = false>(options: Options<BulkUpdateClientTagsData, ThrowOnError>): RequestResult<BulkUpdateClientTagsResponses, BulkUpdateClientTagsErrors, ThrowOnError> => (options.client ?? client).post<BulkUpdateClientTagsResponses, BulkUpdateClientTagsErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/client/tags/bulk',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Set Client Tags
 *
 * Replace one root project's tags. A dedicated sub-resource: the project payload is untouched.
 */
export const setClientTags = <ThrowOnError extends boolean = false>(options: Options<SetClientTagsData, ThrowOnError>): RequestResult<SetClientTagsResponses, SetClientTagsErrors, ThrowOnError> => (options.client ?? client).put<SetClientTagsResponses, SetClientTagsErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/client/{project_id}/tags',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Project
 */
export const deleteProject = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectData, ThrowOnError>): RequestResult<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}', ...options });

/**
 * Update Project
 */
export const updateProject = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectData, ThrowOnError>): RequestResult<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError> => (options.client ?? client).put<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/client/{project_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Update Project Status
 *
 * Update the status of a project dossier.
 *
 * Any team member with a project-scoped role (project_editor,
 * project_executor) or a project_admin scoped to the project's
 * type can open or close a dossier. The check is enforced by
 * `@check_permission` via the type-scope cascade; no manual fallback
 * needed. The action is logged for audit trail purposes.
 */
export const updateProjectStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectStatusData, ThrowOnError>): RequestResult<UpdateProjectStatusResponses, UpdateProjectStatusErrors, ThrowOnError> => (options.client ?? client).patch<UpdateProjectStatusResponses, UpdateProjectStatusErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/client/{project_id}/status',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Archive Project
 *
 * Archive a top-level project together with its whole subtree.
 *
 * Rows, memberships and linked data stay untouched so `restore` is a pure
 * inverse; the tree simply leaves every normal listing and refuses writes.
 */
export const archiveProject = <ThrowOnError extends boolean = false>(options: Options<ArchiveProjectData, ThrowOnError>): RequestResult<ArchiveProjectResponses, ArchiveProjectErrors, ThrowOnError> => (options.client ?? client).post<ArchiveProjectResponses, ArchiveProjectErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/archive', ...options });

/**
 * Restore Project
 *
 * Bring an archived top-level project and its subtree back.
 */
export const restoreProject = <ThrowOnError extends boolean = false>(options: Options<RestoreProjectData, ThrowOnError>): RequestResult<RestoreProjectResponses, RestoreProjectErrors, ThrowOnError> => (options.client ?? client).post<RestoreProjectResponses, RestoreProjectErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/restore', ...options });

/**
 * Update Materiality Thresholds
 *
 * Update materiality thresholds for an audit project.
 *
 * Access is gated by `update_agbw_materiality_thresholds` scoped to the
 * specific project; granted to scoped editors/executors, plus
 * `project_admin` scoped to the audit project type via the cascade.
 */
export const updateMaterialityThresholds = <ThrowOnError extends boolean = false>(options: Options<UpdateMaterialityThresholdsData, ThrowOnError>): RequestResult<UpdateMaterialityThresholdsResponses, UpdateMaterialityThresholdsErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMaterialityThresholdsResponses, UpdateMaterialityThresholdsErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/client/{project_id}/materiality',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * List Grouped Audit Origin Groups
 *
 * Consume grouped validation checks per origin for a client.
 *
 * Only checks relevant to the client are listed unless `include_irrelevant` is set.
 */
export const listGroupedAuditOriginGroups = <ThrowOnError extends boolean = false>(options: Options<ListGroupedAuditOriginGroupsData, ThrowOnError>): RequestResult<ListGroupedAuditOriginGroupsResponses, ListGroupedAuditOriginGroupsErrors, ThrowOnError> => (options.client ?? client).get<ListGroupedAuditOriginGroupsResponses, ListGroupedAuditOriginGroupsErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/data', ...options });

/**
 * Export Validation Results
 *
 * Export validation test results for a specific client as an Excel file.
 *
 * Only checks relevant to the client are exported unless `include_irrelevant` is set.
 */
export const exportValidationResults = <ThrowOnError extends boolean = false>(options: Options<ExportValidationResultsData, ThrowOnError>): RequestResult<ExportValidationResultsResponses, ExportValidationResultsErrors, ThrowOnError> => (options.client ?? client).get<ExportValidationResultsResponses, ExportValidationResultsErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/data/export', ...options });

/**
 * Get Source Status
 *
 * Get the grouped data source freshness status for a client/year.
 *
 * Returns the single source group matching the client's enabled task
 * feature: the ERP group (DUO, DUS-I) for tasks_erp or the Audit File
 * group (GL Trial-Balance, Audit File Financial, Audit File HR) for
 * tasks_audit_file. The two features are mutually exclusive, so the
 * response never contains both groups. Clients with no applicable task
 * feature get an empty list; Continuous Audit is not exposed here yet.
 *
 * Args:
 *     client: The audit client (provides booking_year and company_id).
 *     source_status_service: Service for source freshness status.
 *
 * Returns:
 *     List with at most one SourceStatusGroup.
 */
export const getSourceStatus = <ThrowOnError extends boolean = false>(options: Options<GetSourceStatusData, ThrowOnError>): RequestResult<GetSourceStatusResponses, GetSourceStatusErrors, ThrowOnError> => (options.client ?? client).get<GetSourceStatusResponses, GetSourceStatusErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/source-status', ...options });

/**
 * Rerun Client Checks
 *
 * Rerun the validation checks relevant to a specific client.
 */
export const rerunClientChecks = <ThrowOnError extends boolean = false>(options: Options<RerunClientChecksData, ThrowOnError>): RequestResult<RerunClientChecksResponses, RerunClientChecksErrors, ThrowOnError> => (options.client ?? client).post<RerunClientChecksResponses, RerunClientChecksErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/rerun-checks', ...options });

/**
 * Rerun Single Check For Client
 *
 * Rerun a single validation check for a specific client only, relevant to it or not.
 *
 * this endpoint only executes the check using this client's parameters
 * and only updates this client's result. A check of another
 * organization answers exactly like an unknown check_id.
 */
export const rerunSingleCheckForClient = <ThrowOnError extends boolean = false>(options: Options<RerunSingleCheckForClientData, ThrowOnError>): RequestResult<RerunSingleCheckForClientResponses, RerunSingleCheckForClientErrors, ThrowOnError> => (options.client ?? client).post<RerunSingleCheckForClientResponses, RerunSingleCheckForClientErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/check/{check_id}/rerun', ...options });

/**
 * Get Project Members
 *
 * Project team members with their scoped role and task completion counts.
 *
 * Members are non-deleted members of the project's organization with a
 * project-scoped role assignment (`project_executor` or `project_editor`)
 * on this project.
 * `project_admin`s are NOT listed; they have access via the
 * project_type-scope cascade and are managed at the organization
 * level, not as team members.
 */
export const getProjectMembers = <ThrowOnError extends boolean = false>(options: Options<GetProjectMembersData, ThrowOnError>): RequestResult<GetProjectMembersResponses, GetProjectMembersErrors, ThrowOnError> => (options.client ?? client).get<GetProjectMembersResponses, GetProjectMembersErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/members', ...options });

/**
 * Add Project Member
 *
 * Add a user as a project team member with the given scoped role.
 *
 * Membership and role are the same row under the new model: this writes
 * a UserRoleAssignment scoped to the project. If the user already has a
 * different scoped role on this project, the partial unique index causes
 * `assign_resource_role` to atomically replace the existing role
 * (UPSERT semantics).
 *
 * The user must be a member of the project's organization who is not
 * deleted before the role assignment is written; a user of another
 * organization answers exactly like an unknown user_id.
 */
export const addProjectMember = <ThrowOnError extends boolean = false>(options: Options<AddProjectMemberData, ThrowOnError>): RequestResult<AddProjectMemberResponses, AddProjectMemberErrors, ThrowOnError> => (options.client ?? client).post<AddProjectMemberResponses, AddProjectMemberErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/members', ...options });

/**
 * Remove Project Member
 *
 * Remove a user's membership from a project.
 *
 * Drops every scoped role row for (user, project); under the partial
 * unique index there's at most one anyway, but `revoke_resource_role`
 * with `role_name=None` covers any pre-existing duplicates.
 */
export const removeProjectMember = <ThrowOnError extends boolean = false>(options: Options<RemoveProjectMemberData, ThrowOnError>): RequestResult<RemoveProjectMemberResponses, RemoveProjectMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveProjectMemberResponses, RemoveProjectMemberErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/members/{user_id}', ...options });

/**
 * Get Project Datasources
 *
 * Datasources linked to this project (dossier context).
 *
 * Used for document analysis within the dossier; not shown in the
 * general data management view. Access is gated by `read_project`
 * scoped to this project (handled by `@check_permission`); manual
 * team-membership fallback is no longer needed under the scoped role
 * model.
 */
export const getProjectDatasources = <ThrowOnError extends boolean = false>(options: Options<GetProjectDatasourcesData, ThrowOnError>): RequestResult<GetProjectDatasourcesResponses, GetProjectDatasourcesErrors, ThrowOnError> => (options.client ?? client).get<GetProjectDatasourcesResponses, GetProjectDatasourcesErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/datasources', ...options });

/**
 * Delete All Trial Balance Entries
 *
 * Delete ALL trial balance entries for this client.
 *
 * Args:
 *     session: Database session.
 *     client: The audit client from path validation.
 *     service: Injected trial balance service.
 *     cache_service: API cache service.
 *
 * Returns:
 *     TrialBalanceDeleteResponse with deleted count.
 */
export const deleteAllTrialBalanceEntries = <ThrowOnError extends boolean = false>(options: Options<DeleteAllTrialBalanceEntriesData, ThrowOnError>): RequestResult<DeleteAllTrialBalanceEntriesResponses, DeleteAllTrialBalanceEntriesErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAllTrialBalanceEntriesResponses, DeleteAllTrialBalanceEntriesErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/trial-balance', ...options });

/**
 * Get Trial Balance Entries
 *
 * Get all trial balance entries for an audit client.
 *
 * Returns entries ordered by ledger account number.
 *
 * Args:
 *     client: The audit client from path validation.
 *     service: Injected trial balance service.
 *
 * Returns:
 *     TrialBalanceEntriesResponse containing all entries and count.
 */
export const getTrialBalanceEntries = <ThrowOnError extends boolean = false>(options: Options<GetTrialBalanceEntriesData, ThrowOnError>): RequestResult<GetTrialBalanceEntriesResponses, GetTrialBalanceEntriesErrors, ThrowOnError> => (options.client ?? client).get<GetTrialBalanceEntriesResponses, GetTrialBalanceEntriesErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/trial-balance', ...options });

/**
 * Delete Trial Balance Entry
 *
 * Delete a single trial balance entry.
 *
 * Args:
 *     session: Database session.
 *     client: The audit client from path validation.
 *     service: Injected trial balance service.
 *     cache_service: API cache service.
 *     entry_id: ID of the entry to delete.
 *
 * Raises:
 *     TrialBalanceEntryNotFoundException: If the entry is not found.
 */
export const deleteTrialBalanceEntry = <ThrowOnError extends boolean = false>(options: Options<DeleteTrialBalanceEntryData, ThrowOnError>): RequestResult<DeleteTrialBalanceEntryResponses, DeleteTrialBalanceEntryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTrialBalanceEntryResponses, DeleteTrialBalanceEntryErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/trial-balance/{entry_id}', ...options });

/**
 * Replace All Trial Balance Entries
 *
 * Replace ALL trial balance entries atomically.
 *
 * This deletes all existing entries and creates new ones in a single
 * transaction. If creation fails, deletion is also rolled back.
 *
 * Args:
 *     session: Database session.
 *     client: The audit client from path validation.
 *     service: Injected trial balance service.
 *     request: Replace request with new entries (can be empty to clear all).
 *
 * Returns:
 *     TrialBalanceEntriesResponse with new entries.
 *
 * Raises:
 *     TrialBalanceValidationException: If validation fails.
 */
export const replaceAllTrialBalanceEntries = <ThrowOnError extends boolean = false>(options: Options<ReplaceAllTrialBalanceEntriesData, ThrowOnError>): RequestResult<ReplaceAllTrialBalanceEntriesResponses, ReplaceAllTrialBalanceEntriesErrors, ThrowOnError> => (options.client ?? client).put<ReplaceAllTrialBalanceEntriesResponses, ReplaceAllTrialBalanceEntriesErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/client/{project_id}/trial-balance/replace',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Export Trial Balance
 *
 * Export trial balance and trigger dbt pipeline.
 *
 * Args:
 *     client: Current audit client
 *     current_user: Current authenticated user
 *     request: Export trial balance request
 *     pipeline: Trial balance export pipeline
 *
 * Returns:
 *     ExportTrialBalanceResponse with execution details
 *
 * Raises:
 *     TrialBalanceClientMissingParametersException: If required client parameters are missing.
 *     TrialBalanceExportException: If export preparation or pipeline execution fails.
 */
export const exportTrialBalance = <ThrowOnError extends boolean = false>(options: Options<ExportTrialBalanceData, ThrowOnError>): RequestResult<ExportTrialBalanceResponses, ExportTrialBalanceErrors, ThrowOnError> => (options.client ?? client).post<ExportTrialBalanceResponses, ExportTrialBalanceErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/client/{project_id}/trial-balance/export',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Trial Balance Pipeline Status
 *
 * Get classification export pipeline execution status. Returns null when no execution exists.
 */
export const getTrialBalancePipelineStatus = <ThrowOnError extends boolean = false>(options: Options<GetTrialBalancePipelineStatusData, ThrowOnError>): RequestResult<GetTrialBalancePipelineStatusResponses, GetTrialBalancePipelineStatusErrors, ThrowOnError> => (options.client ?? client).get<GetTrialBalancePipelineStatusResponses, GetTrialBalancePipelineStatusErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/trial-balance/pipeline/status', ...options });

/**
 * Start Agbw Prechecks Pipeline
 *
 * Trigger the AGBW pipeline using the current version.
 *
 * This endpoint runs the pipeline with the existing progress data.
 * It does NOT create a new version - it uses the current version.
 *
 * The version represents the audit run, and all saves and pipeline
 * executions within that run use the same version number.
 *
 * The pipeline is triggered asynchronously. Use GET /progress/pipeline/status
 * to poll for the execution status.
 *
 * Args:
 *     client: The audit client from the path parameter.
 *     dao: Data access object for AGBW operations.
 *     agbw_full_pipeline: The AGBW pipeline instance.
 *     current_user: The currently authenticated user.
 *
 * Raises:
 *     AgbwLatestProgressNotFoundException: If no existing AGBW progress is found.
 *     AgbwPipelineTriggerException: If the pipeline fails to trigger.
 */
export const startAgbwPrechecksPipeline = <ThrowOnError extends boolean = false>(options: Options<StartAgbwPrechecksPipelineData, ThrowOnError>): RequestResult<StartAgbwPrechecksPipelineResponses, StartAgbwPrechecksPipelineErrors, ThrowOnError> => (options.client ?? client).post<StartAgbwPrechecksPipelineResponses, StartAgbwPrechecksPipelineErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/progress/pipeline/precheck', ...options });

/**
 * Get Agbw Pipeline Status
 *
 * Get the status of AGBW child pipelines.
 *
 * Returns the current status of the 4 child pipelines (precheck, processing, export, dbt_run)
 * that are invoked by the parent agbw_full pipeline. This endpoint should be called
 * when visiting the AGBW overview page to display pipeline execution progress.
 *
 * The endpoint queries Fabric's Activity Runs API to get the status of each child
 * pipeline activity. If no execution exists or the run_id is not yet available,
 * all statuses will be returned as "not_started".
 *
 * Args:
 *     client: The audit client.
 *     agbw_full_pipeline: The AGBW full pipeline service.
 *
 * Returns:
 *     AGBWPipelineStatusResponse: Status of parent and child pipelines including:
 *         - parent_run_id: The Fabric run ID (if available)
 *         - parent_status: Overall status of the parent pipeline
 *         - has_active_execution: Whether polling should continue
 *         - children: List of 4 child pipeline statuses
 */
export const getAgbwPipelineStatus = <ThrowOnError extends boolean = false>(options: Options<GetAgbwPipelineStatusData, ThrowOnError>): RequestResult<GetAgbwPipelineStatusResponses, GetAgbwPipelineStatusErrors, ThrowOnError> => (options.client ?? client).get<GetAgbwPipelineStatusResponses, GetAgbwPipelineStatusErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/progress/pipeline/status', ...options });

/**
 * Get Agbw Progress
 *
 * Get AGBW progress for a client.
 *
 * Retrieves the latest saved progress including file metadata (not actual file content).
 *
 * Args:
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *
 * Returns:
 *     AGBWProgressResponse | None: The progress record if it exists, None otherwise.
 *
 * Raises:
 *     PermissionDeniedException: If the gate refuses the project, whatever the reason.
 */
export const getAgbwProgress = <ThrowOnError extends boolean = false>(options: Options<GetAgbwProgressData, ThrowOnError>): RequestResult<GetAgbwProgressResponses, GetAgbwProgressErrors, ThrowOnError> => (options.client ?? client).get<GetAgbwProgressResponses, GetAgbwProgressErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/progress', ...options });

/**
 * Save Agbw Progress
 *
 * Save AGBW progress for a client.
 *
 * Creates or updates progress records. Uses bulk replace strategy for
 * affiliate and trial_balance data to ensure JSONB changes are detected.
 *
 * Args:
 *     session: Database session.
 *     client: Audit client.
 *     dao: AGBW input DAO.
 *     fabric_service: Fabric upload service.
 *     file_service: Azure Blob Storage file service.
 *     current_user: Authenticated user.
 *     data: AGBW progress data to save.
 *
 * Returns:
 *     AGBWProgressResponse with version info.
 */
export const saveAgbwProgress = <ThrowOnError extends boolean = false>(options: Options<SaveAgbwProgressData, ThrowOnError>): RequestResult<SaveAgbwProgressResponses, SaveAgbwProgressErrors, ThrowOnError> => (options.client ?? client).post<SaveAgbwProgressResponses, SaveAgbwProgressErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/{project_id}/agbw/progress',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Agbw Continue Acknowledgment
 *
 * Get the continue acknowledgment for an AGBW progress.
 *
 * Returns the acknowledgment record if issues have been acknowledged,
 * or None if no acknowledgment exists. Always queries the database
 * directly to ensure the guard reflects real-time state.
 *
 * Args:
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *     session: Database session.
 *
 * Returns:
 *     AGBWContinueAcknowledgmentResponse or None if not acknowledged.
 */
export const getAgbwContinueAcknowledgment = <ThrowOnError extends boolean = false>(options: Options<GetAgbwContinueAcknowledgmentData, ThrowOnError>): RequestResult<GetAgbwContinueAcknowledgmentResponses, GetAgbwContinueAcknowledgmentErrors, ThrowOnError> => (options.client ?? client).get<GetAgbwContinueAcknowledgmentResponses, GetAgbwContinueAcknowledgmentErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/progress/continue', ...options });

/**
 * Acknowledge Agbw Issues
 *
 * Acknowledge AGBW issues and continue to full results.
 *
 * Records that an auditor has acknowledged issues (missing batches or
 * trial balance not reconciled) and chosen to continue viewing results.
 * This is a one-time acknowledgment per AGBW progress - once acknowledged,
 * all team members can view the full results.
 *
 * Args:
 *     session: Database session.
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *     current_user: The authenticated user.
 *     data: Acknowledgment request with issue type and reason.
 *
 * Returns:
 *     AGBWContinueAcknowledgmentResponse with acknowledgment details.
 *
 * Raises:
 *     AgbwProgressNotFoundException: If no AGBW progress exists.
 */
export const acknowledgeAgbwIssues = <ThrowOnError extends boolean = false>(options: Options<AcknowledgeAgbwIssuesData, ThrowOnError>): RequestResult<AcknowledgeAgbwIssuesResponses, AcknowledgeAgbwIssuesErrors, ThrowOnError> => (options.client ?? client).post<AcknowledgeAgbwIssuesResponses, AcknowledgeAgbwIssuesErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/{project_id}/agbw/progress/continue',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Export Agbw Output
 *
 * Export AGBW output file from Fabric or generate custom Excel.
 *
 * Args:
 *     client: The audit client.
 *     organization: The organization.
 *     dao: AGBWInputDAO instance.
 *     fabric_service: Fabric upload service.
 *     overview_deps: DAOs + comment/confirmation services for the overview export.
 *     misc_daos: DAOs for the miscellaneous export.
 *     sessions: Warehouse + app database sessions.
 *     output_format: Export format ('legacy', 'lqm', 'agbw', 'data', 'miscellaneous').
 *     worksheets: List of worksheets to export (only for 'miscellaneous' format).
 *     page_size: Maximum number of rows to fetch per worksheet (default: 1000000).
 *
 * Returns:
 *     Excel file streamed from Fabric or generated Excel.
 */
export const exportAgbwOutput = <ThrowOnError extends boolean = false>(options: Options<ExportAgbwOutputData, ThrowOnError>): RequestResult<ExportAgbwOutputResponses, ExportAgbwOutputErrors, ThrowOnError> => (options.client ?? client).get<ExportAgbwOutputResponses, ExportAgbwOutputErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/export', ...options });

/**
 * Get Materiality Preference
 *
 * Get materiality preferences for the current AGBW progress.
 *
 * Args:
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *
 * Returns:
 *     MaterialityPreferenceResponse with the preferences dict.
 *
 * Raises:
 *     AgbwProgressNotFoundException: If no AGBW progress exists.
 */
export const getMaterialityPreference = <ThrowOnError extends boolean = false>(options: Options<GetMaterialityPreferenceData, ThrowOnError>): RequestResult<GetMaterialityPreferenceResponses, GetMaterialityPreferenceErrors, ThrowOnError> => (options.client ?? client).get<GetMaterialityPreferenceResponses, GetMaterialityPreferenceErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/progress/materiality-preference', ...options });

/**
 * Update Materiality Preference
 *
 * Update materiality preferences for the current AGBW progress.
 *
 * Args:
 *     session: Database session.
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *     data: Request with new materiality preferences.
 *
 * Returns:
 *     MaterialityPreferenceResponse with the updated preferences.
 *
 * Raises:
 *     AgbwProgressNotFoundException: If no AGBW progress exists.
 */
export const updateMaterialityPreference = <ThrowOnError extends boolean = false>(options: Options<UpdateMaterialityPreferenceData, ThrowOnError>): RequestResult<UpdateMaterialityPreferenceResponses, UpdateMaterialityPreferenceErrors, ThrowOnError> => (options.client ?? client).put<UpdateMaterialityPreferenceResponses, UpdateMaterialityPreferenceErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/{project_id}/agbw/progress/materiality-preference',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Cpi Preference
 *
 * Get CPI score filter preferences for the current AGBW progress.
 *
 * Args:
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *
 * Returns:
 *     CpiPreferenceResponse with the preferences dict.
 *
 * Raises:
 *     AgbwProgressNotFoundException: If no AGBW progress exists.
 */
export const getCpiPreference = <ThrowOnError extends boolean = false>(options: Options<GetCpiPreferenceData, ThrowOnError>): RequestResult<GetCpiPreferenceResponses, GetCpiPreferenceErrors, ThrowOnError> => (options.client ?? client).get<GetCpiPreferenceResponses, GetCpiPreferenceErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/progress/cpi-preference', ...options });

/**
 * Update Cpi Preference
 *
 * Update CPI score filter preferences for the current AGBW progress.
 *
 * Args:
 *     session: Database session.
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *     data: Request with new CPI score preferences.
 *
 * Returns:
 *     CpiPreferenceResponse with the updated preferences.
 *
 * Raises:
 *     AgbwProgressNotFoundException: If no AGBW progress exists.
 */
export const updateCpiPreference = <ThrowOnError extends boolean = false>(options: Options<UpdateCpiPreferenceData, ThrowOnError>): RequestResult<UpdateCpiPreferenceResponses, UpdateCpiPreferenceErrors, ThrowOnError> => (options.client ?? client).put<UpdateCpiPreferenceResponses, UpdateCpiPreferenceErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/{project_id}/agbw/progress/cpi-preference',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Clear Camt Files
 *
 * Clear all CAMT files for the current AGBW progress.
 *
 * Removes all CAMT file metadata and resets the CAMT status to draft.
 * This allows users to start fresh with CAMT file uploads.
 *
 * Args:
 *     session: Database session.
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *     current_user: The currently authenticated user.
 *
 * Raises:
 *     AgbwProgressNotFoundException: If no AGBW progress exists.
 */
export const clearCamtFiles = <ThrowOnError extends boolean = false>(options: Options<ClearCamtFilesData, ThrowOnError>): RequestResult<ClearCamtFilesResponses, ClearCamtFilesErrors, ThrowOnError> => (options.client ?? client).delete<ClearCamtFilesResponses, ClearCamtFilesErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/progress/camt', ...options });

/**
 * Clear Batch Files
 *
 * Clear all batch files for the current AGBW progress.
 *
 * Removes all batch file metadata and resets the batch status to draft.
 * This allows users to start fresh with batch file uploads.
 *
 * Args:
 *     session: Database session.
 *     client: The audit client.
 *     dao: AGBWInputDAO instance.
 *     current_user: The currently authenticated user.
 *
 * Raises:
 *     AgbwProgressNotFoundException: If no AGBW progress exists.
 */
export const clearBatchFiles = <ThrowOnError extends boolean = false>(options: Options<ClearBatchFilesData, ThrowOnError>): RequestResult<ClearBatchFilesResponses, ClearBatchFilesErrors, ThrowOnError> => (options.client ?? client).delete<ClearBatchFilesResponses, ClearBatchFilesErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/progress/batches', ...options });

/**
 * Get Comments For Dashboard
 *
 * Get all comments for a specific dashboard.
 *
 * Args:
 *     client: The audit client (from path).
 *     organization: The organization (from path).
 *     service: The AGBW row comment service.
 *     run: The run number.
 *     dashboard_name: The dashboard name.
 *
 * Returns:
 *     List of comments for the dashboard.
 */
export const getCommentsForDashboard = <ThrowOnError extends boolean = false>(options: Options<GetCommentsForDashboardData, ThrowOnError>): RequestResult<GetCommentsForDashboardResponses, GetCommentsForDashboardErrors, ThrowOnError> => (options.client ?? client).get<GetCommentsForDashboardResponses, GetCommentsForDashboardErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/comments', ...options });

/**
 * Create Or Update Comment
 *
 * Create a new comment or update an existing one.
 *
 * If a comment already exists for the same row, it will be updated.
 *
 * Args:
 *     client: The audit client (from path).
 *     organization: The organization (from path).
 *     current_user: The current user.
 *     service: The AGBW row comment service.
 *     comment_data: The comment data.
 *
 * Returns:
 *     The created or updated comment.
 */
export const createOrUpdateComment = <ThrowOnError extends boolean = false>(options: Options<CreateOrUpdateCommentData, ThrowOnError>): RequestResult<CreateOrUpdateCommentResponses, CreateOrUpdateCommentErrors, ThrowOnError> => (options.client ?? client).post<CreateOrUpdateCommentResponses, CreateOrUpdateCommentErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/{project_id}/agbw/comments',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Comment
 *
 * Delete a specific comment by ID.
 *
 * Args:
 *     client: The audit client (from path).
 *     organization: The organization (from path).
 *     service: The AGBW row comment service.
 *     comment_id: The comment ID to delete.
 */
export const deleteComment = <ThrowOnError extends boolean = false>(options: Options<DeleteCommentData, ThrowOnError>): RequestResult<DeleteCommentResponses, DeleteCommentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCommentResponses, DeleteCommentErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/comments/{comment_id}', ...options });

/**
 * Get Comment
 *
 * Get a specific comment by ID.
 *
 * Args:
 *     client: The audit client (from path).
 *     organization: The organization (from path).
 *     service: The AGBW row comment service.
 *     comment_id: The comment ID.
 *
 * Returns:
 *     The comment.
 */
export const getComment = <ThrowOnError extends boolean = false>(options: Options<GetCommentData, ThrowOnError>): RequestResult<GetCommentResponses, GetCommentErrors, ThrowOnError> => (options.client ?? client).get<GetCommentResponses, GetCommentErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/comments/{comment_id}', ...options });

/**
 * Delete Confirmation
 *
 * Delete a confirmation for a specific row.
 *
 * Args:
 *     client: The audit client (from path).
 *     organization: The organization (from path).
 *     service: The AGBW row confirmation service.
 *     delete_request: The deletion request data.
 */
export const deleteConfirmation = <ThrowOnError extends boolean = false>(options: Options<DeleteConfirmationData, ThrowOnError>): RequestResult<DeleteConfirmationResponses, DeleteConfirmationErrors, ThrowOnError> => (options.client ?? client).delete<DeleteConfirmationResponses, DeleteConfirmationErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/{project_id}/agbw/confirmations',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Confirmations For Dashboard
 *
 * Get all confirmations for a specific dashboard.
 *
 * Args:
 *     client: The audit client .
 *     organization: The organization .
 *     service: The AGBW row confirmation service.
 *     run: The run number.
 *     dashboard_name: The dashboard name.
 *
 * Returns:
 *     List of confirmations for the dashboard.
 */
export const getConfirmationsForDashboard = <ThrowOnError extends boolean = false>(options: Options<GetConfirmationsForDashboardData, ThrowOnError>): RequestResult<GetConfirmationsForDashboardResponses, GetConfirmationsForDashboardErrors, ThrowOnError> => (options.client ?? client).get<GetConfirmationsForDashboardResponses, GetConfirmationsForDashboardErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/confirmations', ...options });

/**
 * Create Or Update Confirmation
 *
 * Create a new confirmation or update an existing one.
 *
 * If a confirmation already exists for the same row, it will be updated
 * with the current user and timestamp.
 *
 * Args:
 *     client: The audit client (from path).
 *     organization: The organization (from path).
 *     current_user: The current user.
 *     service: The AGBW row confirmation service.
 *     confirmation_data: The confirmation data.
 *
 * Returns:
 *     The created or updated confirmation.
 */
export const createOrUpdateConfirmation = <ThrowOnError extends boolean = false>(options: Options<CreateOrUpdateConfirmationData, ThrowOnError>): RequestResult<CreateOrUpdateConfirmationResponses, CreateOrUpdateConfirmationErrors, ThrowOnError> => (options.client ?? client).post<CreateOrUpdateConfirmationResponses, CreateOrUpdateConfirmationErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/{project_id}/agbw/confirmations',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Confirmation
 *
 * Get a specific confirmation by ID.
 *
 * Args:
 *     client: The audit client (from path).
 *     organization: The organization (from path).
 *     service: The AGBW row confirmation service.
 *     confirmation_id: The confirmation ID.
 *
 * Returns:
 *     The confirmation.
 */
export const getConfirmation = <ThrowOnError extends boolean = false>(options: Options<GetConfirmationData, ThrowOnError>): RequestResult<GetConfirmationResponses, GetConfirmationErrors, ThrowOnError> => (options.client ?? client).get<GetConfirmationResponses, GetConfirmationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/confirmations/{confirmation_id}', ...options });

/**
 * Get Accounts Summary
 *
 * Get accounts summary (bank balance) data. Caching is handled at the DAO level.
 *
 * Args:
 *     dao: Injected AccountsDAO for database access.
 *     client: Project context used to derive company_id internally via audit_parameters(client).company_id.
 *     booking_year: Fiscal year for filtering.
 *     run: Run number for filtering.
 *     page: Page number for pagination.
 *     page_size: Number of items per page.
 *     sort_by: Column to sort by.
 *     sort_direction: Sort direction ("asc" or "desc").
 *
 * Returns:
 *     AccountsSummaryResponse containing paginated account summary information.
 */
export const getAccountsSummary = <ThrowOnError extends boolean = false>(options: Options<GetAccountsSummaryData, ThrowOnError>): RequestResult<GetAccountsSummaryResponses, GetAccountsSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetAccountsSummaryResponses, GetAccountsSummaryErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/overview/accounts', ...options });

/**
 * Get Accounts Drilldown
 *
 * Get accounts drilldown (detailed bank balance information). Caching is handled at the DAO level.
 *
 * Returns detailed balance information including trial balance amounts,
 * opening/closing dates, and impact amounts for reconciliation analysis.
 *
 * Args:
 *     dao: Injected AccountsDAO for database access.
 *     client: Project context used to derive company_id internally via audit_parameters(client).company_id.
 *     booking_year: Fiscal year for filtering.
 *     run: Run number for filtering.
 *     page: Page number for pagination.
 *     page_size: Number of items per page.
 *     sort_by: Column to sort by.
 *     sort_direction: Sort direction ("asc" or "desc").
 *
 * Returns:
 *     AccountsDrilldownResponse containing paginated detailed account information.
 */
export const getAccountsDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetAccountsDrilldownData, ThrowOnError>): RequestResult<GetAccountsDrilldownResponses, GetAccountsDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetAccountsDrilldownResponses, GetAccountsDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/overview/accounts/drilldown', ...options });

/**
 * Export Accounts Drilldown
 *
 * Export all accounts drilldown rows as a styled Excel file.
 */
export const exportAccountsDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportAccountsDrilldownData, ThrowOnError>): RequestResult<ExportAccountsDrilldownResponses, ExportAccountsDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportAccountsDrilldownResponses, ExportAccountsDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/overview/accounts/drilldown/export', ...options });

/**
 * Get Batch Purchase Overview
 *
 * Get batch purchase overview data. Caching is handled at the DAO level.
 *
 * Args:
 *     dao: Injected BatchDAO for database access.
 *     client: Project context used to derive company_id internally via audit_parameters(client).company_id.
 *     booking_year: Fiscal year for filtering.
 *     run: Run number for filtering.
 *
 * Returns:
 *     BatchPurchaseOverviewResponse containing batch purchase overview rows.
 */
export const getBatchPurchaseOverview = <ThrowOnError extends boolean = false>(options: Options<GetBatchPurchaseOverviewData, ThrowOnError>): RequestResult<GetBatchPurchaseOverviewResponses, GetBatchPurchaseOverviewErrors, ThrowOnError> => (options.client ?? client).get<GetBatchPurchaseOverviewResponses, GetBatchPurchaseOverviewErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/overview/batches/purchase', ...options });

/**
 * Get Batch Salary Overview
 *
 * Get batch salary overview data. Caching is handled at the DAO level.
 *
 * Args:
 *     dao: Injected BatchDAO for database access.
 *     client: Project context used to derive company_id internally via audit_parameters(client).company_id.
 *     booking_year: Fiscal year for filtering.
 *     run: Run number for filtering.
 *
 * Returns:
 *     BatchSalaryOverviewResponse containing batch salary overview rows.
 */
export const getBatchSalaryOverview = <ThrowOnError extends boolean = false>(options: Options<GetBatchSalaryOverviewData, ThrowOnError>): RequestResult<GetBatchSalaryOverviewResponses, GetBatchSalaryOverviewErrors, ThrowOnError> => (options.client ?? client).get<GetBatchSalaryOverviewResponses, GetBatchSalaryOverviewErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/overview/batches/salary', ...options });

/**
 * Get Batch Drilldown
 *
 * Get batch drilldown transactions. Caching is handled at the DAO level.
 *
 * Returns detailed batch information including entity, IBAN, bank batch ID,
 * posting date, batch category, batch indicator, currency, total amount,
 * and transaction count.
 *
 * Args:
 *     dao: Injected BatchDAO for database access.
 *     client: Project context used to derive company_id internally via audit_parameters(client).company_id.
 *     booking_year: Fiscal year for filtering.
 *     run: Run number for filtering.
 *     category: Batch category filter ("Purchase" or "Salary").
 *     status: Batch status filter ("Available" or "Missing").
 *     page: Page number for pagination (default: 1).
 *     page_size: Number of items per page (default: 5000, max: 5000).
 *     sort_by: Column to sort by (optional).
 *     sort_direction: Sort direction ("asc" or "desc", default: "asc").
 *
 * Returns:
 *     BatchDrilldownResponse containing paginated batch details.
 */
export const getBatchDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetBatchDrilldownData, ThrowOnError>): RequestResult<GetBatchDrilldownResponses, GetBatchDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetBatchDrilldownResponses, GetBatchDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/overview/batches/drilldown', ...options });

/**
 * Export Batch Drilldown
 *
 * Export all batch drilldown rows as a styled Excel file.
 */
export const exportBatchDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportBatchDrilldownData, ThrowOnError>): RequestResult<ExportBatchDrilldownResponses, ExportBatchDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportBatchDrilldownResponses, ExportBatchDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/overview/batches/drilldown/export', ...options });

/**
 * Get Payment Overview
 *
 * Get payment overview data. Caching is handled at the DAO level.
 */
export const getPaymentOverview = <ThrowOnError extends boolean = false>(options: Options<GetPaymentOverviewData, ThrowOnError>): RequestResult<GetPaymentOverviewResponses, GetPaymentOverviewErrors, ThrowOnError> => (options.client ?? client).get<GetPaymentOverviewResponses, GetPaymentOverviewErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/overview/payments', ...options });

/**
 * Get Payment Category Pivot
 *
 * Get payment overview data pivoted by CategoryManualBatch.
 *
 * This endpoint implements dynamic SQL pivoting where columns
 * are determined by distinct payment categories in the data. The response
 * structure varies between audit runs based on available categories.
 * Caching is handled at the DAO level.
 *
 * The response includes:
 * - category_columns: List of distinct payment category names
 * - rows: Pivoted payment data with Entity IBAN and category amounts
 * - Last row has 'Total' in Entity IBAN column with grand totals
 *
 * Args:
 *     dao: Injected AGBW output DAO.
 *     client: Project context used to derive company_id internally via audit_parameters(client).company_id.
 *     booking_year: The fiscal year.
 *     run: The run number.
 *
 * Returns:
 *     PaymentCategoryPivotResponse with dynamic pivoted payment data.
 *
 * Raises:
 *     AgbwLatestProgressNotFoundException: If no AGBW progress exists for the client.
 *     AgbwClientParametersNotConfiguredException: If client parameters are not configured.
 *     AgbwCompanyIdNotSetException: If the company ID is missing from client parameters.
 */
export const getPaymentCategoryPivot = <ThrowOnError extends boolean = false>(options: Options<GetPaymentCategoryPivotData, ThrowOnError>): RequestResult<GetPaymentCategoryPivotResponses, GetPaymentCategoryPivotErrors, ThrowOnError> => (options.client ?? client).get<GetPaymentCategoryPivotResponses, GetPaymentCategoryPivotErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/overview/payments/category-pivot', ...options });

/**
 * Get Receivables By Counterparty Overview
 *
 * Get receivables grouped by counterparty overview data.
 */
export const getReceivablesByCounterpartyOverview = <ThrowOnError extends boolean = false>(options: Options<GetReceivablesByCounterpartyOverviewData, ThrowOnError>): RequestResult<GetReceivablesByCounterpartyOverviewResponses, GetReceivablesByCounterpartyOverviewErrors, ThrowOnError> => (options.client ?? client).get<GetReceivablesByCounterpartyOverviewResponses, GetReceivablesByCounterpartyOverviewErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/overview/receivables-by-counterparty', ...options });

/**
 * Get New Party Aggregation
 *
 * Get new party aggregation data. Caching is handled at the DAO level.
 */
export const getNewPartyAggregation = <ThrowOnError extends boolean = false>(options: Options<GetNewPartyAggregationData, ThrowOnError>): RequestResult<GetNewPartyAggregationResponses, GetNewPartyAggregationErrors, ThrowOnError> => (options.client ?? client).get<GetNewPartyAggregationResponses, GetNewPartyAggregationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/payments/new-party', ...options });

/**
 * Get New Party Drilldown
 *
 * Get new party drilldown transactions. Caching is handled at the DAO level.
 */
export const getNewPartyDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetNewPartyDrilldownData, ThrowOnError>): RequestResult<GetNewPartyDrilldownResponses, GetNewPartyDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetNewPartyDrilldownResponses, GetNewPartyDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/payments/new-party/drilldown', ...options });

/**
 * Export New Party Drilldown
 *
 * Export all new party drilldown transactions as a styled Excel file.
 */
export const exportNewPartyDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportNewPartyDrilldownData, ThrowOnError>): RequestResult<ExportNewPartyDrilldownResponses, ExportNewPartyDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportNewPartyDrilldownResponses, ExportNewPartyDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/payments/new-party/drilldown/export', ...options });

/**
 * Get Name Change Aggregation
 *
 * Get name change aggregation data (all rows, no pagination).
 *
 * Returns IBANs with multiple counter-party names (name variations).
 * Includes subtotal rows per IBAN group.
 *
 * Pagination is intentionally omitted: the underlying query uses GROUPING SETS
 * which produces paired subtotal + detail rows per IBAN. SQL-level OFFSET/FETCH
 * pagination splits those groups across pages, causing the frontend grouping
 * logic to show incomplete groups (e.g. an IBAN with 2 party names appears
 * to have only 1). Caching is handled at the DAO level.
 */
export const getNameChangeAggregation = <ThrowOnError extends boolean = false>(options: Options<GetNameChangeAggregationData, ThrowOnError>): RequestResult<GetNameChangeAggregationResponses, GetNameChangeAggregationErrors, ThrowOnError> => (options.client ?? client).get<GetNameChangeAggregationResponses, GetNameChangeAggregationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/payments/name-change', ...options });

/**
 * Get Name Change Drilldown
 *
 * Get name change drilldown transactions. Caching is handled at the DAO level.
 */
export const getNameChangeDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetNameChangeDrilldownData, ThrowOnError>): RequestResult<GetNameChangeDrilldownResponses, GetNameChangeDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetNameChangeDrilldownResponses, GetNameChangeDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/payments/name-change/drilldown', ...options });

/**
 * Export Name Change Drilldown
 *
 * Export all name change drilldown transactions as a styled Excel file.
 */
export const exportNameChangeDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportNameChangeDrilldownData, ThrowOnError>): RequestResult<ExportNameChangeDrilldownResponses, ExportNameChangeDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportNameChangeDrilldownResponses, ExportNameChangeDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/payments/name-change/drilldown/export', ...options });

/**
 * Get Changed Iban Aggregation
 *
 * Get changed IBAN aggregation data (all rows, no pagination).
 *
 * Pagination is intentionally omitted: the underlying query uses GROUPING SETS
 * which produces paired subtotal + detail rows per counterparty. SQL-level
 * OFFSET/FETCH pagination splits those groups across pages, causing the frontend
 * grouping logic to show incomplete groups (e.g. a party with 2 IBANs appears
 * to have only 1). Caching is handled at the DAO level.
 */
export const getChangedIbanAggregation = <ThrowOnError extends boolean = false>(options: Options<GetChangedIbanAggregationData, ThrowOnError>): RequestResult<GetChangedIbanAggregationResponses, GetChangedIbanAggregationErrors, ThrowOnError> => (options.client ?? client).get<GetChangedIbanAggregationResponses, GetChangedIbanAggregationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/payments/changed-iban', ...options });

/**
 * Get Changed Iban Drilldown
 *
 * Get changed IBAN drilldown transactions. Caching is handled at the DAO level.
 */
export const getChangedIbanDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetChangedIbanDrilldownData, ThrowOnError>): RequestResult<GetChangedIbanDrilldownResponses, GetChangedIbanDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetChangedIbanDrilldownResponses, GetChangedIbanDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/payments/changed-iban/drilldown', ...options });

/**
 * Export Changed Iban Drilldown
 *
 * Export all changed IBAN drilldown transactions as a styled Excel file.
 */
export const exportChangedIbanDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportChangedIbanDrilldownData, ThrowOnError>): RequestResult<ExportChangedIbanDrilldownResponses, ExportChangedIbanDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportChangedIbanDrilldownResponses, ExportChangedIbanDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/payments/changed-iban/drilldown/export', ...options });

/**
 * Get Special Description Aggregation
 *
 * Get special description aggregation data. Caching is handled at the DAO level.
 */
export const getSpecialDescriptionAggregation = <ThrowOnError extends boolean = false>(options: Options<GetSpecialDescriptionAggregationData, ThrowOnError>): RequestResult<GetSpecialDescriptionAggregationResponses, GetSpecialDescriptionAggregationErrors, ThrowOnError> => (options.client ?? client).get<GetSpecialDescriptionAggregationResponses, GetSpecialDescriptionAggregationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/payments/special-description', ...options });

/**
 * Get Special Description Drilldown
 *
 * Get special description drilldown transactions. Caching is handled at the DAO level.
 */
export const getSpecialDescriptionDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetSpecialDescriptionDrilldownData, ThrowOnError>): RequestResult<GetSpecialDescriptionDrilldownResponses, GetSpecialDescriptionDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetSpecialDescriptionDrilldownResponses, GetSpecialDescriptionDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/payments/special-description/drilldown', ...options });

/**
 * Export Notable Description Drilldown
 *
 * Export all notable description drilldown transactions as a styled Excel file.
 */
export const exportNotableDescriptionDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportNotableDescriptionDrilldownData, ThrowOnError>): RequestResult<ExportNotableDescriptionDrilldownResponses, ExportNotableDescriptionDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportNotableDescriptionDrilldownResponses, ExportNotableDescriptionDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/payments/special-description/drilldown/export', ...options });

/**
 * Get Cpi Payments Aggregation
 *
 * Get CPI Score Payments aggregation. Caching is handled at the DAO level.
 */
export const getCpiPaymentsAggregation = <ThrowOnError extends boolean = false>(options: Options<GetCpiPaymentsAggregationData, ThrowOnError>): RequestResult<GetCpiPaymentsAggregationResponses, GetCpiPaymentsAggregationErrors, ThrowOnError> => (options.client ?? client).get<GetCpiPaymentsAggregationResponses, GetCpiPaymentsAggregationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/wwft/payments/', ...options });

/**
 * Get Cpi Payments Drilldown
 *
 * Get CPI Payments drilldown transactions. Caching is handled at the DAO level.
 */
export const getCpiPaymentsDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetCpiPaymentsDrilldownData, ThrowOnError>): RequestResult<GetCpiPaymentsDrilldownResponses, GetCpiPaymentsDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetCpiPaymentsDrilldownResponses, GetCpiPaymentsDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/wwft/payments/drilldown', ...options });

/**
 * Export Cpi Payments Drilldown
 *
 * Export all CPI payments drilldown transactions as a styled Excel file.
 */
export const exportCpiPaymentsDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportCpiPaymentsDrilldownData, ThrowOnError>): RequestResult<ExportCpiPaymentsDrilldownResponses, ExportCpiPaymentsDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportCpiPaymentsDrilldownResponses, ExportCpiPaymentsDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/wwft/payments/drilldown/export', ...options });

/**
 * Get Cpi Receivements Aggregation
 *
 * Get CPI Score Receivements aggregation. Caching is handled at the DAO level.
 */
export const getCpiReceivementsAggregation = <ThrowOnError extends boolean = false>(options: Options<GetCpiReceivementsAggregationData, ThrowOnError>): RequestResult<GetCpiReceivementsAggregationResponses, GetCpiReceivementsAggregationErrors, ThrowOnError> => (options.client ?? client).get<GetCpiReceivementsAggregationResponses, GetCpiReceivementsAggregationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/wwft/receivements/', ...options });

/**
 * Get Cpi Receivements Drilldown
 *
 * Get CPI Receivements drilldown transactions. Caching is handled at the DAO level.
 */
export const getCpiReceivementsDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetCpiReceivementsDrilldownData, ThrowOnError>): RequestResult<GetCpiReceivementsDrilldownResponses, GetCpiReceivementsDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetCpiReceivementsDrilldownResponses, GetCpiReceivementsDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/wwft/receivements/drilldown', ...options });

/**
 * Export Cpi Received Drilldown
 *
 * Export all CPI received drilldown transactions as a styled Excel file.
 */
export const exportCpiReceivedDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportCpiReceivedDrilldownData, ThrowOnError>): RequestResult<ExportCpiReceivedDrilldownResponses, ExportCpiReceivedDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportCpiReceivedDrilldownResponses, ExportCpiReceivedDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/wwft/receivements/drilldown/export', ...options });

/**
 * Get Recurrent Payments Aggregation
 *
 * Get recurrent payments aggregation data. Caching is handled at the DAO level.
 */
export const getRecurrentPaymentsAggregation = <ThrowOnError extends boolean = false>(options: Options<GetRecurrentPaymentsAggregationData, ThrowOnError>): RequestResult<GetRecurrentPaymentsAggregationResponses, GetRecurrentPaymentsAggregationErrors, ThrowOnError> => (options.client ?? client).get<GetRecurrentPaymentsAggregationResponses, GetRecurrentPaymentsAggregationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/recurrent-payments', ...options });

/**
 * Get Recurrent Payments Drilldown
 *
 * Get recurrent payments drilldown transactions. Caching is handled at the DAO level.
 */
export const getRecurrentPaymentsDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetRecurrentPaymentsDrilldownData, ThrowOnError>): RequestResult<GetRecurrentPaymentsDrilldownResponses, GetRecurrentPaymentsDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetRecurrentPaymentsDrilldownResponses, GetRecurrentPaymentsDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/recurrent-payments/drilldown', ...options });

/**
 * Export Recurrent Payments Drilldown
 *
 * Export all recurrent payments drilldown rows as a styled Excel file.
 */
export const exportRecurrentPaymentsDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportRecurrentPaymentsDrilldownData, ThrowOnError>): RequestResult<ExportRecurrentPaymentsDrilldownResponses, ExportRecurrentPaymentsDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportRecurrentPaymentsDrilldownResponses, ExportRecurrentPaymentsDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/recurrent-payments/drilldown/export', ...options });

/**
 * Get Missing Iban Payments Aggregation
 *
 * Get missing IBAN aggregation data.
 *
 * Returns payments with missing or invalid IBAN information.
 * Caching is handled at the DAO level.
 */
export const getMissingIbanPaymentsAggregation = <ThrowOnError extends boolean = false>(options: Options<GetMissingIbanPaymentsAggregationData, ThrowOnError>): RequestResult<GetMissingIbanPaymentsAggregationResponses, GetMissingIbanPaymentsAggregationErrors, ThrowOnError> => (options.client ?? client).get<GetMissingIbanPaymentsAggregationResponses, GetMissingIbanPaymentsAggregationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/missing-iban-payments', ...options });

/**
 * Get Missing Iban Payments Drilldown
 *
 * Get missing IBAN drilldown transactions.
 *
 * Click-through from aggregation row by tc_description and payment_type.
 * Note: Missing IBAN drilldown has different columns than standard drilldown.
 * Caching is handled at the DAO level.
 */
export const getMissingIbanPaymentsDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetMissingIbanPaymentsDrilldownData, ThrowOnError>): RequestResult<GetMissingIbanPaymentsDrilldownResponses, GetMissingIbanPaymentsDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetMissingIbanPaymentsDrilldownResponses, GetMissingIbanPaymentsDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/missing-iban-payments/drilldown', ...options });

/**
 * Export Missing Iban Payments Drilldown
 *
 * Export all missing IBAN payments drilldown rows as a styled Excel file.
 */
export const exportMissingIbanPaymentsDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportMissingIbanPaymentsDrilldownData, ThrowOnError>): RequestResult<ExportMissingIbanPaymentsDrilldownResponses, ExportMissingIbanPaymentsDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportMissingIbanPaymentsDrilldownResponses, ExportMissingIbanPaymentsDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/missing-iban-payments/drilldown/export', ...options });

/**
 * Get Missing Iban Received Aggregation
 *
 * Get Receivements without IBAN aggregation. Caching is handled at the DAO level.
 */
export const getMissingIbanReceivedAggregation = <ThrowOnError extends boolean = false>(options: Options<GetMissingIbanReceivedAggregationData, ThrowOnError>): RequestResult<GetMissingIbanReceivedAggregationResponses, GetMissingIbanReceivedAggregationErrors, ThrowOnError> => (options.client ?? client).get<GetMissingIbanReceivedAggregationResponses, GetMissingIbanReceivedAggregationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/missing-iban-received/', ...options });

/**
 * Get Missing Iban Received Drilldown
 *
 * Get Receivements without IBAN drilldown transactions. Caching is handled at the DAO level.
 */
export const getMissingIbanReceivedDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetMissingIbanReceivedDrilldownData, ThrowOnError>): RequestResult<GetMissingIbanReceivedDrilldownResponses, GetMissingIbanReceivedDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetMissingIbanReceivedDrilldownResponses, GetMissingIbanReceivedDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/missing-iban-received/drilldown', ...options });

/**
 * Export Missing Iban Received Drilldown
 *
 * Export all missing IBAN received drilldown rows as a styled Excel file.
 */
export const exportMissingIbanReceivedDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportMissingIbanReceivedDrilldownData, ThrowOnError>): RequestResult<ExportMissingIbanReceivedDrilldownResponses, ExportMissingIbanReceivedDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportMissingIbanReceivedDrilldownResponses, ExportMissingIbanReceivedDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/missing-iban-received/drilldown/export', ...options });

/**
 * Get Week Vacation Days Aggregation
 *
 * Get week vacation days aggregation data for pivot table. Caching is handled at the DAO level.
 */
export const getWeekVacationDaysAggregation = <ThrowOnError extends boolean = false>(options: Options<GetWeekVacationDaysAggregationData, ThrowOnError>): RequestResult<GetWeekVacationDaysAggregationResponses, GetWeekVacationDaysAggregationErrors, ThrowOnError> => (options.client ?? client).get<GetWeekVacationDaysAggregationResponses, GetWeekVacationDaysAggregationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/week-vacation-days', ...options });

/**
 * Get Week Vacation Days Drilldown
 *
 * Get week vacation days drilldown transactions. Caching is handled at the DAO level.
 */
export const getWeekVacationDaysDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetWeekVacationDaysDrilldownData, ThrowOnError>): RequestResult<GetWeekVacationDaysDrilldownResponses, GetWeekVacationDaysDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetWeekVacationDaysDrilldownResponses, GetWeekVacationDaysDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/week-vacation-days/drilldown', ...options });

/**
 * Export Week Vacation Days Drilldown
 *
 * Export all week/vacation days drilldown rows as a styled Excel file.
 */
export const exportWeekVacationDaysDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportWeekVacationDaysDrilldownData, ThrowOnError>): RequestResult<ExportWeekVacationDaysDrilldownResponses, ExportWeekVacationDaysDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportWeekVacationDaysDrilldownResponses, ExportWeekVacationDaysDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/week-vacation-days/drilldown/export', ...options });

/**
 * Get Creditcard Statements Aggregation
 *
 * Get credit card statements aggregation data. Caching is handled at the DAO level.
 */
export const getCreditcardStatementsAggregation = <ThrowOnError extends boolean = false>(options: Options<GetCreditcardStatementsAggregationData, ThrowOnError>): RequestResult<GetCreditcardStatementsAggregationResponses, GetCreditcardStatementsAggregationErrors, ThrowOnError> => (options.client ?? client).get<GetCreditcardStatementsAggregationResponses, GetCreditcardStatementsAggregationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/creditcard-statements', ...options });

/**
 * Get Creditcard Statements Drilldown
 *
 * Get credit card statements drilldown transactions. Caching is handled at the DAO level.
 */
export const getCreditcardStatementsDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetCreditcardStatementsDrilldownData, ThrowOnError>): RequestResult<GetCreditcardStatementsDrilldownResponses, GetCreditcardStatementsDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetCreditcardStatementsDrilldownResponses, GetCreditcardStatementsDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/creditcard-statements/drilldown', ...options });

/**
 * Export Creditcard Statements Drilldown
 *
 * Export all credit card statements drilldown rows as a styled Excel file.
 */
export const exportCreditcardStatementsDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportCreditcardStatementsDrilldownData, ThrowOnError>): RequestResult<ExportCreditcardStatementsDrilldownResponses, ExportCreditcardStatementsDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportCreditcardStatementsDrilldownResponses, ExportCreditcardStatementsDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/creditcard-statements/drilldown/export', ...options });

/**
 * Get Iban Salary Other Payments Aggregation
 *
 * Get IBANs that received both salary and non-salary payments.
 */
export const getIbanSalaryOtherPaymentsAggregation = <ThrowOnError extends boolean = false>(options: Options<GetIbanSalaryOtherPaymentsAggregationData, ThrowOnError>): RequestResult<GetIbanSalaryOtherPaymentsAggregationResponses, GetIbanSalaryOtherPaymentsAggregationErrors, ThrowOnError> => (options.client ?? client).get<GetIbanSalaryOtherPaymentsAggregationResponses, GetIbanSalaryOtherPaymentsAggregationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/iban-salary-other-payments', ...options });

/**
 * Get Iban Salary Other Payments Drilldown
 *
 * Get non-salary drilldown transactions for a selected IBAN.
 */
export const getIbanSalaryOtherPaymentsDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetIbanSalaryOtherPaymentsDrilldownData, ThrowOnError>): RequestResult<GetIbanSalaryOtherPaymentsDrilldownResponses, GetIbanSalaryOtherPaymentsDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetIbanSalaryOtherPaymentsDrilldownResponses, GetIbanSalaryOtherPaymentsDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/iban-salary-other-payments/drilldown', ...options });

/**
 * Export Iban Salary Other Payments Drilldown
 *
 * Export all IBAN salary/other payments drilldown rows as a styled Excel file.
 */
export const exportIbanSalaryOtherPaymentsDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportIbanSalaryOtherPaymentsDrilldownData, ThrowOnError>): RequestResult<ExportIbanSalaryOtherPaymentsDrilldownResponses, ExportIbanSalaryOtherPaymentsDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportIbanSalaryOtherPaymentsDrilldownResponses, ExportIbanSalaryOtherPaymentsDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/iban-salary-other-payments/drilldown/export', ...options });

/**
 * Get Government Aggregation
 *
 * Get Government aggregation. Caching is handled at the DAO level.
 */
export const getGovernmentAggregation = <ThrowOnError extends boolean = false>(options: Options<GetGovernmentAggregationData, ThrowOnError>): RequestResult<GetGovernmentAggregationResponses, GetGovernmentAggregationErrors, ThrowOnError> => (options.client ?? client).get<GetGovernmentAggregationResponses, GetGovernmentAggregationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/government/', ...options });

/**
 * Get Government Drilldown
 *
 * Get Government drilldown transactions. Caching is handled at the DAO level.
 */
export const getGovernmentDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetGovernmentDrilldownData, ThrowOnError>): RequestResult<GetGovernmentDrilldownResponses, GetGovernmentDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetGovernmentDrilldownResponses, GetGovernmentDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/government/drilldown', ...options });

/**
 * Export Government Drilldown
 *
 * Export all government payments drilldown rows as a styled Excel file.
 */
export const exportGovernmentDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportGovernmentDrilldownData, ThrowOnError>): RequestResult<ExportGovernmentDrilldownResponses, ExportGovernmentDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportGovernmentDrilldownResponses, ExportGovernmentDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/government/drilldown/export', ...options });

/**
 * Get Intercompany Payments Aggregation
 *
 * Get Intercompany Payments aggregation. Caching is handled at the DAO level.
 */
export const getIntercompanyPaymentsAggregation = <ThrowOnError extends boolean = false>(options: Options<GetIntercompanyPaymentsAggregationData, ThrowOnError>): RequestResult<GetIntercompanyPaymentsAggregationResponses, GetIntercompanyPaymentsAggregationErrors, ThrowOnError> => (options.client ?? client).get<GetIntercompanyPaymentsAggregationResponses, GetIntercompanyPaymentsAggregationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/intercompany-payments/', ...options });

/**
 * Get Intercompany Payments Drilldown
 *
 * Get Intercompany Payments drilldown transactions. Caching is handled at the DAO level.
 */
export const getIntercompanyPaymentsDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetIntercompanyPaymentsDrilldownData, ThrowOnError>): RequestResult<GetIntercompanyPaymentsDrilldownResponses, GetIntercompanyPaymentsDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetIntercompanyPaymentsDrilldownResponses, GetIntercompanyPaymentsDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/intercompany-payments/drilldown', ...options });

/**
 * Export Intercompany Payments Drilldown
 *
 * Export all intercompany payments drilldown rows as a styled Excel file.
 */
export const exportIntercompanyPaymentsDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportIntercompanyPaymentsDrilldownData, ThrowOnError>): RequestResult<ExportIntercompanyPaymentsDrilldownResponses, ExportIntercompanyPaymentsDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportIntercompanyPaymentsDrilldownResponses, ExportIntercompanyPaymentsDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/intercompany-payments/drilldown/export', ...options });

/**
 * Get Same Iban Transactions Aggregation
 *
 * Get Same IBAN aggregation. Caching is handled at the DAO level.
 */
export const getSameIbanTransactionsAggregation = <ThrowOnError extends boolean = false>(options: Options<GetSameIbanTransactionsAggregationData, ThrowOnError>): RequestResult<GetSameIbanTransactionsAggregationResponses, GetSameIbanTransactionsAggregationErrors, ThrowOnError> => (options.client ?? client).get<GetSameIbanTransactionsAggregationResponses, GetSameIbanTransactionsAggregationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/same-iban-transactions/', ...options });

/**
 * Get Same Iban Transactions Drilldown
 *
 * Get Same IBAN drilldown transactions. Caching is handled at the DAO level.
 */
export const getSameIbanTransactionsDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetSameIbanTransactionsDrilldownData, ThrowOnError>): RequestResult<GetSameIbanTransactionsDrilldownResponses, GetSameIbanTransactionsDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetSameIbanTransactionsDrilldownResponses, GetSameIbanTransactionsDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/same-iban-transactions/drilldown', ...options });

/**
 * Export Same Iban Transactions Drilldown
 *
 * Export all same-IBAN drilldown rows as a styled Excel file.
 */
export const exportSameIbanTransactionsDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportSameIbanTransactionsDrilldownData, ThrowOnError>): RequestResult<ExportSameIbanTransactionsDrilldownResponses, ExportSameIbanTransactionsDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportSameIbanTransactionsDrilldownResponses, ExportSameIbanTransactionsDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/same-iban-transactions/drilldown/export', ...options });

/**
 * Get Foreign Currency Aggregation
 *
 * Get Foreign Currency Transactions aggregation.
 *
 * Caching is handled automatically by the DAO layer.
 */
export const getForeignCurrencyAggregation = <ThrowOnError extends boolean = false>(options: Options<GetForeignCurrencyAggregationData, ThrowOnError>): RequestResult<GetForeignCurrencyAggregationResponses, GetForeignCurrencyAggregationErrors, ThrowOnError> => (options.client ?? client).get<GetForeignCurrencyAggregationResponses, GetForeignCurrencyAggregationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/foreign-currency/', ...options });

/**
 * Get Foreign Currency Drilldown
 *
 * Get Foreign Currency Transactions drilldown.
 *
 * Caching is handled automatically by the DAO layer.
 */
export const getForeignCurrencyDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetForeignCurrencyDrilldownData, ThrowOnError>): RequestResult<GetForeignCurrencyDrilldownResponses, GetForeignCurrencyDrilldownErrors, ThrowOnError> => (options.client ?? client).get<GetForeignCurrencyDrilldownResponses, GetForeignCurrencyDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/foreign-currency/drilldown', ...options });

/**
 * Export Foreign Currency Drilldown
 *
 * Export all foreign currency drilldown rows as a styled Excel file.
 */
export const exportForeignCurrencyDrilldown = <ThrowOnError extends boolean = false>(options: Options<ExportForeignCurrencyDrilldownData, ThrowOnError>): RequestResult<ExportForeignCurrencyDrilldownResponses, ExportForeignCurrencyDrilldownErrors, ThrowOnError> => (options.client ?? client).get<ExportForeignCurrencyDrilldownResponses, ExportForeignCurrencyDrilldownErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/agbw/output/miscellaneous/foreign-currency/drilldown/export', ...options });

/**
 * Get Multiple Ibans Per Kvk
 *
 * Return complete KvK groups after scoped filtering, sorting, and pagination.
 */
export const getMultipleIbansPerKvk = <ThrowOnError extends boolean = false>(options: Options<GetMultipleIbansPerKvkData, ThrowOnError>): RequestResult<GetMultipleIbansPerKvkResponses, GetMultipleIbansPerKvkErrors, ThrowOnError> => (options.client ?? client).get<GetMultipleIbansPerKvkResponses, GetMultipleIbansPerKvkErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/continuous-auditor/results/multiple-ibans-per-kvk', ...options });

/**
 * Get Possible Duplicate Payments
 *
 * Return complete counterparty-IBAN groups for possible duplicate payments.
 */
export const getPossibleDuplicatePayments = <ThrowOnError extends boolean = false>(options: Options<GetPossibleDuplicatePaymentsData, ThrowOnError>): RequestResult<GetPossibleDuplicatePaymentsResponses, GetPossibleDuplicatePaymentsErrors, ThrowOnError> => (options.client ?? client).get<GetPossibleDuplicatePaymentsResponses, GetPossibleDuplicatePaymentsErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/continuous-auditor/results/possible-duplicate-payments', ...options });

/**
 * Get Unique Counterparties Multiple Ibans
 *
 * Return complete counterparty-name groups that contain multiple IBANs.
 */
export const getUniqueCounterpartiesMultipleIbans = <ThrowOnError extends boolean = false>(options: Options<GetUniqueCounterpartiesMultipleIbansData, ThrowOnError>): RequestResult<GetUniqueCounterpartiesMultipleIbansResponses, GetUniqueCounterpartiesMultipleIbansErrors, ThrowOnError> => (options.client ?? client).get<GetUniqueCounterpartiesMultipleIbansResponses, GetUniqueCounterpartiesMultipleIbansErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/continuous-auditor/results/unique-counterparties-multiple-ibans', ...options });

/**
 * Get Payment Types
 *
 * Return a flat physical-row page of payment-type hierarchy results.
 */
export const getPaymentTypes = <ThrowOnError extends boolean = false>(options: Options<GetPaymentTypesData, ThrowOnError>): RequestResult<GetPaymentTypesResponses, GetPaymentTypesErrors, ThrowOnError> => (options.client ?? client).get<GetPaymentTypesResponses, GetPaymentTypesErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/continuous-auditor/results/payment-types', ...options });

/**
 * Get Dashboard Filter Values
 *
 * Return company/year-scoped values for one of the four dashboard tables.
 */
export const getDashboardFilterValues = <ThrowOnError extends boolean = false>(options: Options<GetDashboardFilterValuesData, ThrowOnError>): RequestResult<GetDashboardFilterValuesResponses, GetDashboardFilterValuesErrors, ThrowOnError> => (options.client ?? client).get<GetDashboardFilterValuesResponses, GetDashboardFilterValuesErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/continuous-auditor/results/filter-values', ...options });

/**
 * Get Transactions
 *
 * Return individual transactions scoped to the authorized company's booking year.
 */
export const getTransactions = <ThrowOnError extends boolean = false>(options: Options<GetTransactionsData, ThrowOnError>): RequestResult<GetTransactionsResponses, GetTransactionsErrors, ThrowOnError> => (options.client ?? client).get<GetTransactionsResponses, GetTransactionsErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/continuous-auditor/results/transactions', ...options });

/**
 * Get Transaction Overview
 *
 * Return flat or complete grouped transactions with all matching currency totals.
 */
export const getTransactionOverview = <ThrowOnError extends boolean = false>(options: Options<GetTransactionOverviewData, ThrowOnError>): RequestResult<GetTransactionOverviewResponses, GetTransactionOverviewErrors, ThrowOnError> => (options.client ?? client).post<GetTransactionOverviewResponses, GetTransactionOverviewErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/{project_id}/continuous-auditor/results/transactions/overview',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Transaction Drilldown
 *
 * Inspect rows contributing to a selected aggregate under the same project permission.
 */
export const getTransactionDrilldown = <ThrowOnError extends boolean = false>(options: Options<GetTransactionDrilldownData, ThrowOnError>): RequestResult<GetTransactionDrilldownResponses, GetTransactionDrilldownErrors, ThrowOnError> => (options.client ?? client).post<GetTransactionDrilldownResponses, GetTransactionDrilldownErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/{project_id}/continuous-auditor/results/transactions/drilldown',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Transaction Filter Values
 *
 * List exact available column values within the authorized company and booking year.
 */
export const getTransactionFilterValues = <ThrowOnError extends boolean = false>(options: Options<GetTransactionFilterValuesData, ThrowOnError>): RequestResult<GetTransactionFilterValuesResponses, GetTransactionFilterValuesErrors, ThrowOnError> => (options.client ?? client).post<GetTransactionFilterValuesResponses, GetTransactionFilterValuesErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/{project_id}/continuous-auditor/results/transactions/filter-values',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Export Continuous Auditor Transactions
 *
 * Download every filtered result, with supporting transactions for aggregations.
 */
export const exportContinuousAuditorTransactions = <ThrowOnError extends boolean = false>(options: Options<ExportContinuousAuditorTransactionsData, ThrowOnError>): RequestResult<ExportContinuousAuditorTransactionsResponses, ExportContinuousAuditorTransactionsErrors, ThrowOnError> => (options.client ?? client).post<ExportContinuousAuditorTransactionsResponses, ExportContinuousAuditorTransactionsErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/{project_id}/continuous-auditor/results/transactions/export',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Run Refresh Afas Data Pipeline
 */
export const runRefreshAfasDataPipeline = <ThrowOnError extends boolean = false>(options: Options<RunRefreshAfasDataPipelineData, ThrowOnError>): RequestResult<RunRefreshAfasDataPipelineResponses, RunRefreshAfasDataPipelineErrors, ThrowOnError> => (options.client ?? client).post<RunRefreshAfasDataPipelineResponses, RunRefreshAfasDataPipelineErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/afas/refresh', ...options });

/**
 * Get Refresh Afas Data Pipeline Status
 */
export const getRefreshAfasDataPipelineStatus = <ThrowOnError extends boolean = false>(options: Options<GetRefreshAfasDataPipelineStatusData, ThrowOnError>): RequestResult<GetRefreshAfasDataPipelineStatusResponses, GetRefreshAfasDataPipelineStatusErrors, ThrowOnError> => (options.client ?? client).get<GetRefreshAfasDataPipelineStatusResponses, GetRefreshAfasDataPipelineStatusErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/afas/refresh/status', ...options });

/**
 * Run Continuous Auditor Refresh Pipeline
 *
 * Accept a company refresh; the existing Fabric queue dispatches it asynchronously.
 */
export const runContinuousAuditorRefreshPipeline = <ThrowOnError extends boolean = false>(options: Options<RunContinuousAuditorRefreshPipelineData, ThrowOnError>): RequestResult<RunContinuousAuditorRefreshPipelineResponses, RunContinuousAuditorRefreshPipelineErrors, ThrowOnError> => (options.client ?? client).post<RunContinuousAuditorRefreshPipelineResponses, RunContinuousAuditorRefreshPipelineErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/continuous-auditor/refresh', ...options });

/**
 * Get Continuous Auditor Refresh Pipeline Status
 *
 * Read refresh progress without granting permission to trigger a pipeline.
 */
export const getContinuousAuditorRefreshPipelineStatus = <ThrowOnError extends boolean = false>(options: Options<GetContinuousAuditorRefreshPipelineStatusData, ThrowOnError>): RequestResult<GetContinuousAuditorRefreshPipelineStatusResponses, GetContinuousAuditorRefreshPipelineStatusErrors, ThrowOnError> => (options.client ?? client).get<GetContinuousAuditorRefreshPipelineStatusResponses, GetContinuousAuditorRefreshPipelineStatusErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/continuous-auditor/refresh/status', ...options });

/**
 * Get Active Project Pipeline
 *
 * Return an execution still blocking this project's mutations, or null.
 *
 * Costs one query and no Fabric call when nothing is running. Otherwise each
 * candidate is refreshed in turn until one is still non-terminal; refreshing
 * the newest can reveal it has just finished, and stopping there would report
 * "idle" while an older run still blocks the project.
 */
export const getActiveProjectPipeline = <ThrowOnError extends boolean = false>(options: Options<GetActiveProjectPipelineData, ThrowOnError>): RequestResult<GetActiveProjectPipelineResponses, GetActiveProjectPipelineErrors, ThrowOnError> => (options.client ?? client).get<GetActiveProjectPipelineResponses, GetActiveProjectPipelineErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/client/{project_id}/pipelines/active', ...options });

/**
 * Set Pipeline Execution Status
 *
 * Repair an app-side execution status without cancelling the Fabric run.
 *
 * This superuser-only operation changes the stored application status so a
 * stale execution no longer blocks its project. It does not contact Fabric
 * or cancel an upstream Fabric job.
 */
export const setPipelineExecutionStatus = <ThrowOnError extends boolean = false>(options: Options<SetPipelineExecutionStatusData, ThrowOnError>): RequestResult<SetPipelineExecutionStatusResponses, SetPipelineExecutionStatusErrors, ThrowOnError> => (options.client ?? client).put<SetPipelineExecutionStatusResponses, SetPipelineExecutionStatusErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/client/{project_id}/pipelines/executions/{execution_id}/status',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Export Audit Reconciliation
 *
 * Queue the fiscal-year ledger and linked journals in one Data Platform export.
 */
export const exportAuditReconciliation = <ThrowOnError extends boolean = false>(options: Options<ExportAuditReconciliationData, ThrowOnError>): RequestResult<ExportAuditReconciliationResponses, ExportAuditReconciliationErrors, ThrowOnError> => (options.client ?? client).post<ExportAuditReconciliationResponses, ExportAuditReconciliationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/reconciliation/export', ...options });

/**
 * Get Audit Reconciliation Export Status
 *
 * Read combined-export status for the project's current classification bindings.
 */
export const getAuditReconciliationExportStatus = <ThrowOnError extends boolean = false>(options: Options<GetAuditReconciliationExportStatusData, ThrowOnError>): RequestResult<GetAuditReconciliationExportStatusResponses, GetAuditReconciliationExportStatusErrors, ThrowOnError> => (options.client ?? client).get<GetAuditReconciliationExportStatusResponses, GetAuditReconciliationExportStatusErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/reconciliation/export/status', ...options });

/**
 * Export Audit Reconciliation Excel
 *
 * Download selected displayed reconciliations without changing persisted state.
 */
export const exportAuditReconciliationExcel = <ThrowOnError extends boolean = false>(options: Options<ExportAuditReconciliationExcelData, ThrowOnError>): RequestResult<ExportAuditReconciliationExcelResponses, ExportAuditReconciliationExcelErrors, ThrowOnError> => (options.client ?? client).post<ExportAuditReconciliationExcelResponses, ExportAuditReconciliationExcelErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/{project_id}/reconciliation/export/excel',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Start Audit Statement Extraction
 *
 * Queue balance sheet and profit-and-loss extraction for the current report.
 */
export const startAuditStatementExtraction = <ThrowOnError extends boolean = false>(options: Options<StartAuditStatementExtractionData, ThrowOnError>): RequestResult<StartAuditStatementExtractionResponses, StartAuditStatementExtractionErrors, ThrowOnError> => (options.client ?? client).post<StartAuditStatementExtractionResponses, StartAuditStatementExtractionErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/statement-extraction/runs', ...options });

/**
 * Latest Audit Statement Extraction
 *
 * Return the audit dossier's current extraction run.
 */
export const latestAuditStatementExtraction = <ThrowOnError extends boolean = false>(options: Options<LatestAuditStatementExtractionData, ThrowOnError>): RequestResult<LatestAuditStatementExtractionResponses, LatestAuditStatementExtractionErrors, ThrowOnError> => (options.client ?? client).get<LatestAuditStatementExtractionResponses, LatestAuditStatementExtractionErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/statement-extraction/runs/latest', ...options });

/**
 * Latest Audit Statement Reference Reconciliation
 *
 * Return T-1 report-to-report checks when both independent sides exist.
 */
export const latestAuditStatementReferenceReconciliation = <ThrowOnError extends boolean = false>(options: Options<LatestAuditStatementReferenceReconciliationData, ThrowOnError>): RequestResult<LatestAuditStatementReferenceReconciliationResponses, LatestAuditStatementReferenceReconciliationErrors, ThrowOnError> => (options.client ?? client).get<LatestAuditStatementReferenceReconciliationResponses, LatestAuditStatementReferenceReconciliationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/statement-extraction/runs/reference-reconciliation/latest', ...options });

/**
 * Latest Audit Budget Reconciliation
 *
 * Return optional P&L budget values and their variance from actuals.
 */
export const latestAuditBudgetReconciliation = <ThrowOnError extends boolean = false>(options: Options<LatestAuditBudgetReconciliationData, ThrowOnError>): RequestResult<LatestAuditBudgetReconciliationResponses, LatestAuditBudgetReconciliationErrors, ThrowOnError> => (options.client ?? client).get<LatestAuditBudgetReconciliationResponses, LatestAuditBudgetReconciliationErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/statement-extraction/runs/budget-reconciliation/latest', ...options });

/**
 * Latest Audit Statement Extraction Jobs
 *
 * Return source-bound current and previous background job state.
 */
export const latestAuditStatementExtractionJobs = <ThrowOnError extends boolean = false>(options: Options<LatestAuditStatementExtractionJobsData, ThrowOnError>): RequestResult<LatestAuditStatementExtractionJobsResponses, LatestAuditStatementExtractionJobsErrors, ThrowOnError> => (options.client ?? client).get<LatestAuditStatementExtractionJobsResponses, LatestAuditStatementExtractionJobsErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/statement-extraction/runs/jobs/latest', ...options });

/**
 * Start Audit Previous Report Extraction
 *
 * Queue extraction of the linked previous annual report.
 */
export const startAuditPreviousReportExtraction = <ThrowOnError extends boolean = false>(options: Options<StartAuditPreviousReportExtractionData, ThrowOnError>): RequestResult<StartAuditPreviousReportExtractionResponses, StartAuditPreviousReportExtractionErrors, ThrowOnError> => (options.client ?? client).post<StartAuditPreviousReportExtractionResponses, StartAuditPreviousReportExtractionErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/statement-extraction/runs/reference-reconciliation', ...options });

/**
 * Restart Audit Statement Extraction Job
 *
 * Requeue one current-source job after validating its report and taxonomy.
 */
export const restartAuditStatementExtractionJob = <ThrowOnError extends boolean = false>(options: Options<RestartAuditStatementExtractionJobData, ThrowOnError>): RequestResult<RestartAuditStatementExtractionJobResponses, RestartAuditStatementExtractionJobErrors, ThrowOnError> => (options.client ?? client).post<RestartAuditStatementExtractionJobResponses, RestartAuditStatementExtractionJobErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/statement-extraction/runs/jobs/{job_id}/restart', ...options });

/**
 * Replace Audit Previous Report Stage
 *
 * Save one complete T-1 statement and its reported controls.
 */
export const replaceAuditPreviousReportStage = <ThrowOnError extends boolean = false>(options: Options<ReplaceAuditPreviousReportStageData, ThrowOnError>): RequestResult<ReplaceAuditPreviousReportStageResponses, ReplaceAuditPreviousReportStageErrors, ThrowOnError> => (options.client ?? client).put<ReplaceAuditPreviousReportStageResponses, ReplaceAuditPreviousReportStageErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/{project_id}/statement-extraction/runs/reference-reconciliation/{run_id}/stages/{stage}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Confirm Audit Previous Report Stage
 *
 * Confirm one T-1 statement after its controls pass.
 */
export const confirmAuditPreviousReportStage = <ThrowOnError extends boolean = false>(options: Options<ConfirmAuditPreviousReportStageData, ThrowOnError>): RequestResult<ConfirmAuditPreviousReportStageResponses, ConfirmAuditPreviousReportStageErrors, ThrowOnError> => (options.client ?? client).post<ConfirmAuditPreviousReportStageResponses, ConfirmAuditPreviousReportStageErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/statement-extraction/runs/reference-reconciliation/{run_id}/stages/{stage}/confirm', ...options });

/**
 * Deconfirm Audit Previous Report Stage
 *
 * Return one confirmed T-1 statement to review.
 */
export const deconfirmAuditPreviousReportStage = <ThrowOnError extends boolean = false>(options: Options<DeconfirmAuditPreviousReportStageData, ThrowOnError>): RequestResult<DeconfirmAuditPreviousReportStageResponses, DeconfirmAuditPreviousReportStageErrors, ThrowOnError> => (options.client ?? client).post<DeconfirmAuditPreviousReportStageResponses, DeconfirmAuditPreviousReportStageErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/statement-extraction/runs/reference-reconciliation/{run_id}/stages/{stage}/deconfirm', ...options });

/**
 * Replace Audit Statement Extraction Stage
 *
 * Replace one complete fixed-statement snapshot.
 */
export const replaceAuditStatementExtractionStage = <ThrowOnError extends boolean = false>(options: Options<ReplaceAuditStatementExtractionStageData, ThrowOnError>): RequestResult<ReplaceAuditStatementExtractionStageResponses, ReplaceAuditStatementExtractionStageErrors, ThrowOnError> => (options.client ?? client).put<ReplaceAuditStatementExtractionStageResponses, ReplaceAuditStatementExtractionStageErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/{project_id}/statement-extraction/runs/{run_id}/stages/{stage}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Replace Audit Statement Extraction Categories
 *
 * Save a complete review snapshot, preserving references for moved Level 2 categories.
 *
 * Targets must be existing empty categories in the same statement/sign section.
 * Source categories must be cleared in the supplied snapshot. Confirmation and
 * latest-run locks follow the regular stage replacement contract.
 */
export const replaceAuditStatementExtractionCategories = <ThrowOnError extends boolean = false>(options: Options<ReplaceAuditStatementExtractionCategoriesData, ThrowOnError>): RequestResult<ReplaceAuditStatementExtractionCategoriesResponses, ReplaceAuditStatementExtractionCategoriesErrors, ThrowOnError> => (options.client ?? client).put<ReplaceAuditStatementExtractionCategoriesResponses, ReplaceAuditStatementExtractionCategoriesErrors, ThrowOnError>({
  url: '/organization/{org_id}/audit/{project_id}/statement-extraction/runs/{run_id}/stages/{stage}/categories',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Confirm Audit Statement Extraction Stage
 *
 * Confirm one audit statement independently after its controls pass.
 */
export const confirmAuditStatementExtractionStage = <ThrowOnError extends boolean = false>(options: Options<ConfirmAuditStatementExtractionStageData, ThrowOnError>): RequestResult<ConfirmAuditStatementExtractionStageResponses, ConfirmAuditStatementExtractionStageErrors, ThrowOnError> => (options.client ?? client).post<ConfirmAuditStatementExtractionStageResponses, ConfirmAuditStatementExtractionStageErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/statement-extraction/runs/{run_id}/stages/{stage}/confirm', ...options });

/**
 * Deconfirm Audit Statement Extraction Stage
 *
 * Return one confirmed audit statement to review.
 */
export const deconfirmAuditStatementExtractionStage = <ThrowOnError extends boolean = false>(options: Options<DeconfirmAuditStatementExtractionStageData, ThrowOnError>): RequestResult<DeconfirmAuditStatementExtractionStageResponses, DeconfirmAuditStatementExtractionStageErrors, ThrowOnError> => (options.client ?? client).post<DeconfirmAuditStatementExtractionStageResponses, DeconfirmAuditStatementExtractionStageErrors, ThrowOnError>({ url: '/organization/{org_id}/audit/{project_id}/statement-extraction/runs/{run_id}/stages/{stage}/deconfirm', ...options });

/**
 * Delete Audit Files
 *
 * Delete specific audit files from a folder.
 */
export const deleteAuditFiles = <ThrowOnError extends boolean = false>(options: Options<DeleteAuditFilesData, ThrowOnError>): RequestResult<DeleteAuditFilesResponses, DeleteAuditFilesErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAuditFilesResponses, DeleteAuditFilesErrors, ThrowOnError>({
  url: '/organization/{org_id}/project/{project_id}/audit-files',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * List Audit Files
 *
 * List all audit files in a folder.
 */
export const listAuditFiles = <ThrowOnError extends boolean = false>(options: Options<ListAuditFilesData, ThrowOnError>): RequestResult<ListAuditFilesResponses, ListAuditFilesErrors, ThrowOnError> => (options.client ?? client).get<ListAuditFilesResponses, ListAuditFilesErrors, ThrowOnError>({ url: '/organization/{org_id}/project/{project_id}/audit-files', ...options });

/**
 * Upload Audit Files
 *
 * Upload audit files to Fabric; processing is started through the run endpoint.
 */
export const uploadAuditFiles = <ThrowOnError extends boolean = false>(options: Options<UploadAuditFilesData, ThrowOnError>): RequestResult<UploadAuditFilesResponses, UploadAuditFilesErrors, ThrowOnError> => (options.client ?? client).post<UploadAuditFilesResponses, UploadAuditFilesErrors, ThrowOnError>({
  url: '/organization/{org_id}/project/{project_id}/audit-files',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Copy Audit Files From Previous Dossier
 *
 * Copy the previous dossier's own-year FA upload into the destination's prior year.
 *
 * Both dossiers must belong to the same client. The destination must be open
 * and have an empty prior-year FA slot. Both storage layouts are supported.
 * The caller needs read access to the source and upload access to the destination.
 * Copies are independent; start processing separately through the existing run endpoint.
 * If booking_year is supplied, it must equal the destination dossier year minus one.
 */
export const copyAuditFilesFromPreviousDossier = <ThrowOnError extends boolean = false>(options: Options<CopyAuditFilesFromPreviousDossierData, ThrowOnError>): RequestResult<CopyAuditFilesFromPreviousDossierResponses, CopyAuditFilesFromPreviousDossierErrors, ThrowOnError> => (options.client ?? client).post<CopyAuditFilesFromPreviousDossierResponses, CopyAuditFilesFromPreviousDossierErrors, ThrowOnError>({ url: '/organization/{org_id}/project/{project_id}/audit-files/copy-from/{source_project_id}', ...options });

/**
 * Download Audit File
 *
 * Stream one uploaded audit file from Fabric.
 */
export const downloadAuditFile = <ThrowOnError extends boolean = false>(options: Options<DownloadAuditFileData, ThrowOnError>): RequestResult<DownloadAuditFileResponses, DownloadAuditFileErrors, ThrowOnError> => (options.client ?? client).get<DownloadAuditFileResponses, DownloadAuditFileErrors, ThrowOnError>({ url: '/organization/{org_id}/project/{project_id}/audit-files/download/{filename}', ...options });

/**
 * Run Refresh Audit File Pipeline
 *
 * Trigger audit-file processing for the resolved project scope.
 */
export const runRefreshAuditFilePipeline = <ThrowOnError extends boolean = false>(options: Options<RunRefreshAuditFilePipelineData, ThrowOnError>): RequestResult<RunRefreshAuditFilePipelineResponses, RunRefreshAuditFilePipelineErrors, ThrowOnError> => (options.client ?? client).post<RunRefreshAuditFilePipelineResponses, RunRefreshAuditFilePipelineErrors, ThrowOnError>({ url: '/organization/{org_id}/project/{project_id}/audit-files/run', ...options });

/**
 * Get Refresh Audit File Pipeline Status
 *
 * Return audit-file processing status for the resolved project scope.
 */
export const getRefreshAuditFilePipelineStatus = <ThrowOnError extends boolean = false>(options: Options<GetRefreshAuditFilePipelineStatusData, ThrowOnError>): RequestResult<GetRefreshAuditFilePipelineStatusResponses, GetRefreshAuditFilePipelineStatusErrors, ThrowOnError> => (options.client ?? client).get<GetRefreshAuditFilePipelineStatusResponses, GetRefreshAuditFilePipelineStatusErrors, ThrowOnError>({ url: '/organization/{org_id}/project/{project_id}/audit-files/status', ...options });

/**
 * Get Project Audit File Gl Coverage
 *
 * Report transaction output presence for the project's accepted upload years.
 */
export const getProjectAuditFileGlCoverage = <ThrowOnError extends boolean = false>(options: Options<GetProjectAuditFileGlCoverageData, ThrowOnError>): RequestResult<GetProjectAuditFileGlCoverageResponses, GetProjectAuditFileGlCoverageErrors, ThrowOnError> => (options.client ?? client).get<GetProjectAuditFileGlCoverageResponses, GetProjectAuditFileGlCoverageErrors, ThrowOnError>({ url: '/organization/{org_id}/project/{project_id}/audit-files/gl-coverage', ...options });

/**
 * Request Upload Urls
 *
 * Generate SAS URLs for direct client upload of one or more files.
 */
export const requestUploadUrls = <ThrowOnError extends boolean = false>(options: Options<RequestUploadUrlsData, ThrowOnError>): RequestResult<RequestUploadUrlsResponses, RequestUploadUrlsErrors, ThrowOnError> => (options.client ?? client).post<RequestUploadUrlsResponses, RequestUploadUrlsErrors, ThrowOnError>({
  url: '/file/upload/request-urls',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Confirm Upload
 *
 * Confirm multiple direct uploads.
 */
export const confirmUpload = <ThrowOnError extends boolean = false>(options: Options<ConfirmUploadData, ThrowOnError>): RequestResult<ConfirmUploadResponses, ConfirmUploadErrors, ThrowOnError> => (options.client ?? client).post<ConfirmUploadResponses, ConfirmUploadErrors, ThrowOnError>({
  url: '/file/upload/confirm',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Organization File
 */
export const getOrganizationFile = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationFileData, ThrowOnError>): RequestResult<GetOrganizationFileResponses, GetOrganizationFileErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationFileResponses, GetOrganizationFileErrors, ThrowOnError>({ url: '/file/{organization_id}/{blob_name}', ...options });

/**
 * Delete Organization File
 *
 * Delete a file from organization's blob storage.
 *
 * The blob_name is normalized to the organization's storage prefix before checks.
 *
 * Args:
 *     organization_id: The organization ID from the path.
 *     blob_name: The blob path relative to the organization prefix.
 *     organization: The current user's organization (from dependency).
 *     file_service: The file service instance.
 *
 * Returns:
 *     dict: Confirmation message.
 *
 * Raises:
 *     FileForbiddenException: If organization mismatch or file doesn't belong to org.
 *     FileNotFoundException: If file not found.
 *     FileDeleteException: If deletion fails.
 */
export const deleteOrganizationFile = <ThrowOnError extends boolean = false>(options: Options<DeleteOrganizationFileData, ThrowOnError>): RequestResult<DeleteOrganizationFileResponses, DeleteOrganizationFileErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOrganizationFileResponses, DeleteOrganizationFileErrors, ThrowOnError>({ url: '/file/{organization_id}/delete/{blob_name}', ...options });

/**
 * Create Feedback
 */
export const createFeedback = <ThrowOnError extends boolean = false>(options: Options<CreateFeedbackData, ThrowOnError>): RequestResult<CreateFeedbackResponses, CreateFeedbackErrors, ThrowOnError> => (options.client ?? client).post<CreateFeedbackResponses, CreateFeedbackErrors, ThrowOnError>({
  url: '/feedback/',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * New Message Feedback
 *
 * Submits feedback for a chat message.
 *
 * Args:
 *     user: The authenticated user submitting feedback.
 *     data: Feedback data including message_id, rating, and text.
 *     session: Database session.
 *
 * Returns:
 *     InChatFeedback: The created or updated feedback.
 *
 * Raises:
 *     MessageFeedbackNotFoundException: If the message is not part of a
 *         conversation the caller owns.
 */
export const newMessageFeedback = <ThrowOnError extends boolean = false>(options: Options<NewMessageFeedbackData, ThrowOnError>): RequestResult<NewMessageFeedbackResponses, NewMessageFeedbackErrors, ThrowOnError> => (options.client ?? client).post<NewMessageFeedbackResponses, NewMessageFeedbackErrors, ThrowOnError>({
  url: '/feedback/message/feedback',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Prompt Library
 *
 * List one prompt library tab, paged out of the relation the caller may read.
 */
export const getPromptLibrary = <ThrowOnError extends boolean = false>(options: Options<GetPromptLibraryData, ThrowOnError>): RequestResult<GetPromptLibraryResponses, GetPromptLibraryErrors, ThrowOnError> => (options.client ?? client).get<GetPromptLibraryResponses, GetPromptLibraryErrors, ThrowOnError>({ url: '/prompt-library', ...options });

/**
 * Create Prompt
 *
 * Create a personal prompt owned by the caller.
 */
export const createPrompt = <ThrowOnError extends boolean = false>(options: Options<CreatePromptData, ThrowOnError>): RequestResult<CreatePromptResponses, CreatePromptErrors, ThrowOnError> => (options.client ?? client).post<CreatePromptResponses, CreatePromptErrors, ThrowOnError>({
  url: '/prompt-library',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Prompt
 *
 * Delete a prompt the caller may delete.
 */
export const deletePrompt = <ThrowOnError extends boolean = false>(options: Options<DeletePromptData, ThrowOnError>): RequestResult<DeletePromptResponses, DeletePromptErrors, ThrowOnError> => (options.client ?? client).delete<DeletePromptResponses, DeletePromptErrors, ThrowOnError>({ url: '/prompt-library/{prompt_id}', ...options });

/**
 * Get Prompt
 *
 * Read one prompt the caller may see.
 */
export const getPrompt = <ThrowOnError extends boolean = false>(options: Options<GetPromptData, ThrowOnError>): RequestResult<GetPromptResponses, GetPromptErrors, ThrowOnError> => (options.client ?? client).get<GetPromptResponses, GetPromptErrors, ThrowOnError>({ url: '/prompt-library/{prompt_id}', ...options });

/**
 * Update Prompt
 *
 * Replace a prompt's text, name, tags and datasource links.
 */
export const updatePrompt = <ThrowOnError extends boolean = false>(options: Options<UpdatePromptData, ThrowOnError>): RequestResult<UpdatePromptResponses, UpdatePromptErrors, ThrowOnError> => (options.client ?? client).put<UpdatePromptResponses, UpdatePromptErrors, ThrowOnError>({
  url: '/prompt-library/{prompt_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Prompt Shares
 *
 * List the users a personal prompt is shared with; only its owner may ask.
 */
export const getPromptShares = <ThrowOnError extends boolean = false>(options: Options<GetPromptSharesData, ThrowOnError>): RequestResult<GetPromptSharesResponses, GetPromptSharesErrors, ThrowOnError> => (options.client ?? client).get<GetPromptSharesResponses, GetPromptSharesErrors, ThrowOnError>({ url: '/prompt-library/{prompt_id}/share', ...options });

/**
 * Patch Prompt Shares
 *
 * Grant or revoke view-only shares with users of the same organization.
 */
export const patchPromptShares = <ThrowOnError extends boolean = false>(options: Options<PatchPromptSharesData, ThrowOnError>): RequestResult<PatchPromptSharesResponses, PatchPromptSharesErrors, ThrowOnError> => (options.client ?? client).patch<PatchPromptSharesResponses, PatchPromptSharesErrors, ThrowOnError>({
  url: '/prompt-library/{prompt_id}/share',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Publish Prompt
 *
 * Publish the caller's personal prompt to a department they administer or to their organization.
 *
 * The gate answers for the prompt; `PROMPT_FORBIDDEN` is left for the
 * destination, which is a department or the organization rather than this
 * prompt. The prompt's individual shares are removed in the same transaction.
 */
export const publishPrompt = <ThrowOnError extends boolean = false>(options: Options<PublishPromptData, ThrowOnError>): RequestResult<PublishPromptResponses, PublishPromptErrors, ThrowOnError> => (options.client ?? client).post<PublishPromptResponses, PublishPromptErrors, ThrowOnError>({
  url: '/prompt-library/{prompt_id}/publish',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Export Data
 */
export const exportData = <ThrowOnError extends boolean = false>(options: Options<ExportDataData, ThrowOnError>): RequestResult<ExportDataResponses, ExportDataErrors, ThrowOnError> => (options.client ?? client).post<ExportDataResponses, ExportDataErrors, ThrowOnError>({
  url: '/data/export',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Articles
 *
 * Get a list of articles with optional filtering.
 *
 * **Authentication required.**
 * - Regular users can only see published articles
 * - Help-center managers can see all articles (including unpublished)
 */
export const getArticles = <ThrowOnError extends boolean = false>(options?: Options<GetArticlesData, ThrowOnError>): RequestResult<GetArticlesResponses, GetArticlesErrors, ThrowOnError> => (options?.client ?? client).get<GetArticlesResponses, GetArticlesErrors, ThrowOnError>({ url: '/help-center/articles', ...options });

/**
 * Create Article
 *
 * Create a new article.
 *
 * **Requires help-center management access.**
 */
export const createArticle = <ThrowOnError extends boolean = false>(options: Options<CreateArticleData, ThrowOnError>): RequestResult<CreateArticleResponses, CreateArticleErrors, ThrowOnError> => (options.client ?? client).post<CreateArticleResponses, CreateArticleErrors, ThrowOnError>({
  url: '/help-center/articles',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Article
 *
 * Delete an article by ID.
 *
 * **Requires help-center management access.**
 */
export const deleteArticle = <ThrowOnError extends boolean = false>(options: Options<DeleteArticleData, ThrowOnError>): RequestResult<DeleteArticleResponses, DeleteArticleErrors, ThrowOnError> => (options.client ?? client).delete<DeleteArticleResponses, DeleteArticleErrors, ThrowOnError>({ url: '/help-center/articles/{article_id}', ...options });

/**
 * Get Article
 *
 * Get a specific article by ID.
 *
 * **Authentication required.**
 * - Regular users can only view published articles
 * - Help-center managers can view all articles
 */
export const getArticle = <ThrowOnError extends boolean = false>(options: Options<GetArticleData, ThrowOnError>): RequestResult<GetArticleResponses, GetArticleErrors, ThrowOnError> => (options.client ?? client).get<GetArticleResponses, GetArticleErrors, ThrowOnError>({ url: '/help-center/articles/{article_id}', ...options });

/**
 * Update Article
 *
 * Update an existing article.
 *
 * **Requires help-center management access.**
 */
export const updateArticle = <ThrowOnError extends boolean = false>(options: Options<UpdateArticleData, ThrowOnError>): RequestResult<UpdateArticleResponses, UpdateArticleErrors, ThrowOnError> => (options.client ?? client).patch<UpdateArticleResponses, UpdateArticleErrors, ThrowOnError>({
  url: '/help-center/articles/{article_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Publish Article
 *
 * Publish an article.
 *
 * **Requires help-center management access.**
 */
export const publishArticle = <ThrowOnError extends boolean = false>(options: Options<PublishArticleData, ThrowOnError>): RequestResult<PublishArticleResponses, PublishArticleErrors, ThrowOnError> => (options.client ?? client).patch<PublishArticleResponses, PublishArticleErrors, ThrowOnError>({ url: '/help-center/articles/{article_id}/publish', ...options });

/**
 * Unpublish Article
 *
 * Unpublish an article.
 *
 * **Requires help-center management access.**
 */
export const unpublishArticle = <ThrowOnError extends boolean = false>(options: Options<UnpublishArticleData, ThrowOnError>): RequestResult<UnpublishArticleResponses, UnpublishArticleErrors, ThrowOnError> => (options.client ?? client).patch<UnpublishArticleResponses, UnpublishArticleErrors, ThrowOnError>({ url: '/help-center/articles/{article_id}/unpublish', ...options });

/**
 * Increment Article Views
 *
 * Increment the view count for an article.
 *
 * **Authentication required.**
 */
export const incrementArticleViews = <ThrowOnError extends boolean = false>(options: Options<IncrementArticleViewsData, ThrowOnError>): RequestResult<IncrementArticleViewsResponses, IncrementArticleViewsErrors, ThrowOnError> => (options.client ?? client).patch<IncrementArticleViewsResponses, IncrementArticleViewsErrors, ThrowOnError>({ url: '/help-center/articles/{article_id}/increment_views', ...options });

/**
 * Like Article
 *
 * Increment the like count for an article.
 *
 * **Authentication required.**
 */
export const likeArticle = <ThrowOnError extends boolean = false>(options: Options<LikeArticleData, ThrowOnError>): RequestResult<LikeArticleResponses, LikeArticleErrors, ThrowOnError> => (options.client ?? client).patch<LikeArticleResponses, LikeArticleErrors, ThrowOnError>({ url: '/help-center/articles/{article_id}/like', ...options });

/**
 * Dislike Article
 *
 * Increment the dislike count for an article.
 *
 * **Authentication required.**
 */
export const dislikeArticle = <ThrowOnError extends boolean = false>(options: Options<DislikeArticleData, ThrowOnError>): RequestResult<DislikeArticleResponses, DislikeArticleErrors, ThrowOnError> => (options.client ?? client).patch<DislikeArticleResponses, DislikeArticleErrors, ThrowOnError>({ url: '/help-center/articles/{article_id}/dislike', ...options });

/**
 * Get Faqs
 *
 * Get a list of FAQs.
 *
 * **Authentication required.**
 * - Regular users can only see published FAQs
 * - Help-center managers can see all FAQs
 */
export const getFaqs = <ThrowOnError extends boolean = false>(options?: Options<GetFaqsData, ThrowOnError>): RequestResult<GetFaqsResponses, GetFaqsErrors, ThrowOnError> => (options?.client ?? client).get<GetFaqsResponses, GetFaqsErrors, ThrowOnError>({ url: '/help-center/faqs', ...options });

/**
 * Create Faq
 *
 * Create a new FAQ.
 *
 * **Requires help-center management access.**
 */
export const createFaq = <ThrowOnError extends boolean = false>(options: Options<CreateFaqData, ThrowOnError>): RequestResult<CreateFaqResponses, CreateFaqErrors, ThrowOnError> => (options.client ?? client).post<CreateFaqResponses, CreateFaqErrors, ThrowOnError>({
  url: '/help-center/faqs',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Faq
 *
 * Delete a FAQ by ID.
 *
 * **Requires help-center management access.**
 */
export const deleteFaq = <ThrowOnError extends boolean = false>(options: Options<DeleteFaqData, ThrowOnError>): RequestResult<DeleteFaqResponses, DeleteFaqErrors, ThrowOnError> => (options.client ?? client).delete<DeleteFaqResponses, DeleteFaqErrors, ThrowOnError>({ url: '/help-center/faqs/{faq_id}', ...options });

/**
 * Update Faq
 *
 * Update an existing FAQ.
 *
 * **Requires help-center management access.**
 */
export const updateFaq = <ThrowOnError extends boolean = false>(options: Options<UpdateFaqData, ThrowOnError>): RequestResult<UpdateFaqResponses, UpdateFaqErrors, ThrowOnError> => (options.client ?? client).patch<UpdateFaqResponses, UpdateFaqErrors, ThrowOnError>({
  url: '/help-center/faqs/{faq_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Publish Faq
 *
 * Publish a FAQ.
 *
 * **Requires help-center management access.**
 */
export const publishFaq = <ThrowOnError extends boolean = false>(options: Options<PublishFaqData, ThrowOnError>): RequestResult<PublishFaqResponses, PublishFaqErrors, ThrowOnError> => (options.client ?? client).patch<PublishFaqResponses, PublishFaqErrors, ThrowOnError>({ url: '/help-center/faqs/{faq_id}/publish', ...options });

/**
 * Unpublish Faq
 *
 * Unpublish a FAQ.
 *
 * **Requires help-center management access.**
 */
export const unpublishFaq = <ThrowOnError extends boolean = false>(options: Options<UnpublishFaqData, ThrowOnError>): RequestResult<UnpublishFaqResponses, UnpublishFaqErrors, ThrowOnError> => (options.client ?? client).patch<UnpublishFaqResponses, UnpublishFaqErrors, ThrowOnError>({ url: '/help-center/faqs/{faq_id}/unpublish', ...options });

/**
 * Increment Faq Views
 *
 * Increment the view count for a FAQ.
 *
 * **Authentication required.**
 */
export const incrementFaqViews = <ThrowOnError extends boolean = false>(options: Options<IncrementFaqViewsData, ThrowOnError>): RequestResult<IncrementFaqViewsResponses, IncrementFaqViewsErrors, ThrowOnError> => (options.client ?? client).patch<IncrementFaqViewsResponses, IncrementFaqViewsErrors, ThrowOnError>({ url: '/help-center/faqs/{faq_id}/increment_views', ...options });

/**
 * Get Topics
 *
 * Get all article topics.
 */
export const getTopics = <ThrowOnError extends boolean = false>(options?: Options<GetTopicsData, ThrowOnError>): RequestResult<GetTopicsResponses, GetTopicsErrors, ThrowOnError> => (options?.client ?? client).get<GetTopicsResponses, GetTopicsErrors, ThrowOnError>({ url: '/help-center/topics', ...options });

/**
 * Create Topic
 *
 * Create a new custom article topic.
 */
export const createTopic = <ThrowOnError extends boolean = false>(options: Options<CreateTopicData, ThrowOnError>): RequestResult<CreateTopicResponses, CreateTopicErrors, ThrowOnError> => (options.client ?? client).post<CreateTopicResponses, CreateTopicErrors, ThrowOnError>({
  url: '/help-center/topics',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Topic
 *
 * Delete a custom article topic that is not in use.
 */
export const deleteTopic = <ThrowOnError extends boolean = false>(options: Options<DeleteTopicData, ThrowOnError>): RequestResult<DeleteTopicResponses, DeleteTopicErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTopicResponses, DeleteTopicErrors, ThrowOnError>({ url: '/help-center/topics/{topic_id}', ...options });

/**
 * Update Topic
 *
 * Rename a custom article topic.
 */
export const updateTopic = <ThrowOnError extends boolean = false>(options: Options<UpdateTopicData, ThrowOnError>): RequestResult<UpdateTopicResponses, UpdateTopicErrors, ThrowOnError> => (options.client ?? client).patch<UpdateTopicResponses, UpdateTopicErrors, ThrowOnError>({
  url: '/help-center/topics/{topic_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Article Templates
 *
 * Get all article templates.
 *
 * **Authentication required.**
 */
export const getArticleTemplates = <ThrowOnError extends boolean = false>(options?: Options<GetArticleTemplatesData, ThrowOnError>): RequestResult<GetArticleTemplatesResponses, GetArticleTemplatesErrors, ThrowOnError> => (options?.client ?? client).get<GetArticleTemplatesResponses, GetArticleTemplatesErrors, ThrowOnError>({ url: '/help-center/article-templates', ...options });

/**
 * Create Article Template
 *
 * Create a new article template.
 *
 * **Requires help-center management access.**
 */
export const createArticleTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateArticleTemplateData, ThrowOnError>): RequestResult<CreateArticleTemplateResponses, CreateArticleTemplateErrors, ThrowOnError> => (options.client ?? client).post<CreateArticleTemplateResponses, CreateArticleTemplateErrors, ThrowOnError>({
  url: '/help-center/article-templates',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Article Template
 *
 * Delete a template by ID.
 *
 * **Requires help-center management access.**
 */
export const deleteArticleTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteArticleTemplateData, ThrowOnError>): RequestResult<DeleteArticleTemplateResponses, DeleteArticleTemplateErrors, ThrowOnError> => (options.client ?? client).delete<DeleteArticleTemplateResponses, DeleteArticleTemplateErrors, ThrowOnError>({ url: '/help-center/article-templates/{template_id}', ...options });

/**
 * Get Article Template
 *
 * Get a specific template by ID.
 *
 * **Authentication required.**
 */
export const getArticleTemplate = <ThrowOnError extends boolean = false>(options: Options<GetArticleTemplateData, ThrowOnError>): RequestResult<GetArticleTemplateResponses, GetArticleTemplateErrors, ThrowOnError> => (options.client ?? client).get<GetArticleTemplateResponses, GetArticleTemplateErrors, ThrowOnError>({ url: '/help-center/article-templates/{template_id}', ...options });

/**
 * Update Article Template
 *
 * Update an existing template.
 *
 * **Requires help-center management access.**
 */
export const updateArticleTemplate = <ThrowOnError extends boolean = false>(options: Options<UpdateArticleTemplateData, ThrowOnError>): RequestResult<UpdateArticleTemplateResponses, UpdateArticleTemplateErrors, ThrowOnError> => (options.client ?? client).patch<UpdateArticleTemplateResponses, UpdateArticleTemplateErrors, ThrowOnError>({
  url: '/help-center/article-templates/{template_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Use Article Template
 *
 * Increment template usage count when used to create an article.
 *
 * **Authentication required.**
 */
export const useArticleTemplate = <ThrowOnError extends boolean = false>(options: Options<UseArticleTemplateData, ThrowOnError>): RequestResult<UseArticleTemplateResponses, UseArticleTemplateErrors, ThrowOnError> => (options.client ?? client).patch<UseArticleTemplateResponses, UseArticleTemplateErrors, ThrowOnError>({ url: '/help-center/article-templates/{template_id}/increment-usage', ...options });

/**
 * Upload Help Center Media
 *
 * Upload a media file (image or video).
 *
 * **Requires help-center management access.**
 */
export const uploadHelpCenterMedia = <ThrowOnError extends boolean = false>(options: Options<UploadHelpCenterMediaData, ThrowOnError>): RequestResult<UploadHelpCenterMediaResponses, UploadHelpCenterMediaErrors, ThrowOnError> => (options.client ?? client).post<UploadHelpCenterMediaResponses, UploadHelpCenterMediaErrors, ThrowOnError>({
  ...formDataBodySerializer,
  url: '/help-center/media/upload',
  ...options,
  headers: {
    'Content-Type': null,
    ...options.headers
  }
});

/**
 * Delete Media
 *
 * Delete a media file and its metadata.
 *
 * **Requires help-center management access.**
 */
export const deleteMedia = <ThrowOnError extends boolean = false>(options: Options<DeleteMediaData, ThrowOnError>): RequestResult<DeleteMediaResponses, DeleteMediaErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMediaResponses, DeleteMediaErrors, ThrowOnError>({ url: '/help-center/media/{media_id}', ...options });

/**
 * Get Media Metadata
 *
 * Retrieve metadata for a specific media file by its ID.
 *
 * **Authentication required.**
 */
export const getMediaMetadata = <ThrowOnError extends boolean = false>(options: Options<GetMediaMetadataData, ThrowOnError>): RequestResult<GetMediaMetadataResponses, GetMediaMetadataErrors, ThrowOnError> => (options.client ?? client).get<GetMediaMetadataResponses, GetMediaMetadataErrors, ThrowOnError>({ url: '/help-center/media/{media_id}', ...options });

/**
 * Download Media
 *
 * Streams or downloads a media file.
 *
 * **Authentication required.**
 */
export const downloadMedia = <ThrowOnError extends boolean = false>(options: Options<DownloadMediaData, ThrowOnError>): RequestResult<DownloadMediaResponses, DownloadMediaErrors, ThrowOnError> => (options.client ?? client).get<DownloadMediaResponses, DownloadMediaErrors, ThrowOnError>({ url: '/help-center/media/{media_id}/download', ...options });

/**
 * Send Contact Message
 *
 * Send a contact message to the help center team.
 *
 * **Authentication required.**
 */
export const sendContactMessage = <ThrowOnError extends boolean = false>(options: Options<SendContactMessageData, ThrowOnError>): RequestResult<SendContactMessageResponses, SendContactMessageErrors, ThrowOnError> => (options.client ?? client).post<SendContactMessageResponses, SendContactMessageErrors, ThrowOnError>({
  url: '/help-center/contact',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Release Notes
 *
 * Get a list of release notes.
 */
export const getReleaseNotes = <ThrowOnError extends boolean = false>(options?: Options<GetReleaseNotesData, ThrowOnError>): RequestResult<GetReleaseNotesResponses, GetReleaseNotesErrors, ThrowOnError> => (options?.client ?? client).get<GetReleaseNotesResponses, GetReleaseNotesErrors, ThrowOnError>({ url: '/help-center/release-notes', ...options });

/**
 * Create Release Note
 *
 * Create a new release note.
 */
export const createReleaseNote = <ThrowOnError extends boolean = false>(options: Options<CreateReleaseNoteData, ThrowOnError>): RequestResult<CreateReleaseNoteResponses, CreateReleaseNoteErrors, ThrowOnError> => (options.client ?? client).post<CreateReleaseNoteResponses, CreateReleaseNoteErrors, ThrowOnError>({
  url: '/help-center/release-notes',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Release Note
 *
 * Delete a release note by ID.
 */
export const deleteReleaseNote = <ThrowOnError extends boolean = false>(options: Options<DeleteReleaseNoteData, ThrowOnError>): RequestResult<DeleteReleaseNoteResponses, DeleteReleaseNoteErrors, ThrowOnError> => (options.client ?? client).delete<DeleteReleaseNoteResponses, DeleteReleaseNoteErrors, ThrowOnError>({ url: '/help-center/release-notes/{release_note_id}', ...options });

/**
 * Get Release Note By Id
 *
 * Get a specific release note by ID.
 */
export const getReleaseNoteById = <ThrowOnError extends boolean = false>(options: Options<GetReleaseNoteByIdData, ThrowOnError>): RequestResult<GetReleaseNoteByIdResponses, GetReleaseNoteByIdErrors, ThrowOnError> => (options.client ?? client).get<GetReleaseNoteByIdResponses, GetReleaseNoteByIdErrors, ThrowOnError>({ url: '/help-center/release-notes/{release_note_id}', ...options });

/**
 * Update Release Note
 *
 * Update an existing release note.
 */
export const updateReleaseNote = <ThrowOnError extends boolean = false>(options: Options<UpdateReleaseNoteData, ThrowOnError>): RequestResult<UpdateReleaseNoteResponses, UpdateReleaseNoteErrors, ThrowOnError> => (options.client ?? client).patch<UpdateReleaseNoteResponses, UpdateReleaseNoteErrors, ThrowOnError>({
  url: '/help-center/release-notes/{release_note_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Publish Release Note
 *
 * Publish a release note.
 */
export const publishReleaseNote = <ThrowOnError extends boolean = false>(options: Options<PublishReleaseNoteData, ThrowOnError>): RequestResult<PublishReleaseNoteResponses, PublishReleaseNoteErrors, ThrowOnError> => (options.client ?? client).patch<PublishReleaseNoteResponses, PublishReleaseNoteErrors, ThrowOnError>({ url: '/help-center/release-notes/{release_note_id}/publish', ...options });

/**
 * Unpublish Release Note
 *
 * Unpublish a release note.
 */
export const unpublishReleaseNote = <ThrowOnError extends boolean = false>(options: Options<UnpublishReleaseNoteData, ThrowOnError>): RequestResult<UnpublishReleaseNoteResponses, UnpublishReleaseNoteErrors, ThrowOnError> => (options.client ?? client).patch<UnpublishReleaseNoteResponses, UnpublishReleaseNoteErrors, ThrowOnError>({ url: '/help-center/release-notes/{release_note_id}/unpublish', ...options });

/**
 * List Classifications
 */
export const listClassifications = <ThrowOnError extends boolean = false>(options: Options<ListClassificationsData, ThrowOnError>): RequestResult<ListClassificationsResponses, ListClassificationsErrors, ThrowOnError> => (options.client ?? client).get<ListClassificationsResponses, ListClassificationsErrors, ThrowOnError>({ url: '/organization/{org_id}/classification/{project_id}/template/{template_id}/classify', ...options });

/**
 * Save Classifications
 */
export const saveClassifications = <ThrowOnError extends boolean = false>(options: Options<SaveClassificationsData, ThrowOnError>): RequestResult<SaveClassificationsResponses, SaveClassificationsErrors, ThrowOnError> => (options.client ?? client).post<SaveClassificationsResponses, SaveClassificationsErrors, ThrowOnError>({
  url: '/organization/{org_id}/classification/{project_id}/template/{template_id}/classify',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Snapshot Classifications
 *
 * Load the current-year warehouse row set once into local classification rows.
 */
export const snapshotClassifications = <ThrowOnError extends boolean = false>(options: Options<SnapshotClassificationsData, ThrowOnError>): RequestResult<SnapshotClassificationsResponses, SnapshotClassificationsErrors, ThrowOnError> => (options.client ?? client).post<SnapshotClassificationsResponses, SnapshotClassificationsErrors, ThrowOnError>({ url: '/organization/{org_id}/classification/{project_id}/template/{template_id}/classify/snapshot', ...options });

/**
 * Refresh Classifications
 *
 * Re-read current-year gold: additive identity updates plus gold-match verdicts.
 */
export const refreshClassifications = <ThrowOnError extends boolean = false>(options: Options<RefreshClassificationsData, ThrowOnError>): RequestResult<RefreshClassificationsResponses, RefreshClassificationsErrors, ThrowOnError> => (options.client ?? client).post<RefreshClassificationsResponses, RefreshClassificationsErrors, ThrowOnError>({ url: '/organization/{org_id}/classification/{project_id}/template/{template_id}/classify/refresh', ...options });

/**
 * Import Prior Year Classifications
 *
 * Fill unclassified local rows from T-1 gold. Does not stamp gold_verified_at.
 */
export const importPriorYearClassifications = <ThrowOnError extends boolean = false>(options: Options<ImportPriorYearClassificationsData, ThrowOnError>): RequestResult<ImportPriorYearClassificationsResponses, ImportPriorYearClassificationsErrors, ThrowOnError> => (options.client ?? client).post<ImportPriorYearClassificationsResponses, ImportPriorYearClassificationsErrors, ThrowOnError>({ url: '/organization/{org_id}/classification/{project_id}/template/{template_id}/classify/import-prior-year', ...options });

/**
 * Copy Classifications
 *
 * Copy a readable sibling project's classifications into this project's unclassified rows.
 */
export const copyClassifications = <ThrowOnError extends boolean = false>(options: Options<CopyClassificationsData, ThrowOnError>): RequestResult<CopyClassificationsResponses, CopyClassificationsErrors, ThrowOnError> => (options.client ?? client).post<CopyClassificationsResponses, CopyClassificationsErrors, ThrowOnError>({
  url: '/organization/{org_id}/classification/{project_id}/template/{template_id}/classify/copy',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * List Copy Classification Sources
 *
 * List the projects this project can copy classifications from, busiest first.
 */
export const listCopyClassificationSources = <ThrowOnError extends boolean = false>(options: Options<ListCopyClassificationSourcesData, ThrowOnError>): RequestResult<ListCopyClassificationSourcesResponses, ListCopyClassificationSourcesErrors, ThrowOnError> => (options.client ?? client).get<ListCopyClassificationSourcesResponses, ListCopyClassificationSourcesErrors, ThrowOnError>({ url: '/organization/{org_id}/classification/{project_id}/template/{template_id}/classify/copy/sources', ...options });

/**
 * Get Classification Stats
 */
export const getClassificationStats = <ThrowOnError extends boolean = false>(options: Options<GetClassificationStatsData, ThrowOnError>): RequestResult<GetClassificationStatsResponses, GetClassificationStatsErrors, ThrowOnError> => (options.client ?? client).get<GetClassificationStatsResponses, GetClassificationStatsErrors, ThrowOnError>({ url: '/organization/{org_id}/classification/{project_id}/template/{template_id}/classify/stats', ...options });

/**
 * Export Classifications
 *
 * Export local classification rows to the external system.
 */
export const exportClassifications = <ThrowOnError extends boolean = false>(options: Options<ExportClassificationsData, ThrowOnError>): RequestResult<ExportClassificationsResponses, ExportClassificationsErrors, ThrowOnError> => (options.client ?? client).post<ExportClassificationsResponses, ExportClassificationsErrors, ThrowOnError>({ url: '/organization/{org_id}/classification/{project_id}/template/{template_id}/classify/export', ...options });

/**
 * Export Classification Results Excel
 *
 * Export classification results to an Excel file for local download.
 */
export const exportClassificationResultsExcel = <ThrowOnError extends boolean = false>(options: Options<ExportClassificationResultsExcelData, ThrowOnError>): RequestResult<ExportClassificationResultsExcelResponses, ExportClassificationResultsExcelErrors, ThrowOnError> => (options.client ?? client).get<ExportClassificationResultsExcelResponses, ExportClassificationResultsExcelErrors, ThrowOnError>({ url: '/organization/{org_id}/classification/{project_id}/template/{template_id}/classify/export/excel', ...options });

/**
 * Get Classification Pipeline Status
 *
 * Get classification export pipeline execution status.
 */
export const getClassificationPipelineStatus = <ThrowOnError extends boolean = false>(options: Options<GetClassificationPipelineStatusData, ThrowOnError>): RequestResult<GetClassificationPipelineStatusResponses, GetClassificationPipelineStatusErrors, ThrowOnError> => (options.client ?? client).get<GetClassificationPipelineStatusResponses, GetClassificationPipelineStatusErrors, ThrowOnError>({ url: '/organization/{org_id}/classification/{project_id}/template/{template_id}/classification/pipeline/status', ...options });

/**
 * Predict Classifications
 *
 * Predict classifications for rows using AI.
 *
 * Uses the latest template version and LLM to automatically classify rows.
 * Returns only valid predictions that exactly match allowed combinations.
 * Invalid predictions are counted for feedback.
 *
 * The response includes the model name used for provenance tracking.
 *
 * The gate resolves the project inside the caller's organization and decides in
 * one statement, so the row reached here is both authorized and the one the
 * template is checked against, and the id that books the usage reservation is
 * its own. A project outside the organization is denied like an unknown one.
 *
 * The applicability check stays in the handler rather than coming from
 * `get_project_template`: this route reads its template id out of the path for
 * the prediction call, and routing it through the shared dependency would add a
 * second template fetch for the same row.
 */
export const predictClassifications = <ThrowOnError extends boolean = false>(options: Options<PredictClassificationsData, ThrowOnError>): RequestResult<PredictClassificationsResponses, PredictClassificationsErrors, ThrowOnError> => (options.client ?? client).post<PredictClassificationsResponses, PredictClassificationsErrors, ThrowOnError>({
  url: '/organization/{org_id}/classification/{project_id}/template/{template_id}/classify/predict',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Clear Ledger Classifications
 *
 * Remove every target of the project's resolved ledger binding, keeping revision history.
 */
export const clearLedgerClassifications = <ThrowOnError extends boolean = false>(options: Options<ClearLedgerClassificationsData, ThrowOnError>): RequestResult<ClearLedgerClassificationsResponses, ClearLedgerClassificationsErrors, ThrowOnError> => (options.client ?? client).delete<ClearLedgerClassificationsResponses, ClearLedgerClassificationsErrors, ThrowOnError>({ url: '/organization/{org_id}/ledger_classification/{project_id}/classify', ...options });

/**
 * List Ledger Accounts
 *
 * Read the grid columns and one local row per account with evidence for the project's booking year.
 */
export const listLedgerAccounts = <ThrowOnError extends boolean = false>(options: Options<ListLedgerAccountsData, ThrowOnError>): RequestResult<ListLedgerAccountsResponses, ListLedgerAccountsErrors, ThrowOnError> => (options.client ?? client).get<ListLedgerAccountsResponses, ListLedgerAccountsErrors, ThrowOnError>({ url: '/organization/{org_id}/ledger_classification/{project_id}/classify', ...options });

/**
 * Save Ledger Classifications
 *
 * Save manual classifications against the audit project's resolved ledger binding.
 */
export const saveLedgerClassifications = <ThrowOnError extends boolean = false>(options: Options<SaveLedgerClassificationsData, ThrowOnError>): RequestResult<SaveLedgerClassificationsResponses, SaveLedgerClassificationsErrors, ThrowOnError> => (options.client ?? client).post<SaveLedgerClassificationsResponses, SaveLedgerClassificationsErrors, ThrowOnError>({
  url: '/organization/{org_id}/ledger_classification/{project_id}/classify',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Predict Ledger Classifications
 *
 * Predict targets for the typed ledger's current unclassified accounts.
 */
export const predictLedgerClassifications = <ThrowOnError extends boolean = false>(options: Options<PredictLedgerClassificationsData, ThrowOnError>): RequestResult<PredictLedgerClassificationsResponses, PredictLedgerClassificationsErrors, ThrowOnError> => (options.client ?? client).post<PredictLedgerClassificationsResponses, PredictLedgerClassificationsErrors, ThrowOnError>({ url: '/organization/{org_id}/ledger_classification/{project_id}/classify/predict', ...options });

/**
 * Accept Ledger Predictions
 *
 * Accept selected server-issued predictions without overwriting later edits.
 */
export const acceptLedgerPredictions = <ThrowOnError extends boolean = false>(options: Options<AcceptLedgerPredictionsData, ThrowOnError>): RequestResult<AcceptLedgerPredictionsResponses, AcceptLedgerPredictionsErrors, ThrowOnError> => (options.client ?? client).post<AcceptLedgerPredictionsResponses, AcceptLedgerPredictionsErrors, ThrowOnError>({
  url: '/organization/{org_id}/ledger_classification/{project_id}/classify/predict/accept',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * List Ledger Targets
 *
 * Read the resolved published taxonomy offered by the ledger classification picker.
 */
export const listLedgerTargets = <ThrowOnError extends boolean = false>(options: Options<ListLedgerTargetsData, ThrowOnError>): RequestResult<ListLedgerTargetsResponses, ListLedgerTargetsErrors, ThrowOnError> => (options.client ?? client).get<ListLedgerTargetsResponses, ListLedgerTargetsErrors, ThrowOnError>({ url: '/organization/{org_id}/ledger_classification/{project_id}/classify/targets', ...options });

/**
 * Get Ledger Stats
 *
 * Read local account counts and completeness using the ledger grid's status rules.
 */
export const getLedgerStats = <ThrowOnError extends boolean = false>(options: Options<GetLedgerStatsData, ThrowOnError>): RequestResult<GetLedgerStatsResponses, GetLedgerStatsErrors, ThrowOnError> => (options.client ?? client).get<GetLedgerStatsResponses, GetLedgerStatsErrors, ThrowOnError>({ url: '/organization/{org_id}/ledger_classification/{project_id}/classify/stats', ...options });

/**
 * Snapshot Ledger Accounts
 *
 * Explicitly snapshot the bound ledger's account evidence for the project's booking year.
 */
export const snapshotLedgerAccounts = <ThrowOnError extends boolean = false>(options: Options<SnapshotLedgerAccountsData, ThrowOnError>): RequestResult<SnapshotLedgerAccountsResponses, SnapshotLedgerAccountsErrors, ThrowOnError> => (options.client ?? client).post<SnapshotLedgerAccountsResponses, SnapshotLedgerAccountsErrors, ThrowOnError>({ url: '/organization/{org_id}/ledger_classification/{project_id}/classify/snapshot', ...options });

/**
 * Refresh Ledger Accounts
 *
 * Explicitly refresh the bound ledger's account list for the project's booking year.
 */
export const refreshLedgerAccounts = <ThrowOnError extends boolean = false>(options: Options<RefreshLedgerAccountsData, ThrowOnError>): RequestResult<RefreshLedgerAccountsResponses, RefreshLedgerAccountsErrors, ThrowOnError> => (options.client ?? client).post<RefreshLedgerAccountsResponses, RefreshLedgerAccountsErrors, ThrowOnError>({ url: '/organization/{org_id}/ledger_classification/{project_id}/classify/refresh', ...options });

/**
 * Copy Ledger Classifications
 *
 * Fill unclassified accounts from another audit project the caller can read, never the warehouse.
 */
export const copyLedgerClassifications = <ThrowOnError extends boolean = false>(options: Options<CopyLedgerClassificationsData, ThrowOnError>): RequestResult<CopyLedgerClassificationsResponses, CopyLedgerClassificationsErrors, ThrowOnError> => (options.client ?? client).post<CopyLedgerClassificationsResponses, CopyLedgerClassificationsErrors, ThrowOnError>({
  url: '/organization/{org_id}/ledger_classification/{project_id}/classify/copy',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * List Ledger Copy Sources
 *
 * List the audit projects this project can copy classifications from, busiest first.
 */
export const listLedgerCopySources = <ThrowOnError extends boolean = false>(options: Options<ListLedgerCopySourcesData, ThrowOnError>): RequestResult<ListLedgerCopySourcesResponses, ListLedgerCopySourcesErrors, ThrowOnError> => (options.client ?? client).get<ListLedgerCopySourcesResponses, ListLedgerCopySourcesErrors, ThrowOnError>({ url: '/organization/{org_id}/ledger_classification/{project_id}/classify/copy/sources', ...options });

/**
 * Export Ledger Classifications
 *
 * Send the fiscal year's typed classifications to gold and record that the batch was sent.
 */
export const exportLedgerClassifications = <ThrowOnError extends boolean = false>(options: Options<ExportLedgerClassificationsData, ThrowOnError>): RequestResult<ExportLedgerClassificationsResponses, ExportLedgerClassificationsErrors, ThrowOnError> => (options.client ?? client).post<ExportLedgerClassificationsResponses, ExportLedgerClassificationsErrors, ThrowOnError>({ url: '/organization/{org_id}/ledger_classification/{project_id}/classify/export', ...options });

/**
 * Get Ledger Export Status
 *
 * Report the latest export of the ledger the project is bound to, or null before the first one.
 */
export const getLedgerExportStatus = <ThrowOnError extends boolean = false>(options: Options<GetLedgerExportStatusData, ThrowOnError>): RequestResult<GetLedgerExportStatusResponses, GetLedgerExportStatusErrors, ThrowOnError> => (options.client ?? client).get<GetLedgerExportStatusResponses, GetLedgerExportStatusErrors, ThrowOnError>({ url: '/organization/{org_id}/ledger_classification/{project_id}/classify/export/status', ...options });

/**
 * List Classification Templates
 */
export const listClassificationTemplates = <ThrowOnError extends boolean = false>(options: Options<ListClassificationTemplatesData, ThrowOnError>): RequestResult<ListClassificationTemplatesResponses, ListClassificationTemplatesErrors, ThrowOnError> => (options.client ?? client).get<ListClassificationTemplatesResponses, ListClassificationTemplatesErrors, ThrowOnError>({ url: '/organization/{org_id}/classification_template/template', ...options });

/**
 * Create Classification Template
 */
export const createClassificationTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateClassificationTemplateData, ThrowOnError>): RequestResult<CreateClassificationTemplateResponses, CreateClassificationTemplateErrors, ThrowOnError> => (options.client ?? client).post<CreateClassificationTemplateResponses, CreateClassificationTemplateErrors, ThrowOnError>({
  url: '/organization/{org_id}/classification_template/template',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Classification Template
 *
 * Delete a classification template.
 *
 * Deleting a template will:
 * - Remove all template versions
 * - Remove all classifications associated with the template
 * - Remove all client-template associations
 *
 * No `require_locked_row`: a catalog's authority is organization-level, so no
 * row serializes a revocation against this write and the change takes effect on
 * the next request, which is the residual window RFC 5.11 already describes.
 */
export const deleteClassificationTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteClassificationTemplateData, ThrowOnError>): RequestResult<DeleteClassificationTemplateResponses, DeleteClassificationTemplateErrors, ThrowOnError> => (options.client ?? client).delete<DeleteClassificationTemplateResponses, DeleteClassificationTemplateErrors, ThrowOnError>({ url: '/organization/{org_id}/classification_template/template/{template_id}', ...options });

/**
 * Get Classification Template
 *
 * Return one template of this organization's catalog.
 */
export const getClassificationTemplate = <ThrowOnError extends boolean = false>(options: Options<GetClassificationTemplateData, ThrowOnError>): RequestResult<GetClassificationTemplateResponses, GetClassificationTemplateErrors, ThrowOnError> => (options.client ?? client).get<GetClassificationTemplateResponses, GetClassificationTemplateErrors, ThrowOnError>({ url: '/organization/{org_id}/classification_template/template/{template_id}', ...options });

/**
 * Get Latest Classification Template Version
 */
export const getLatestClassificationTemplateVersion = <ThrowOnError extends boolean = false>(options: Options<GetLatestClassificationTemplateVersionData, ThrowOnError>): RequestResult<GetLatestClassificationTemplateVersionResponses, GetLatestClassificationTemplateVersionErrors, ThrowOnError> => (options.client ?? client).get<GetLatestClassificationTemplateVersionResponses, GetLatestClassificationTemplateVersionErrors, ThrowOnError>({ url: '/organization/{org_id}/classification_template/template/{template_id}/version/latest', ...options });

/**
 * List Classification Template Versions
 */
export const listClassificationTemplateVersions = <ThrowOnError extends boolean = false>(options: Options<ListClassificationTemplateVersionsData, ThrowOnError>): RequestResult<ListClassificationTemplateVersionsResponses, ListClassificationTemplateVersionsErrors, ThrowOnError> => (options.client ?? client).get<ListClassificationTemplateVersionsResponses, ListClassificationTemplateVersionsErrors, ThrowOnError>({ url: '/organization/{org_id}/classification_template/template/{template_id}/version', ...options });

/**
 * Create Template Version
 */
export const createTemplateVersion = <ThrowOnError extends boolean = false>(options: Options<CreateTemplateVersionData, ThrowOnError>): RequestResult<CreateTemplateVersionResponses, CreateTemplateVersionErrors, ThrowOnError> => (options.client ?? client).post<CreateTemplateVersionResponses, CreateTemplateVersionErrors, ThrowOnError>({
  url: '/organization/{org_id}/classification_template/template/{template_id}/version',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Query Classification Template Data
 *
 * Read one page of a template's source rows for one project.
 *
 * Three different questions, and a gate answers two of them. *May this actor
 * reach this template?* is the catalog policy's. *May they classify this
 * project?* is the project policy's. *Does this template apply to the project
 * the url names?* is neither: it is a predicate over the two authorized rows,
 * so `resolve_template_context` keeps it, exactly as widget containment stays
 * on its routes.
 */
export const queryClassificationTemplateData = <ThrowOnError extends boolean = false>(options: Options<QueryClassificationTemplateDataData, ThrowOnError>): RequestResult<QueryClassificationTemplateDataResponses, QueryClassificationTemplateDataErrors, ThrowOnError> => (options.client ?? client).get<QueryClassificationTemplateDataResponses, QueryClassificationTemplateDataErrors, ThrowOnError>({ url: '/organization/{org_id}/classification_template/{project_id}/template/{template_id}/query', ...options });

/**
 * Create Ledger Classification Template
 *
 * Create an audit ledger template on the shared statement tree.
 *
 * Journals continue using `/classification_template` and the legacy tables.
 */
export const createLedgerClassificationTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateLedgerClassificationTemplateData, ThrowOnError>): RequestResult<CreateLedgerClassificationTemplateResponses, CreateLedgerClassificationTemplateErrors, ThrowOnError> => (options.client ?? client).post<CreateLedgerClassificationTemplateResponses, CreateLedgerClassificationTemplateErrors, ThrowOnError>({
  url: '/organization/{org_id}/ledger_classification_template/template',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Read Ledger Template Query
 *
 * Read the source query of an audit ledger template.
 */
export const readLedgerTemplateQuery = <ThrowOnError extends boolean = false>(options: Options<ReadLedgerTemplateQueryData, ThrowOnError>): RequestResult<ReadLedgerTemplateQueryResponses, ReadLedgerTemplateQueryErrors, ThrowOnError> => (options.client ?? client).get<ReadLedgerTemplateQueryResponses, ReadLedgerTemplateQueryErrors, ThrowOnError>({ url: '/organization/{org_id}/ledger_classification_template/template/{template_id}/query', ...options });

/**
 * Update Ledger Template Query
 *
 * Save source configuration for subsequent account loads and refreshes.
 */
export const updateLedgerTemplateQuery = <ThrowOnError extends boolean = false>(options: Options<UpdateLedgerTemplateQueryData, ThrowOnError>): RequestResult<UpdateLedgerTemplateQueryResponses, UpdateLedgerTemplateQueryErrors, ThrowOnError> => (options.client ?? client).put<UpdateLedgerTemplateQueryResponses, UpdateLedgerTemplateQueryErrors, ThrowOnError>({
  url: '/organization/{org_id}/ledger_classification_template/template/{template_id}/query',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Personal Analysis Runs
 *
 * List the caller's personal runs across every personal template they own.
 *
 * A "personal run" is a record with no `project_id` against a
 * template the caller created at `scope_type="personal"`. Returned
 * flat (one entry per `(template, datasource, run_number)` triple),
 * sorted by most recent first. Avoids the N+1 fan-out of calling
 * `/{template_id}/runs` per template.
 */
export const getPersonalAnalysisRuns = <ThrowOnError extends boolean = false>(options: Options<GetPersonalAnalysisRunsData, ThrowOnError>): RequestResult<GetPersonalAnalysisRunsResponses, GetPersonalAnalysisRunsErrors, ThrowOnError> => (options.client ?? client).get<GetPersonalAnalysisRunsResponses, GetPersonalAnalysisRunsErrors, ThrowOnError>({ url: '/organization/{org_id}/document-analysis/runs/personal', ...options });

/**
 * Get Analysis Run Results
 *
 * Get analysis results for a specific run.
 *
 * A run is uniquely identified by (project_id, template_id, datasource_id, run_number)
 * because run numbers restart at 1 per (project, template, datasource) triple. All four
 * must be passed to avoid leaking records from other runs that happen to share the same
 * counter value.
 *
 * Records are returned in the same order as questions appear in the template.
 *
 * When project_id is omitted the caller's personal run (project_id IS NULL, owned by
 * the caller) is returned. No project-level permission is required in that case.
 */
export const getAnalysisRunResults = <ThrowOnError extends boolean = false>(options: Options<GetAnalysisRunResultsData, ThrowOnError>): RequestResult<GetAnalysisRunResultsResponses, GetAnalysisRunResultsErrors, ThrowOnError> => (options.client ?? client).get<GetAnalysisRunResultsResponses, GetAnalysisRunResultsErrors, ThrowOnError>({ url: '/organization/{org_id}/document-analysis/run/{run_number}/results', ...options });

/**
 * Get Batch Summary
 *
 * Resolve a batch to the documents it produced.
 *
 * A batch groups N per-document runs under one batch_id; this returns the
 * distinct (datasource_id, run_number) pairs plus the shared template/project
 * so the client can reuse the per-run results endpoint for each document.
 *
 * Authorization mirrors the results endpoint: a project batch requires the
 * project permission; a personal batch (project_id IS NULL) must belong to the
 * caller (their personal template in this org).
 */
export const getBatchSummary = <ThrowOnError extends boolean = false>(options: Options<GetBatchSummaryData, ThrowOnError>): RequestResult<GetBatchSummaryResponses, GetBatchSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetBatchSummaryResponses, GetBatchSummaryErrors, ThrowOnError>({ url: '/organization/{org_id}/document-analysis/batch/{batch_id}', ...options });

/**
 * Delete Analysis Run
 *
 * Delete all records for a specific analysis run.
 *
 * A run is uniquely identified by (project_id, template_id, datasource_id, run_number).
 * Without the full identity, deleting "run 1" would also delete unrelated runs that
 * share the counter value across templates or datasources.
 *
 * When project_id is provided the caller must hold
 * `delete_document_analysis_run` on the specific project resource
 * (i.e. be assigned to that audit client team) to delete records.
 * When omitted,
 * only the caller's own personal run (project_id IS NULL) can be deleted;
 * no extra permission is required beyond org membership.
 */
export const deleteAnalysisRun = <ThrowOnError extends boolean = false>(options: Options<DeleteAnalysisRunData, ThrowOnError>): RequestResult<DeleteAnalysisRunResponses, DeleteAnalysisRunErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAnalysisRunResponses, DeleteAnalysisRunErrors, ThrowOnError>({ url: '/organization/{org_id}/document-analysis/run/{run_number}', ...options });

/**
 * Document Analysis Search
 *
 * Run a checklist against one or more documents.
 *
 * Streams NDJSON: per-document run-number and record events tagged with their
 * datasource_id, then a terminal complete event summarizing every document.
 * Each document is an independent run; the records share one batch_id. A single
 * document is just a run of one.
 *
 * Every supplied datasource must be readable by the caller and, when a project
 * is supplied, the caller must hold `perform_document_analysis` on that exact
 * project: its company/year context drives the run's row-level security. List
 * semantics are all-or-nothing — one denied document fails the whole request
 * rather than silently narrowing the run.
 */
export const documentAnalysisSearch = <ThrowOnError extends boolean = false>(options: Options<DocumentAnalysisSearchData, ThrowOnError>): RequestResult<DocumentAnalysisSearchResponses, DocumentAnalysisSearchErrors, ThrowOnError> => (options.client ?? client).post<DocumentAnalysisSearchResponses, DocumentAnalysisSearchErrors, ThrowOnError>({
  url: '/organization/{org_id}/document-analysis/{template_id}/search',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Template Analysis Runs
 *
 * List all analysis runs produced from this template, across projects and personal runs.
 *
 * Visibility tracks the template: the path dependency already gates
 * "can the caller see this template" via the scope-aware permission
 * check, so any record sharing the template's id is fair game.
 * Runs are grouped per `(project_id, datasource_id, run_number)`.
 */
export const getTemplateAnalysisRuns = <ThrowOnError extends boolean = false>(options: Options<GetTemplateAnalysisRunsData, ThrowOnError>): RequestResult<GetTemplateAnalysisRunsResponses, GetTemplateAnalysisRunsErrors, ThrowOnError> => (options.client ?? client).get<GetTemplateAnalysisRunsResponses, GetTemplateAnalysisRunsErrors, ThrowOnError>({ url: '/organization/{org_id}/document-analysis/{template_id}/runs', ...options });

/**
 * Get Client Analysis Runs
 *
 * Get all analysis runs for a client.
 *
 * Bound to the project in the path: a role on another project does not list
 * this one's runs.
 *
 * Each run represents a complete, independent analysis of one datasource with one template.
 * Returns all runs sorted by run_number (most recent first).
 * Supports multiple runs per template-datasource combination.
 *
 * Only returns runs that were explicitly connected to this client (have project_id set).
 * Test runs (created from template overview without a client) are excluded.
 */
export const getClientAnalysisRuns = <ThrowOnError extends boolean = false>(options: Options<GetClientAnalysisRunsData, ThrowOnError>): RequestResult<GetClientAnalysisRunsResponses, GetClientAnalysisRunsErrors, ThrowOnError> => (options.client ?? client).get<GetClientAnalysisRunsResponses, GetClientAnalysisRunsErrors, ThrowOnError>({ url: '/organization/{org_id}/document-analysis/client/{project_id}/runs', ...options });

/**
 * Export Document Analysis Run Results As Excel
 *
 * Export document analysis run results as an Excel file.
 *
 * Only available when all records in the run are confirmed. When project_id is omitted
 * the caller's personal run is exported; when supplied it must resolve inside the
 * caller's organization, because its company and booking year name the download.
 */
export const exportDocumentAnalysisRunResultsAsExcel = <ThrowOnError extends boolean = false>(options: Options<ExportDocumentAnalysisRunResultsAsExcelData, ThrowOnError>): RequestResult<ExportDocumentAnalysisRunResultsAsExcelResponses, ExportDocumentAnalysisRunResultsAsExcelErrors, ThrowOnError> => (options.client ?? client).get<ExportDocumentAnalysisRunResultsAsExcelResponses, ExportDocumentAnalysisRunResultsAsExcelErrors, ThrowOnError>({ url: '/organization/{org_id}/document-analysis/run/{run_number}/results/export', ...options });

/**
 * Export Document Analysis Run Results As Pdf
 *
 * Export document analysis run results as a PDF with bounding box overlays.
 *
 * Same project binding as the Excel export: a project id outside the caller's
 * organization is denied before the document is read.
 */
export const exportDocumentAnalysisRunResultsAsPdf = <ThrowOnError extends boolean = false>(options: Options<ExportDocumentAnalysisRunResultsAsPdfData, ThrowOnError>): RequestResult<ExportDocumentAnalysisRunResultsAsPdfResponses, ExportDocumentAnalysisRunResultsAsPdfErrors, ThrowOnError> => (options.client ?? client).get<ExportDocumentAnalysisRunResultsAsPdfResponses, ExportDocumentAnalysisRunResultsAsPdfErrors, ThrowOnError>({ url: '/organization/{org_id}/document-analysis/run/{run_number}/results/export/pdf', ...options });

/**
 * Toggle Confirmation
 *
 * Toggle confirmation state for a document analysis record.
 */
export const toggleConfirmation = <ThrowOnError extends boolean = false>(options: Options<ToggleConfirmationData, ThrowOnError>): RequestResult<ToggleConfirmationResponses, ToggleConfirmationErrors, ThrowOnError> => (options.client ?? client).post<ToggleConfirmationResponses, ToggleConfirmationErrors, ThrowOnError>({ url: '/organization/{org_id}/document-analysis/{template_id}/record/{record_id}/confirmation', ...options });

/**
 * Update Document Analysis Record
 *
 * Update a document analysis record with editable Q&A.
 *
 * Note: template_id in the path pins the record's identity, it does not
 * authorize the edit; the record's stored project (or its template, for a
 * project-less run) does.
 */
export const updateDocumentAnalysisRecord = <ThrowOnError extends boolean = false>(options: Options<UpdateDocumentAnalysisRecordData, ThrowOnError>): RequestResult<UpdateDocumentAnalysisRecordResponses, UpdateDocumentAnalysisRecordErrors, ThrowOnError> => (options.client ?? client).put<UpdateDocumentAnalysisRecordResponses, UpdateDocumentAnalysisRecordErrors, ThrowOnError>({
  url: '/organization/{org_id}/document-analysis/{template_id}/record/{record_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Document Analysis Template
 *
 * Delete a template (and its analysis records).
 *
 * Personal: requires the per-resource `ResourcePermission` owner-action bundle on this template id.
 * Promoted: requires `delete_document_analysis_template` on the
 * template's scope (project / project_type).
 */
export const deleteDocumentAnalysisTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteDocumentAnalysisTemplateData, ThrowOnError>): RequestResult<DeleteDocumentAnalysisTemplateResponses, DeleteDocumentAnalysisTemplateErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDocumentAnalysisTemplateResponses, DeleteDocumentAnalysisTemplateErrors, ThrowOnError>({ url: '/organization/{org_id}/document-analysis/{template_id}', ...options });

/**
 * Get Document Analysis Template
 *
 * Read a document analysis template.
 *
 * Visibility is enforced by the path dependency: personal templates
 * are visible only to their owner (and superusers); org-wide
 * templates to anyone in the org.
 */
export const getDocumentAnalysisTemplate = <ThrowOnError extends boolean = false>(options: Options<GetDocumentAnalysisTemplateData, ThrowOnError>): RequestResult<GetDocumentAnalysisTemplateResponses, GetDocumentAnalysisTemplateErrors, ThrowOnError> => (options.client ?? client).get<GetDocumentAnalysisTemplateResponses, GetDocumentAnalysisTemplateErrors, ThrowOnError>({ url: '/organization/{org_id}/document-analysis/{template_id}', ...options });

/**
 * Update Document Analysis Template
 *
 * Update a template by archiving and creating a new version.
 *
 * Personal: requires the per-resource `ResourcePermission` owner-action bundle on this template id.
 * Promoted: requires `update_document_analysis_template` on the
 * template's scope (project / project_type). The new version
 * inherits scope and creator.
 */
export const updateDocumentAnalysisTemplate = <ThrowOnError extends boolean = false>(options: Options<UpdateDocumentAnalysisTemplateData, ThrowOnError>): RequestResult<UpdateDocumentAnalysisTemplateResponses, UpdateDocumentAnalysisTemplateErrors, ThrowOnError> => (options.client ?? client).put<UpdateDocumentAnalysisTemplateResponses, UpdateDocumentAnalysisTemplateErrors, ThrowOnError>({
  url: '/organization/{org_id}/document-analysis/{template_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Document Analysis Templates
 *
 * List active (non-archived) templates the caller can see.
 *
 * `scope="all"` (default) -> caller's personal + every promoted template.
 * `scope="personal"` -> caller's personal templates only.
 * `scope="promoted"` -> templates promoted to a project / project_type.
 */
export const getDocumentAnalysisTemplates = <ThrowOnError extends boolean = false>(options: Options<GetDocumentAnalysisTemplatesData, ThrowOnError>): RequestResult<GetDocumentAnalysisTemplatesResponses, GetDocumentAnalysisTemplatesErrors, ThrowOnError> => (options.client ?? client).get<GetDocumentAnalysisTemplatesResponses, GetDocumentAnalysisTemplatesErrors, ThrowOnError>({ url: '/organization/{org_id}/document-analysis', ...options });

/**
 * Create Document Analysis Template
 *
 * Create a template at one of three scope tiers.
 *
 * Personal (`scope.type="personal"`): authored by the calling user;
 * visible and writable only to them via the per-resource
 * `ResourcePermission` owner-action bundle scoped to the new
 * template id. No project-level grant required.
 *
 * Project (`scope.type="project"`): requires
 * `("project.<project_id>", "create_document_analysis_template")`
 * on each project supplied, held by `project_editor` (and inherited
 * by `project_admin` / `org_admin` via the type-scope cascade). Every
 * id must also resolve inside the caller's organization; one that does
 * not fails the whole request, like one that does not exist.
 *
 * Project-type (`scope.type="project_type"`): library template
 * promoted to every project of the type. Requires
 * `("project_type.<type_uuid>", "create_document_analysis_template")`;
 * held by `project_admin` scoped to the type.
 */
export const createDocumentAnalysisTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateDocumentAnalysisTemplateData, ThrowOnError>): RequestResult<CreateDocumentAnalysisTemplateResponses, CreateDocumentAnalysisTemplateErrors, ThrowOnError> => (options.client ?? client).post<CreateDocumentAnalysisTemplateResponses, CreateDocumentAnalysisTemplateErrors, ThrowOnError>({
  url: '/organization/{org_id}/document-analysis',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Duplicate Document Analysis Template
 *
 * Duplicate a template the caller can see.
 *
 * The duplicate is always personal (owned by the caller via a fresh
 * the per-resource `ResourcePermission` owner-action bundle grant). To turn a duplicate into a promoted
 * template, follow with the (future) promotion flow.
 */
export const duplicateDocumentAnalysisTemplate = <ThrowOnError extends boolean = false>(options: Options<DuplicateDocumentAnalysisTemplateData, ThrowOnError>): RequestResult<DuplicateDocumentAnalysisTemplateResponses, DuplicateDocumentAnalysisTemplateErrors, ThrowOnError> => (options.client ?? client).post<DuplicateDocumentAnalysisTemplateResponses, DuplicateDocumentAnalysisTemplateErrors, ThrowOnError>({
  url: '/organization/{org_id}/document-analysis/{template_id}/duplicate',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Compare Documents
 *
 * Compare two stored documents and return their structured differences.
 *
 * Requires ``read_datasource`` on both documents: organization membership alone
 * does not grant access to an arbitrary datasource by id.
 */
export const compareDocuments = <ThrowOnError extends boolean = false>(options: Options<CompareDocumentsData, ThrowOnError>): RequestResult<CompareDocumentsResponses, CompareDocumentsErrors, ThrowOnError> => (options.client ?? client).get<CompareDocumentsResponses, CompareDocumentsErrors, ThrowOnError>({ url: '/organization/{org_id}/document-comparison', ...options });

/**
 * Run Document Analysis Pipeline
 *
 * Run document analysis export pipeline.
 *
 * The decorator binds `document_analysis_annotate` to the exact project, the
 * project is resolved inside the caller's organization, and the exported
 * document arrives already tenant-scoped and read-authorized.
 */
export const runDocumentAnalysisPipeline = <ThrowOnError extends boolean = false>(options: Options<RunDocumentAnalysisPipelineData, ThrowOnError>): RequestResult<RunDocumentAnalysisPipelineResponses, RunDocumentAnalysisPipelineErrors, ThrowOnError> => (options.client ?? client).post<RunDocumentAnalysisPipelineResponses, RunDocumentAnalysisPipelineErrors, ThrowOnError>({ url: '/organization/{org_id}/document-analysis/{template_id}/pipeline', ...options });

/**
 * Get Annual Report Pipeline Status
 *
 * Get aggregated annual report pipeline status across templates. Returns null when no execution exists.
 */
export const getAnnualReportPipelineStatus = <ThrowOnError extends boolean = false>(options: Options<GetAnnualReportPipelineStatusData, ThrowOnError>): RequestResult<GetAnnualReportPipelineStatusResponses, GetAnnualReportPipelineStatusErrors, ThrowOnError> => (options.client ?? client).get<GetAnnualReportPipelineStatusResponses, GetAnnualReportPipelineStatusErrors, ThrowOnError>({ url: '/organization/{org_id}/document-analysis/client/{project_id}/pipeline/status', ...options });

/**
 * Create Workflow
 *
 * Create a task inside a task set.
 *
 * The caller must have `create_workflow` on the parent task set's
 * scope: the per-resource `ResourcePermission` owner-action bundle for personal task sets, project-scoped role
 * for project-promoted ones, project_type cascade otherwise.
 */
export const createWorkflow = <ThrowOnError extends boolean = false>(options: Options<CreateWorkflowData, ThrowOnError>): RequestResult<CreateWorkflowResponses, CreateWorkflowErrors, ThrowOnError> => (options.client ?? client).post<CreateWorkflowResponses, CreateWorkflowErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Workflow
 *
 * Delete a task. Owner-only for personal parent task set; project-scoped gate for org-wide.
 */
export const deleteWorkflow = <ThrowOnError extends boolean = false>(options: Options<DeleteWorkflowData, ThrowOnError>): RequestResult<DeleteWorkflowResponses, DeleteWorkflowErrors, ThrowOnError> => (options.client ?? client).delete<DeleteWorkflowResponses, DeleteWorkflowErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/task/{workflow_id}', ...options });

/**
 * Update Workflow
 *
 * Update a task.
 *
 * The factory dependency authorizes against the *current* parent
 * task set. If `workflow_set_id` moves the task to a different parent,
 * that new parent is also checked here.
 */
export const updateWorkflow = <ThrowOnError extends boolean = false>(options: Options<UpdateWorkflowData, ThrowOnError>): RequestResult<UpdateWorkflowResponses, UpdateWorkflowErrors, ThrowOnError> => (options.client ?? client).put<UpdateWorkflowResponses, UpdateWorkflowErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task/{workflow_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Reorder Workflow
 *
 * Reorder a task relative to another task (before/after).
 *
 * Owner-only for personal parent task set; project-scoped gate for org-wide.
 * Uses float-based fractional indexing; rebalances on precision exhaustion.
 */
export const reorderWorkflow = <ThrowOnError extends boolean = false>(options: Options<ReorderWorkflowData, ThrowOnError>): RequestResult<ReorderWorkflowResponses, ReorderWorkflowErrors, ThrowOnError> => (options.client ?? client).patch<ReorderWorkflowResponses, ReorderWorkflowErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task/{workflow_id}/reorder',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Set Workflow Excel Template
 *
 * Set the excel template for the latest task version.
 *
 * Approved -> forks a new draft with the template; draft -> updates in place.
 * Owner-only for personal parent task set.
 */
export const setWorkflowExcelTemplate = <ThrowOnError extends boolean = false>(options: Options<SetWorkflowExcelTemplateData, ThrowOnError>): RequestResult<SetWorkflowExcelTemplateResponses, SetWorkflowExcelTemplateErrors, ThrowOnError> => (options.client ?? client).patch<SetWorkflowExcelTemplateResponses, SetWorkflowExcelTemplateErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task/{workflow_id}/version/excel-template',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Set Workflow Client Tags
 *
 * Replace the client tags a task applies to. An empty list makes it global.
 *
 * A dedicated sub-resource so the task payload stays untouched, and
 * deliberately outside the approved-set freeze: which clients a task is
 * meant for is targeting, not reviewed content, so it mints no new version.
 * The caller picks from the vocabulary of each type the task set serves;
 * creating tags stays with whoever governs it.
 */
export const setWorkflowClientTags = <ThrowOnError extends boolean = false>(options: Options<SetWorkflowClientTagsData, ThrowOnError>): RequestResult<SetWorkflowClientTagsResponses, SetWorkflowClientTagsErrors, ThrowOnError> => (options.client ?? client).put<SetWorkflowClientTagsResponses, SetWorkflowClientTagsErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task/{workflow_id}/client-tags',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Place Workflow
 *
 * Move or reorder an item in the combined workflow tree atomically.
 */
export const placeWorkflow = <ThrowOnError extends boolean = false>(options: Options<PlaceWorkflowData, ThrowOnError>): RequestResult<PlaceWorkflowResponses, PlaceWorkflowErrors, ThrowOnError> => (options.client ?? client).patch<PlaceWorkflowResponses, PlaceWorkflowErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task/{workflow_id}/place',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Clone Workflow
 *
 * Copy a task in place, into new personal/domain containers, or both.
 *
 * Preserves actions, parameters, datasource links, client tags, content language
 * and the Excel template. Personal copies need source visibility; domain
 * copies need create rights on every target. All copies need direct read
 * access to attached datasources. Current-workflow copies require an editable
 * parent; copying to new sets does not modify the approved source.
 */
export const cloneWorkflow = <ThrowOnError extends boolean = false>(options: Options<CloneWorkflowData, ThrowOnError>): RequestResult<CloneWorkflowResponses, CloneWorkflowErrors, ThrowOnError> => (options.client ?? client).post<CloneWorkflowResponses, CloneWorkflowErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task/{workflow_id}/copies',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Workflow Sets
 */
export const getWorkflowSets = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowSetsData, ThrowOnError>): RequestResult<GetWorkflowSetsResponses, GetWorkflowSetsErrors, ThrowOnError> => (options.client ?? client).get<GetWorkflowSetsResponses, GetWorkflowSetsErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/task-set', ...options });

/**
 * Create Workflow Set
 *
 * Create a task set at one of three scope tiers.
 *
 * Personal (`scope.type="personal"`): authored by the caller;
 * ownership held via the per-resource `ResourcePermission` owner-action
 * bundle scoped to the new task set id.
 *
 * Project (`scope.type="project"`): attached to one or more projects.
 * Requires `("project.<project_id>", "create_workflow")` on
 * every project supplied (held by `project_editor` and inherited by
 * `project_admin` / `org_admin` via the type-scope cascade). Container
 * nodes of a structural type (audit_client) are rejected; work lives on
 * the dossiers beneath them.
 * Every id must also resolve inside the caller's organization; one that
 * does not fails the whole request, like one that does not exist.
 *
 * Project-type (`scope.type="project_type"`): library task set
 * promoted to every project of the type. Structural types (audit_client)
 * are rejected; they group projects rather than hold work. Requires
 * `("project_type.<type_uuid>", "create_workflow")`; held by
 * `project_admin` scoped to the type and `org_admin` / `org_owner`
 * via YAML wildcards.
 */
export const createWorkflowSet = <ThrowOnError extends boolean = false>(options: Options<CreateWorkflowSetData, ThrowOnError>): RequestResult<CreateWorkflowSetResponses, CreateWorkflowSetErrors, ThrowOnError> => (options.client ?? client).post<CreateWorkflowSetResponses, CreateWorkflowSetErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task-set',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Workflow Set
 *
 * Delete a task set. Owner-only for personal; project-scoped gate for org-wide.
 */
export const deleteWorkflowSet = <ThrowOnError extends boolean = false>(options: Options<DeleteWorkflowSetData, ThrowOnError>): RequestResult<DeleteWorkflowSetResponses, DeleteWorkflowSetErrors, ThrowOnError> => (options.client ?? client).delete<DeleteWorkflowSetResponses, DeleteWorkflowSetErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/task-set/{taskset_id}', ...options });

/**
 * Update Workflow Set
 *
 * Update a task set. Owner-only for personal; project-scoped gate for org-wide.
 */
export const updateWorkflowSet = <ThrowOnError extends boolean = false>(options: Options<UpdateWorkflowSetData, ThrowOnError>): RequestResult<UpdateWorkflowSetResponses, UpdateWorkflowSetErrors, ThrowOnError> => (options.client ?? client).put<UpdateWorkflowSetResponses, UpdateWorkflowSetErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task-set/{taskset_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Reorder Workflow Set
 *
 * Reorder a task set relative to another task set (before/after).
 *
 * Owner-only for personal task sets;
 * `("project", "update_workflow")` for org-wide.
 */
export const reorderWorkflowSet = <ThrowOnError extends boolean = false>(options: Options<ReorderWorkflowSetData, ThrowOnError>): RequestResult<ReorderWorkflowSetResponses, ReorderWorkflowSetErrors, ThrowOnError> => (options.client ?? client).patch<ReorderWorkflowSetResponses, ReorderWorkflowSetErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task-set/{taskset_id}/reorder',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Place Workflow Set
 *
 * Move or reorder a set in the combined workflow tree atomically.
 */
export const placeWorkflowSet = <ThrowOnError extends boolean = false>(options: Options<PlaceWorkflowSetData, ThrowOnError>): RequestResult<PlaceWorkflowSetResponses, PlaceWorkflowSetErrors, ThrowOnError> => (options.client ?? client).patch<PlaceWorkflowSetResponses, PlaceWorkflowSetErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task-set/{taskset_id}/place',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Clone Workflow Set
 *
 * Copy a hierarchy into Personal, domain proposals at the same audience, or both.
 *
 * Each domain copy has an independent approval request; personal copies are
 * owned by the caller without review. Latest task definitions are copied;
 * execution history and schedules are excluded. All modes require source
 * visibility and datasource read access. Domain copies also require create
 * rights on every target. Both destinations are created in one transaction.
 * The source remains unchanged.
 */
export const cloneWorkflowSet = <ThrowOnError extends boolean = false>(options: Options<CloneWorkflowSetData, ThrowOnError>): RequestResult<CloneWorkflowSetResponses, CloneWorkflowSetErrors, ThrowOnError> => (options.client ?? client).post<CloneWorkflowSetResponses, CloneWorkflowSetErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task-set/{taskset_id}/copies',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Submit For Approval
 */
export const submitForApproval = <ThrowOnError extends boolean = false>(options: Options<SubmitForApprovalData, ThrowOnError>): RequestResult<SubmitForApprovalResponses, SubmitForApprovalErrors, ThrowOnError> => (options.client ?? client).post<SubmitForApprovalResponses, SubmitForApprovalErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task-set/{taskset_id}/submit',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Approve
 */
export const approve = <ThrowOnError extends boolean = false>(options: Options<ApproveData, ThrowOnError>): RequestResult<ApproveResponses, ApproveErrors, ThrowOnError> => (options.client ?? client).post<ApproveResponses, ApproveErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task-set/{taskset_id}/approve',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Reject
 */
export const reject = <ThrowOnError extends boolean = false>(options: Options<RejectData, ThrowOnError>): RequestResult<RejectResponses, RejectErrors, ThrowOnError> => (options.client ?? client).post<RejectResponses, RejectErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task-set/{taskset_id}/reject',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Cancel
 */
export const cancel = <ThrowOnError extends boolean = false>(options: Options<CancelData, ThrowOnError>): RequestResult<CancelResponses, CancelErrors, ThrowOnError> => (options.client ?? client).post<CancelResponses, CancelErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/task-set/{taskset_id}/cancel', ...options });

/**
 * Demote
 */
export const demote = <ThrowOnError extends boolean = false>(options: Options<DemoteData, ThrowOnError>): RequestResult<DemoteResponses, DemoteErrors, ThrowOnError> => (options.client ?? client).post<DemoteResponses, DemoteErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/task-set/{taskset_id}/demote', ...options });

/**
 * Unapprove
 */
export const unapprove = <ThrowOnError extends boolean = false>(options: Options<UnapproveData, ThrowOnError>): RequestResult<UnapproveResponses, UnapproveErrors, ThrowOnError> => (options.client ?? client).post<UnapproveResponses, UnapproveErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/task-set/{taskset_id}/unapprove', ...options });

/**
 * To Maintenance
 */
export const toMaintenance = <ThrowOnError extends boolean = false>(options: Options<ToMaintenanceData, ThrowOnError>): RequestResult<ToMaintenanceResponses, ToMaintenanceErrors, ThrowOnError> => (options.client ?? client).post<ToMaintenanceResponses, ToMaintenanceErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/task-set/{taskset_id}/maintenance', ...options });

/**
 * Resume
 */
export const resume = <ThrowOnError extends boolean = false>(options: Options<ResumeData, ThrowOnError>): RequestResult<ResumeResponses, ResumeErrors, ThrowOnError> => (options.client ?? client).post<ResumeResponses, ResumeErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/task-set/{taskset_id}/resume', ...options });

/**
 * Submit Individual Workflow
 */
export const submitIndividualWorkflow = <ThrowOnError extends boolean = false>(options: Options<SubmitIndividualWorkflowData, ThrowOnError>): RequestResult<SubmitIndividualWorkflowResponses, SubmitIndividualWorkflowErrors, ThrowOnError> => (options.client ?? client).post<SubmitIndividualWorkflowResponses, SubmitIndividualWorkflowErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task/{workflow_id}/submit',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Approve Individual Workflow
 */
export const approveIndividualWorkflow = <ThrowOnError extends boolean = false>(options: Options<ApproveIndividualWorkflowData, ThrowOnError>): RequestResult<ApproveIndividualWorkflowResponses, ApproveIndividualWorkflowErrors, ThrowOnError> => (options.client ?? client).post<ApproveIndividualWorkflowResponses, ApproveIndividualWorkflowErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task/{workflow_id}/approve',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Reset Individual Workflow Approval
 */
export const resetIndividualWorkflowApproval = <ThrowOnError extends boolean = false>(options: Options<ResetIndividualWorkflowApprovalData, ThrowOnError>): RequestResult<ResetIndividualWorkflowApprovalResponses, ResetIndividualWorkflowApprovalErrors, ThrowOnError> => (options.client ?? client).post<ResetIndividualWorkflowApprovalResponses, ResetIndividualWorkflowApprovalErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/task/{workflow_id}/reset-approval', ...options });

/**
 * Reject Individual Workflow
 */
export const rejectIndividualWorkflow = <ThrowOnError extends boolean = false>(options: Options<RejectIndividualWorkflowData, ThrowOnError>): RequestResult<RejectIndividualWorkflowResponses, RejectIndividualWorkflowErrors, ThrowOnError> => (options.client ?? client).post<RejectIndividualWorkflowResponses, RejectIndividualWorkflowErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task/{workflow_id}/reject',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Workflow Actions
 *
 * List actions for a task. Visibility is enforced by the path dependency.
 */
export const getWorkflowActions = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowActionsData, ThrowOnError>): RequestResult<GetWorkflowActionsResponses, GetWorkflowActionsErrors, ThrowOnError> => (options.client ?? client).get<GetWorkflowActionsResponses, GetWorkflowActionsErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/task/{workflow_id}/action', ...options });

/**
 * Create Workflow Action
 */
export const createWorkflowAction = <ThrowOnError extends boolean = false>(options: Options<CreateWorkflowActionData, ThrowOnError>): RequestResult<CreateWorkflowActionResponses, CreateWorkflowActionErrors, ThrowOnError> => (options.client ?? client).post<CreateWorkflowActionResponses, CreateWorkflowActionErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task/{workflow_id}/action',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Analyze Workflow Action Sql Parameters
 *
 * Report how unsaved SQL binds line up with an unsaved parameters schema.
 *
 * Side-effect free so the editor can call it while the user types; the
 * action update and execute routes enforce the same rule.
 */
export const analyzeWorkflowActionSqlParameters = <ThrowOnError extends boolean = false>(options: Options<AnalyzeWorkflowActionSqlParametersData, ThrowOnError>): RequestResult<AnalyzeWorkflowActionSqlParametersResponses, AnalyzeWorkflowActionSqlParametersErrors, ThrowOnError> => (options.client ?? client).post<AnalyzeWorkflowActionSqlParametersResponses, AnalyzeWorkflowActionSqlParametersErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task/{workflow_id}/action/analyze-sql-parameters',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Workflow Action
 */
export const deleteWorkflowAction = <ThrowOnError extends boolean = false>(options: Options<DeleteWorkflowActionData, ThrowOnError>): RequestResult<DeleteWorkflowActionResponses, DeleteWorkflowActionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteWorkflowActionResponses, DeleteWorkflowActionErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/task/{workflow_id}/action/{action_id}', ...options });

/**
 * Get Workflow Action
 */
export const getWorkflowAction = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowActionData, ThrowOnError>): RequestResult<GetWorkflowActionResponses, GetWorkflowActionErrors, ThrowOnError> => (options.client ?? client).get<GetWorkflowActionResponses, GetWorkflowActionErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/task/{workflow_id}/action/{action_id}', ...options });

/**
 * Update Workflow Action
 */
export const updateWorkflowAction = <ThrowOnError extends boolean = false>(options: Options<UpdateWorkflowActionData, ThrowOnError>): RequestResult<UpdateWorkflowActionResponses, UpdateWorkflowActionErrors, ThrowOnError> => (options.client ?? client).put<UpdateWorkflowActionResponses, UpdateWorkflowActionErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task/{workflow_id}/action/{action_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Generate Action Technical Explanation
 *
 * Generate a technical explanation for an audit action using AI.
 *
 * Analyzes the action's workflow and SQL queries to generate a line-by-line
 * explanation suitable for documentation purposes.
 *
 * Returns:
 *     WorkflowAction: The action with updated technical_explanation field.
 */
export const generateActionTechnicalExplanation = <ThrowOnError extends boolean = false>(options: Options<GenerateActionTechnicalExplanationData, ThrowOnError>): RequestResult<GenerateActionTechnicalExplanationResponses, GenerateActionTechnicalExplanationErrors, ThrowOnError> => (options.client ?? client).post<GenerateActionTechnicalExplanationResponses, GenerateActionTechnicalExplanationErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/task/{workflow_id}/action/{action_id}/generate-technical-explanation', ...options });

/**
 * Reorder Workflow Action
 *
 * Reorder an action relative to another action (before/after).
 *
 * Owner-only for personal parent task set; project-scoped gate for
 * org-wide. Uses float-based fractional indexing.
 */
export const reorderWorkflowAction = <ThrowOnError extends boolean = false>(options: Options<ReorderWorkflowActionData, ThrowOnError>): RequestResult<ReorderWorkflowActionResponses, ReorderWorkflowActionErrors, ThrowOnError> => (options.client ?? client).patch<ReorderWorkflowActionResponses, ReorderWorkflowActionErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task/{workflow_id}/action/{action_id}/reorder',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Clone Workflow Action
 *
 * Clone an action into a different task.
 *
 * The source task is authorized via the path dependency; the target
 * task (resolved from the request body) is authorized inline. Both
 * must be writable by the caller; owner for personal task sets,
 * `project:update_workflow` for org-wide.
 */
export const cloneWorkflowAction = <ThrowOnError extends boolean = false>(options: Options<CloneWorkflowActionData, ThrowOnError>): RequestResult<CloneWorkflowActionResponses, CloneWorkflowActionErrors, ThrowOnError> => (options.client ?? client).post<CloneWorkflowActionResponses, CloneWorkflowActionErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task/{workflow_id}/action/{action_id}/clone',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Move Workflow Action
 *
 * Move an action into a different task.
 *
 * Source task is authorized via the path dependency; target task is
 * authorized inline. Both task sets must be writable by the caller.
 */
export const moveWorkflowAction = <ThrowOnError extends boolean = false>(options: Options<MoveWorkflowActionData, ThrowOnError>): RequestResult<MoveWorkflowActionResponses, MoveWorkflowActionErrors, ThrowOnError> => (options.client ?? client).post<MoveWorkflowActionResponses, MoveWorkflowActionErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task/{workflow_id}/action/{action_id}/move',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Copy Workflow Action
 *
 * Copy a leaf action into explicitly selected existing workflows, atomically.
 *
 * Targets may include the current workflow or workflows in Personal and any
 * domain in the same organization. Every destination must be visible,
 * writable and editable. Attached datasources require direct read access;
 * parameter schemas must be compatible with each destination. No parent
 * workflow sets or workflows are created.
 */
export const copyWorkflowAction = <ThrowOnError extends boolean = false>(options: Options<CopyWorkflowActionData, ThrowOnError>): RequestResult<CopyWorkflowActionResponses, CopyWorkflowActionErrors, ThrowOnError> => (options.client ?? client).post<CopyWorkflowActionResponses, CopyWorkflowActionErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/task/{workflow_id}/action/{action_id}/copies',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Execute Audit Workflow
 *
 * Execute multiple workflow actions with SSE streaming.
 *
 * Routing and authorization for the project-vs-personal fork live in
 * `get_workflow_execution_target_from_path`; the handler just consumes
 * the resolved `(task, project | None, scope_id)` triple.
 *
 * Two run modes (resolved in the path dep):
 *   - **Project run** (`project_id` query param set): requires the
 *     `("project.<id>", "perform_audit")` grant. Parameters resolve
 *     from `project.parameters`, with optional
 *     `parameters_overrides_json` taking precedence.
 *   - **Personal run** (`project_id` omitted): requires that the
 *     task's parent task set is personal AND the caller holds
 *     `execute_workflow_set` on it. Parameters come from
 *     `parameters_overrides_json` plus per-action schema defaults.
 */
export const executeAuditWorkflow = <ThrowOnError extends boolean = false>(options: Options<ExecuteAuditWorkflowData, ThrowOnError, ExecuteAuditWorkflowResponse>): Promise<ServerSentEventsResult<ExecuteAuditWorkflowResponses>> => (options.client ?? client).sse.get<ExecuteAuditWorkflowResponses, ExecuteAuditWorkflowErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/task/{workflow_id}/execute', ...options });

/**
 * Get Project Execution History
 *
 * Every workflow run performed in this project, newest first.
 *
 * Independent of the workflow catalogue by design: runs whose
 * workflow was edited, deleted or demoted are returned exactly like
 * any other, carrying the name, version and action list they had when
 * they ran. That is what makes this the dossier's audit trail rather
 * than a decoration on the task tree.
 */
export const getProjectExecutionHistory = <ThrowOnError extends boolean = false>(options: Options<GetProjectExecutionHistoryData, ThrowOnError>): RequestResult<GetProjectExecutionHistoryResponses, GetProjectExecutionHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetProjectExecutionHistoryResponses, GetProjectExecutionHistoryErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/project/{project_id}/executions', ...options });

/**
 * Get Execution Results
 *
 * Read one past run's stored output, addressed by the run itself.
 *
 * The caller supplies only the execution id: which actions ran, and
 * which threads hold their output, come from the record rather than
 * from the workflow's current definition. That is what makes an edited
 * or deleted workflow's history still readable.
 */
export const getExecutionResults = <ThrowOnError extends boolean = false>(options: Options<GetExecutionResultsData, ThrowOnError>): RequestResult<GetExecutionResultsResponses, GetExecutionResultsErrors, ThrowOnError> => (options.client ?? client).get<GetExecutionResultsResponses, GetExecutionResultsErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/executions/{execution_id}/results', ...options });

/**
 * Create Chat From Execution
 *
 * Continue a past action's transcript as a chat.
 *
 * Addressed by the run and the thread it wrote, never by the workflow,
 * so a run whose workflow or actions were deleted is still openable.
 * The thread must belong to this run, which is what stops the parameter
 * being a way to read arbitrary conversations.
 */
export const createChatFromExecution = <ThrowOnError extends boolean = false>(options: Options<CreateChatFromExecutionData, ThrowOnError>): RequestResult<CreateChatFromExecutionResponses, CreateChatFromExecutionErrors, ThrowOnError> => (options.client ?? client).post<CreateChatFromExecutionResponses, CreateChatFromExecutionErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/executions/{execution_id}/chat', ...options });

/**
 * List Schedules
 *
 * List the schedules in the caller's organization the caller may read.
 */
export const listSchedules = <ThrowOnError extends boolean = false>(options: Options<ListSchedulesData, ThrowOnError>): RequestResult<ListSchedulesResponses, ListSchedulesErrors, ThrowOnError> => (options.client ?? client).get<ListSchedulesResponses, ListSchedulesErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/schedules', ...options });

/**
 * Create Schedule
 *
 * Create a new workflow schedule owned by the caller.
 *
 * Authorization mirrors `/task/{workflow_id}/execute`: a schedule is just
 * "future execution under these conditions", so the caller must already
 * be allowed to execute the task immediately. Cross-org / unreachable
 * tasks 404; visible-but-unauthorized 403.
 */
export const createSchedule = <ThrowOnError extends boolean = false>(options: Options<CreateScheduleData, ThrowOnError>): RequestResult<CreateScheduleResponses, CreateScheduleErrors, ThrowOnError> => (options.client ?? client).post<CreateScheduleResponses, CreateScheduleErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/schedules',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Schedule
 *
 * Delete a schedule. Queued runs for this schedule are cancelled first.
 */
export const deleteSchedule = <ThrowOnError extends boolean = false>(options: Options<DeleteScheduleData, ThrowOnError>): RequestResult<DeleteScheduleResponses, DeleteScheduleErrors, ThrowOnError> => (options.client ?? client).delete<DeleteScheduleResponses, DeleteScheduleErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/schedules/{schedule_id}', ...options });

/**
 * Get Schedule
 *
 * Fetch one schedule by id (403 unless the caller may run its parent).
 */
export const getSchedule = <ThrowOnError extends boolean = false>(options: Options<GetScheduleData, ThrowOnError>): RequestResult<GetScheduleResponses, GetScheduleErrors, ThrowOnError> => (options.client ?? client).get<GetScheduleResponses, GetScheduleErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/schedules/{schedule_id}', ...options });

/**
 * Update Schedule
 *
 * Patch a schedule. Only the fields you pass are touched.
 */
export const updateSchedule = <ThrowOnError extends boolean = false>(options: Options<UpdateScheduleData, ThrowOnError>): RequestResult<UpdateScheduleResponses, UpdateScheduleErrors, ThrowOnError> => (options.client ?? client).patch<UpdateScheduleResponses, UpdateScheduleErrors, ThrowOnError>({
  url: '/organization/{org_id}/workflow/schedules/{schedule_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * List Runs
 *
 * Run history for one schedule.
 */
export const listRuns = <ThrowOnError extends boolean = false>(options: Options<ListRunsData, ThrowOnError>): RequestResult<ListRunsResponses, ListRunsErrors, ThrowOnError> => (options.client ?? client).get<ListRunsResponses, ListRunsErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/schedules/{schedule_id}/runs', ...options });

/**
 * Trigger Manual Run
 *
 * Queue an ad-hoc run of the schedule's workflow under the caller's identity.
 *
 * Auth mirrors `create_schedule`; the caller must be allowed to execute
 * the underlying task under the schedule's scope, not merely belong to
 * the schedule's org. Without this check any org member could trigger a
 * same-org schedule for a personal/project-scoped task they otherwise
 * couldn't execute.
 */
export const triggerManualRun = <ThrowOnError extends boolean = false>(options: Options<TriggerManualRunData, ThrowOnError>): RequestResult<TriggerManualRunResponses, TriggerManualRunErrors, ThrowOnError> => (options.client ?? client).post<TriggerManualRunResponses, TriggerManualRunErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/schedules/{schedule_id}/runs', ...options });

/**
 * List Org Runs
 *
 * Org-wide run history, newest scheduled_fire_at first.
 *
 * Backs the Workflow results tab. Scoped to the caller's organization;
 * finer scope-aware filtering is not yet implemented.
 */
export const listOrgRuns = <ThrowOnError extends boolean = false>(options: Options<ListOrgRunsData, ThrowOnError>): RequestResult<ListOrgRunsResponses, ListOrgRunsErrors, ThrowOnError> => (options.client ?? client).get<ListOrgRunsResponses, ListOrgRunsErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/runs', ...options });

/**
 * Get Run
 *
 * Fetch one run by id (403 unless the caller may run its parent).
 */
export const getRun = <ThrowOnError extends boolean = false>(options: Options<GetRunData, ThrowOnError>): RequestResult<GetRunResponses, GetRunErrors, ThrowOnError> => (options.client ?? client).get<GetRunResponses, GetRunErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/runs/{run_id}', ...options });

/**
 * Cancel Run
 *
 * Cancel a queued run.
 *
 * Returns 409 for `running` runs; v1 has no cooperative cancellation
 * path into the executor, so flipping a running row to `cancelled`
 * used to be cosmetic (side effects continued). No-op on terminal
 * states (`succeeded`, `failed`, `cancelled`).
 */
export const cancelRun = <ThrowOnError extends boolean = false>(options: Options<CancelRunData, ThrowOnError>): RequestResult<CancelRunResponses, CancelRunErrors, ThrowOnError> => (options.client ?? client).post<CancelRunResponses, CancelRunErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/runs/{run_id}/cancel', ...options });

/**
 * List Notifications
 *
 * The current user's notifications in this org, newest first.
 */
export const listNotifications = <ThrowOnError extends boolean = false>(options: Options<ListNotificationsData, ThrowOnError>): RequestResult<ListNotificationsResponses, ListNotificationsErrors, ThrowOnError> => (options.client ?? client).get<ListNotificationsResponses, ListNotificationsErrors, ThrowOnError>({ url: '/organization/{org_id}/notifications', ...options });

/**
 * Unread Count
 *
 * Cheap badge poll; unread count only.
 */
export const unreadCount = <ThrowOnError extends boolean = false>(options: Options<UnreadCountData, ThrowOnError>): RequestResult<UnreadCountResponses, UnreadCountErrors, ThrowOnError> => (options.client ?? client).get<UnreadCountResponses, UnreadCountErrors, ThrowOnError>({ url: '/organization/{org_id}/notifications/unread-count', ...options });

/**
 * Mark Read
 *
 * Mark one notification read (404 if it isn't the caller's).
 */
export const markRead = <ThrowOnError extends boolean = false>(options: Options<MarkReadData, ThrowOnError>): RequestResult<MarkReadResponses, MarkReadErrors, ThrowOnError> => (options.client ?? client).post<MarkReadResponses, MarkReadErrors, ThrowOnError>({ url: '/organization/{org_id}/notifications/{notification_id}/read', ...options });

/**
 * Mark All Read
 *
 * Mark all the caller's unread notifications read.
 */
export const markAllRead = <ThrowOnError extends boolean = false>(options: Options<MarkAllReadData, ThrowOnError>): RequestResult<MarkAllReadResponses, MarkAllReadErrors, ThrowOnError> => (options.client ?? client).post<MarkAllReadResponses, MarkAllReadErrors, ThrowOnError>({ url: '/organization/{org_id}/notifications/read-all', ...options });

/**
 * Get Execution Report
 *
 * Download the workbook for a past run, addressed by the run itself.
 *
 * Every label in the workbook (task name, action names and
 * descriptions) is read from the record, so deleting or editing the
 * workflow afterwards cannot change or empty a report that has
 * already been filed.
 */
export const getExecutionReport = <ThrowOnError extends boolean = false>(options: Options<GetExecutionReportData, ThrowOnError>): RequestResult<GetExecutionReportResponses, GetExecutionReportErrors, ThrowOnError> => (options.client ?? client).get<GetExecutionReportResponses, GetExecutionReportErrors, ThrowOnError>({ url: '/organization/{org_id}/workflow/executions/{execution_id}/report', ...options });

/**
 * List Project Types
 *
 * Public registry of project types; used to render dynamic create forms.
 */
export const listProjectTypes = <ThrowOnError extends boolean = false>(options: Options<ListProjectTypesData, ThrowOnError>): RequestResult<ListProjectTypesResponses, ListProjectTypesErrors, ThrowOnError> => (options.client ?? client).get<ListProjectTypesResponses, ListProjectTypesErrors, ThrowOnError>({ url: '/organization/{org_id}/project-types', ...options });

/**
 * List Client Tags
 *
 * The organization's tag vocabularies, or only the one serving `project_type`.
 */
export const listClientTags = <ThrowOnError extends boolean = false>(options: Options<ListClientTagsData, ThrowOnError>): RequestResult<ListClientTagsResponses, ListClientTagsErrors, ThrowOnError> => (options.client ?? client).get<ListClientTagsResponses, ListClientTagsErrors, ThrowOnError>({ url: '/organization/{org_id}/client-tag', ...options });

/**
 * Create Client Tag
 *
 * Create a tag, or return the existing one with that name in the same vocabulary.
 *
 * Idempotent on the trimmed, case-insensitive name, so a combobox that
 * creates before it attaches never has to distinguish the two cases.
 */
export const createClientTag = <ThrowOnError extends boolean = false>(options: Options<CreateClientTagData, ThrowOnError>): RequestResult<CreateClientTagResponses, CreateClientTagErrors, ThrowOnError> => (options.client ?? client).post<CreateClientTagResponses, CreateClientTagErrors, ThrowOnError>({
  url: '/organization/{org_id}/client-tag',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Client Tag
 *
 * Delete a tag that nothing references.
 */
export const deleteClientTag = <ThrowOnError extends boolean = false>(options: Options<DeleteClientTagData, ThrowOnError>): RequestResult<DeleteClientTagResponses, DeleteClientTagErrors, ThrowOnError> => (options.client ?? client).delete<DeleteClientTagResponses, DeleteClientTagErrors, ThrowOnError>({ url: '/organization/{org_id}/client-tag/{client_tag_id}', ...options });

/**
 * Rename Client Tag
 *
 * Rename a tag. A name another tag of its type already holds is a conflict, not a merge.
 */
export const renameClientTag = <ThrowOnError extends boolean = false>(options: Options<RenameClientTagData, ThrowOnError>): RequestResult<RenameClientTagResponses, RenameClientTagErrors, ThrowOnError> => (options.client ?? client).patch<RenameClientTagResponses, RenameClientTagErrors, ThrowOnError>({
  url: '/organization/{org_id}/client-tag/{client_tag_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Disconnect Project Vectorized Datasource
 *
 * Disconnect a project vectorized datasource, soft-deleting it when no projects remain.
 *
 * Unlinking from the project is a project-management action gated by
 * `delete_project_datasource`. The org-wide soft-delete that follows once the
 * last link is gone is destructive to the datasource itself, so it also
 * requires `delete_datasource` on the datasource. Without it the link is
 * removed but the datasource is left intact for its owner.
 */
export const disconnectProjectVectorizedDatasource = <ThrowOnError extends boolean = false>(options: Options<DisconnectProjectVectorizedDatasourceData, ThrowOnError>): RequestResult<DisconnectProjectVectorizedDatasourceResponses, DisconnectProjectVectorizedDatasourceErrors, ThrowOnError> => (options.client ?? client).delete<DisconnectProjectVectorizedDatasourceResponses, DisconnectProjectVectorizedDatasourceErrors, ThrowOnError>({ url: '/organization/{org_id}/project/{project_id}/datasources', ...options });

/**
 * List Project Vectorized Datasources
 *
 * List vectorized datasources attached to a project.
 */
export const listProjectVectorizedDatasources = <ThrowOnError extends boolean = false>(options: Options<ListProjectVectorizedDatasourcesData, ThrowOnError>): RequestResult<ListProjectVectorizedDatasourcesResponses, ListProjectVectorizedDatasourcesErrors, ThrowOnError> => (options.client ?? client).get<ListProjectVectorizedDatasourcesResponses, ListProjectVectorizedDatasourcesErrors, ThrowOnError>({ url: '/organization/{org_id}/project/{project_id}/datasources', ...options });

/**
 * Upsert Project File Datasource
 *
 * Create or update a vectorized datasource for a project.
 *
 * Linking is a share-DOWN: the caller must already hold `read_datasource`
 * on the target datasource. `update_project_datasource` on the project is
 * not enough; otherwise a project member could pull a datasource they were
 * never granted into the project and read it via workflow execution.
 */
export const upsertProjectFileDatasource = <ThrowOnError extends boolean = false>(options: Options<UpsertProjectFileDatasourceData, ThrowOnError>): RequestResult<UpsertProjectFileDatasourceResponses, UpsertProjectFileDatasourceErrors, ThrowOnError> => (options.client ?? client).put<UpsertProjectFileDatasourceResponses, UpsertProjectFileDatasourceErrors, ThrowOnError>({
  url: '/organization/{org_id}/project/{project_id}/datasources',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Financial Explorer
 *
 * Return financial explorer rows for the selected project scope and display period.
 */
export const getFinancialExplorer = <ThrowOnError extends boolean = false>(options: Options<GetFinancialExplorerData, ThrowOnError>): RequestResult<GetFinancialExplorerResponses, GetFinancialExplorerErrors, ThrowOnError> => (options.client ?? client).get<GetFinancialExplorerResponses, GetFinancialExplorerErrors, ThrowOnError>({ url: '/organization/{org_id}/projects/{project_id}/financial-explorer', ...options });

/**
 * Get Financial Explorer Reconciliation
 *
 * Return Audit balance evidence with the latest saved local classification.
 */
export const getFinancialExplorerReconciliation = <ThrowOnError extends boolean = false>(options: Options<GetFinancialExplorerReconciliationData, ThrowOnError>): RequestResult<GetFinancialExplorerReconciliationResponses, GetFinancialExplorerReconciliationErrors, ThrowOnError> => (options.client ?? client).get<GetFinancialExplorerReconciliationResponses, GetFinancialExplorerReconciliationErrors, ThrowOnError>({ url: '/organization/{org_id}/projects/{project_id}/financial-explorer/reconciliation', ...options });

/**
 * Get Financial Explorer Transactions
 *
 * Return paged transactions and period totals for one booking year, both under the filters.
 */
export const getFinancialExplorerTransactions = <ThrowOnError extends boolean = false>(options: Options<GetFinancialExplorerTransactionsData, ThrowOnError>): RequestResult<GetFinancialExplorerTransactionsResponses, GetFinancialExplorerTransactionsErrors, ThrowOnError> => (options.client ?? client).get<GetFinancialExplorerTransactionsResponses, GetFinancialExplorerTransactionsErrors, ThrowOnError>({ url: '/organization/{org_id}/projects/{project_id}/financial-explorer/transactions', ...options });

/**
 * Get Financial Explorer Transaction Filter Values
 *
 * Return one page of a column's distinct values under every filter except the column's own.
 */
export const getFinancialExplorerTransactionFilterValues = <ThrowOnError extends boolean = false>(options: Options<GetFinancialExplorerTransactionFilterValuesData, ThrowOnError>): RequestResult<GetFinancialExplorerTransactionFilterValuesResponses, GetFinancialExplorerTransactionFilterValuesErrors, ThrowOnError> => (options.client ?? client).get<GetFinancialExplorerTransactionFilterValuesResponses, GetFinancialExplorerTransactionFilterValuesErrors, ThrowOnError>({ url: '/organization/{org_id}/projects/{project_id}/financial-explorer/transactions/filter-values', ...options });

/**
 * Create Financial Explorer Chat
 *
 * Open a chat about the Financial Explorer with the whole explorer, and optionally one account's transactions.
 *
 * Nothing is attached: the explorer's tables are mostly not registered
 * datasources, so its rows travel with the chat, and anything further is left
 * to datasource discovery.
 */
export const createFinancialExplorerChat = <ThrowOnError extends boolean = false>(options: Options<CreateFinancialExplorerChatData, ThrowOnError>): RequestResult<CreateFinancialExplorerChatResponses, CreateFinancialExplorerChatErrors, ThrowOnError> => (options.client ?? client).post<CreateFinancialExplorerChatResponses, CreateFinancialExplorerChatErrors, ThrowOnError>({
  url: '/organization/{org_id}/projects/{project_id}/financial-explorer/chat',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Clear Account Mappings
 *
 * Remove every AI and manual mapping of the project.
 */
export const clearAccountMappings = <ThrowOnError extends boolean = false>(options: Options<ClearAccountMappingsData, ThrowOnError>): RequestResult<ClearAccountMappingsResponses, ClearAccountMappingsErrors, ThrowOnError> => (options.client ?? client).delete<ClearAccountMappingsResponses, ClearAccountMappingsErrors, ThrowOnError>({ url: '/organization/{org_id}/corporate-finance/{project_id}/account-mappings', ...options });

/**
 * List Account Mappings
 *
 * Return the project mapping targets and per-year accounts, or null when none exist.
 */
export const listAccountMappings = <ThrowOnError extends boolean = false>(options: Options<ListAccountMappingsData, ThrowOnError>): RequestResult<ListAccountMappingsResponses, ListAccountMappingsErrors, ThrowOnError> => (options.client ?? client).get<ListAccountMappingsResponses, ListAccountMappingsErrors, ThrowOnError>({ url: '/organization/{org_id}/corporate-finance/{project_id}/account-mappings', ...options });

/**
 * Save Account Mappings
 *
 * Persist complete manual mapping selections for the project.
 */
export const saveAccountMappings = <ThrowOnError extends boolean = false>(options: Options<SaveAccountMappingsData, ThrowOnError>): RequestResult<SaveAccountMappingsResponses, SaveAccountMappingsErrors, ThrowOnError> => (options.client ?? client).patch<SaveAccountMappingsResponses, SaveAccountMappingsErrors, ThrowOnError>({
  url: '/organization/{org_id}/corporate-finance/{project_id}/account-mappings',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Classify Account Mappings
 *
 * Classify and persist the project AI account-mapping overlay.
 */
export const classifyAccountMappings = <ThrowOnError extends boolean = false>(options: Options<ClassifyAccountMappingsData, ThrowOnError>): RequestResult<ClassifyAccountMappingsResponses, ClassifyAccountMappingsErrors, ThrowOnError> => (options.client ?? client).post<ClassifyAccountMappingsResponses, ClassifyAccountMappingsErrors, ThrowOnError>({ url: '/organization/{org_id}/corporate-finance/{project_id}/account-mappings/classify', ...options });

/**
 * Classify Scoped Account Mappings
 *
 * Reclassify selected ledger-account codes across the project.
 */
export const classifyScopedAccountMappings = <ThrowOnError extends boolean = false>(options: Options<ClassifyScopedAccountMappingsData, ThrowOnError>): RequestResult<ClassifyScopedAccountMappingsResponses, ClassifyScopedAccountMappingsErrors, ThrowOnError> => (options.client ?? client).post<ClassifyScopedAccountMappingsResponses, ClassifyScopedAccountMappingsErrors, ThrowOnError>({
  url: '/organization/{org_id}/corporate-finance/{project_id}/account-mappings/classify-scoped',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Add Account Mapping Level 3 Target
 *
 * Add a Level-3 target beneath a current confirmed statement path.
 */
export const addAccountMappingLevel3Target = <ThrowOnError extends boolean = false>(options: Options<AddAccountMappingLevel3TargetData, ThrowOnError>): RequestResult<AddAccountMappingLevel3TargetResponses, AddAccountMappingLevel3TargetErrors, ThrowOnError> => (options.client ?? client).post<AddAccountMappingLevel3TargetResponses, AddAccountMappingLevel3TargetErrors, ThrowOnError>({
  url: '/organization/{org_id}/corporate-finance/{project_id}/account-mappings/level-3-targets',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Copy Account Mappings
 *
 * Copy a readable sibling entity's mappings into the target project.
 */
export const copyAccountMappings = <ThrowOnError extends boolean = false>(options: Options<CopyAccountMappingsData, ThrowOnError>): RequestResult<CopyAccountMappingsResponses, CopyAccountMappingsErrors, ThrowOnError> => (options.client ?? client).post<CopyAccountMappingsResponses, CopyAccountMappingsErrors, ThrowOnError>({
  url: '/organization/{org_id}/corporate-finance/{project_id}/account-mappings/copy',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Export Account Mappings
 *
 * Export the selected project-year account-mapping snapshot to Fabric.
 */
export const exportAccountMappings = <ThrowOnError extends boolean = false>(options: Options<ExportAccountMappingsData, ThrowOnError>): RequestResult<ExportAccountMappingsResponses, ExportAccountMappingsErrors, ThrowOnError> => (options.client ?? client).post<ExportAccountMappingsResponses, ExportAccountMappingsErrors, ThrowOnError>({ url: '/organization/{org_id}/corporate-finance/{project_id}/account-mappings/export', ...options });

/**
 * Get Account Mapping Export Status
 *
 * Return the latest Corporate Finance classification export status.
 */
export const getAccountMappingExportStatus = <ThrowOnError extends boolean = false>(options: Options<GetAccountMappingExportStatusData, ThrowOnError>): RequestResult<GetAccountMappingExportStatusResponses, GetAccountMappingExportStatusErrors, ThrowOnError> => (options.client ?? client).get<GetAccountMappingExportStatusResponses, GetAccountMappingExportStatusErrors, ThrowOnError>({ url: '/organization/{org_id}/corporate-finance/{project_id}/account-mappings/export/status', ...options });

/**
 * Read Project Statement Taxonomy
 *
 * Return the taxonomy this project's extraction runs are built from.
 */
export const readProjectStatementTaxonomy = <ThrowOnError extends boolean = false>(options: Options<ReadProjectStatementTaxonomyData, ThrowOnError>): RequestResult<ReadProjectStatementTaxonomyResponses, ReadProjectStatementTaxonomyErrors, ThrowOnError> => (options.client ?? client).get<ReadProjectStatementTaxonomyResponses, ReadProjectStatementTaxonomyErrors, ThrowOnError>({ url: '/organization/{org_id}/corporate-finance/{project_id}/statement-taxonomy', ...options });

/**
 * Select Project Statement Taxonomy
 *
 * Choose the taxonomy this project's future extraction runs are built from.
 */
export const selectProjectStatementTaxonomy = <ThrowOnError extends boolean = false>(options: Options<SelectProjectStatementTaxonomyData, ThrowOnError>): RequestResult<SelectProjectStatementTaxonomyResponses, SelectProjectStatementTaxonomyErrors, ThrowOnError> => (options.client ?? client).put<SelectProjectStatementTaxonomyResponses, SelectProjectStatementTaxonomyErrors, ThrowOnError>({
  url: '/organization/{org_id}/corporate-finance/{project_id}/statement-taxonomy',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Start Statement Extraction
 *
 * Run Stage 1A and Stage 1B for all configured project years.
 */
export const startStatementExtraction = <ThrowOnError extends boolean = false>(options: Options<StartStatementExtractionData, ThrowOnError>): RequestResult<StartStatementExtractionResponses, StartStatementExtractionErrors, ThrowOnError> => (options.client ?? client).post<StartStatementExtractionResponses, StartStatementExtractionErrors, ThrowOnError>({ url: '/organization/{org_id}/corporate-finance/{project_id}/statement-extraction/runs', ...options });

/**
 * Latest Statement Extraction
 *
 * Return the current statement-extraction run.
 */
export const latestStatementExtraction = <ThrowOnError extends boolean = false>(options: Options<LatestStatementExtractionData, ThrowOnError>): RequestResult<LatestStatementExtractionResponses, LatestStatementExtractionErrors, ThrowOnError> => (options.client ?? client).get<LatestStatementExtractionResponses, LatestStatementExtractionErrors, ThrowOnError>({ url: '/organization/{org_id}/corporate-finance/{project_id}/statement-extraction/runs/latest', ...options });

/**
 * Start Statement Extraction Deep Stage
 *
 * Run one deep stage for every configured project year.
 */
export const startStatementExtractionDeepStage = <ThrowOnError extends boolean = false>(options: Options<StartStatementExtractionDeepStageData, ThrowOnError>): RequestResult<StartStatementExtractionDeepStageResponses, StartStatementExtractionDeepStageErrors, ThrowOnError> => (options.client ?? client).post<StartStatementExtractionDeepStageResponses, StartStatementExtractionDeepStageErrors, ThrowOnError>({ url: '/organization/{org_id}/corporate-finance/{project_id}/statement-extraction/runs/{run_id}/stages/{stage}', ...options });

/**
 * Replace Statement Extraction Stage
 *
 * Replace one stage with a complete manual snapshot.
 */
export const replaceStatementExtractionStage = <ThrowOnError extends boolean = false>(options: Options<ReplaceStatementExtractionStageData, ThrowOnError>): RequestResult<ReplaceStatementExtractionStageResponses, ReplaceStatementExtractionStageErrors, ThrowOnError> => (options.client ?? client).put<ReplaceStatementExtractionStageResponses, ReplaceStatementExtractionStageErrors, ThrowOnError>({
  url: '/organization/{org_id}/corporate-finance/{project_id}/statement-extraction/runs/{run_id}/stages/{stage}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Confirm Statement Extraction Stage
 *
 * Confirm one stage after every exact control passes.
 */
export const confirmStatementExtractionStage = <ThrowOnError extends boolean = false>(options: Options<ConfirmStatementExtractionStageData, ThrowOnError>): RequestResult<ConfirmStatementExtractionStageResponses, ConfirmStatementExtractionStageErrors, ThrowOnError> => (options.client ?? client).post<ConfirmStatementExtractionStageResponses, ConfirmStatementExtractionStageErrors, ThrowOnError>({ url: '/organization/{org_id}/corporate-finance/{project_id}/statement-extraction/runs/{run_id}/stages/{stage}/confirm', ...options });

/**
 * Deconfirm Statement Extraction Stage
 *
 * Return one confirmed stage to review while retaining its snapshot.
 */
export const deconfirmStatementExtractionStage = <ThrowOnError extends boolean = false>(options: Options<DeconfirmStatementExtractionStageData, ThrowOnError>): RequestResult<DeconfirmStatementExtractionStageResponses, DeconfirmStatementExtractionStageErrors, ThrowOnError> => (options.client ?? client).post<DeconfirmStatementExtractionStageResponses, DeconfirmStatementExtractionStageErrors, ThrowOnError>({ url: '/organization/{org_id}/corporate-finance/{project_id}/statement-extraction/runs/{run_id}/stages/{stage}/deconfirm', ...options });

/**
 * List Statement Taxonomies
 *
 * Return the library or the template choices for an audit or CF project.
 */
export const listStatementTaxonomies = <ThrowOnError extends boolean = false>(options: Options<ListStatementTaxonomiesData, ThrowOnError>): RequestResult<ListStatementTaxonomiesResponses, ListStatementTaxonomiesErrors, ThrowOnError> => (options.client ?? client).get<ListStatementTaxonomiesResponses, ListStatementTaxonomiesErrors, ThrowOnError>({ url: '/organization/{org_id}/corporate-finance/statement-taxonomies', ...options });

/**
 * Create Statement Taxonomy
 *
 * Open a draft seeded from the default taxonomy or from an existing one.
 */
export const createStatementTaxonomy = <ThrowOnError extends boolean = false>(options: Options<CreateStatementTaxonomyData, ThrowOnError>): RequestResult<CreateStatementTaxonomyResponses, CreateStatementTaxonomyErrors, ThrowOnError> => (options.client ?? client).post<CreateStatementTaxonomyResponses, CreateStatementTaxonomyErrors, ThrowOnError>({
  url: '/organization/{org_id}/corporate-finance/statement-taxonomies',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Read Default Statement Taxonomy
 *
 * Return the packaged default taxonomy, which every organization can copy.
 */
export const readDefaultStatementTaxonomy = <ThrowOnError extends boolean = false>(options: Options<ReadDefaultStatementTaxonomyData, ThrowOnError>): RequestResult<ReadDefaultStatementTaxonomyResponses, ReadDefaultStatementTaxonomyErrors, ThrowOnError> => (options.client ?? client).get<ReadDefaultStatementTaxonomyResponses, ReadDefaultStatementTaxonomyErrors, ThrowOnError>({ url: '/organization/{org_id}/corporate-finance/statement-taxonomies/default', ...options });

/**
 * Archive Statement Taxonomy
 *
 * Retire a taxonomy that no project selects.
 *
 * Takes its locks inside the service, in the order `publish` explains.
 */
export const archiveStatementTaxonomy = <ThrowOnError extends boolean = false>(options: Options<ArchiveStatementTaxonomyData, ThrowOnError>): RequestResult<ArchiveStatementTaxonomyResponses, ArchiveStatementTaxonomyErrors, ThrowOnError> => (options.client ?? client).delete<ArchiveStatementTaxonomyResponses, ArchiveStatementTaxonomyErrors, ThrowOnError>({ url: '/organization/{org_id}/corporate-finance/statement-taxonomies/{taxonomy_id}', ...options });

/**
 * Read Statement Taxonomy
 *
 * Return one taxonomy's current rows.
 *
 * The 404 survives the gate: the tenant select deliberately keeps an archived
 * taxonomy, so an archived id reaches the service and is answered there, as it
 * was before.
 */
export const readStatementTaxonomy = <ThrowOnError extends boolean = false>(options: Options<ReadStatementTaxonomyData, ThrowOnError>): RequestResult<ReadStatementTaxonomyResponses, ReadStatementTaxonomyErrors, ThrowOnError> => (options.client ?? client).get<ReadStatementTaxonomyResponses, ReadStatementTaxonomyErrors, ThrowOnError>({ url: '/organization/{org_id}/corporate-finance/statement-taxonomies/{taxonomy_id}', ...options });

/**
 * Update Statement Taxonomy
 *
 * Replace the taxonomy's draft rows.
 */
export const updateStatementTaxonomy = <ThrowOnError extends boolean = false>(options: Options<UpdateStatementTaxonomyData, ThrowOnError>): RequestResult<UpdateStatementTaxonomyResponses, UpdateStatementTaxonomyErrors, ThrowOnError> => (options.client ?? client).put<UpdateStatementTaxonomyResponses, UpdateStatementTaxonomyErrors, ThrowOnError>({
  url: '/organization/{org_id}/corporate-finance/statement-taxonomies/{taxonomy_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Publish Statement Taxonomy
 *
 * Publish the tree while preserving completed results and excluding active extraction.
 *
 * No `require_locked_row` here, deliberately. The service already opens its own
 * transaction and takes `guard_hierarchy` *before* the taxonomy row, and a lock
 * taken out here would invert that order against every other writer of the
 * pair. There is also nothing row-scoped to re-prove: a catalog's authority is
 * organization-level, so a revocation takes effect on the next request (the
 * residual window RFC 5.11 already describes for the organization prompt
 * shelf).
 */
export const publishStatementTaxonomy = <ThrowOnError extends boolean = false>(options: Options<PublishStatementTaxonomyData, ThrowOnError>): RequestResult<PublishStatementTaxonomyResponses, PublishStatementTaxonomyErrors, ThrowOnError> => (options.client ?? client).post<PublishStatementTaxonomyResponses, PublishStatementTaxonomyErrors, ThrowOnError>({ url: '/organization/{org_id}/corporate-finance/statement-taxonomies/{taxonomy_id}/publish', ...options });

/**
 * Exportcorporatefinanceworkbook
 *
 * Export selected Corporate Finance worksheets as an XLSX workbook.
 */
export const exportCorporateFinanceWorkbook = <ThrowOnError extends boolean = false>(options: Options<ExportCorporateFinanceWorkbookData, ThrowOnError>): RequestResult<ExportCorporateFinanceWorkbookResponses, ExportCorporateFinanceWorkbookErrors, ThrowOnError> => (options.client ?? client).get<ExportCorporateFinanceWorkbookResponses, ExportCorporateFinanceWorkbookErrors, ThrowOnError>({ url: '/organization/{org_id}/corporate-finance/{project_id}/export', ...options });

/**
 * Get Audit Checks
 */
export const getAuditChecks = <ThrowOnError extends boolean = false>(options?: Options<GetAuditChecksData, ThrowOnError>): RequestResult<GetAuditChecksResponses, GetAuditChecksErrors, ThrowOnError> => (options?.client ?? client).get<GetAuditChecksResponses, GetAuditChecksErrors, ThrowOnError>({ url: '/check', ...options });

/**
 * Set Audit Check
 */
export const setAuditCheck = <ThrowOnError extends boolean = false>(options: Options<SetAuditCheckData, ThrowOnError>): RequestResult<SetAuditCheckResponses, SetAuditCheckErrors, ThrowOnError> => (options.client ?? client).post<SetAuditCheckResponses, SetAuditCheckErrors, ThrowOnError>({
  url: '/check',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Audit Check
 */
export const deleteAuditCheck = <ThrowOnError extends boolean = false>(options: Options<DeleteAuditCheckData, ThrowOnError>): RequestResult<DeleteAuditCheckResponses, DeleteAuditCheckErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAuditCheckResponses, DeleteAuditCheckErrors, ThrowOnError>({ url: '/check/{check_id}', ...options });

/**
 * Rerun Validation Check
 *
 * Rerun a validation check for all its associated clients.
 */
export const rerunValidationCheck = <ThrowOnError extends boolean = false>(options: Options<RerunValidationCheckData, ThrowOnError>): RequestResult<RerunValidationCheckResponses, RerunValidationCheckErrors, ThrowOnError> => (options.client ?? client).post<RerunValidationCheckResponses, RerunValidationCheckErrors, ThrowOnError>({ url: '/check/{check_id}/rerun', ...options });

/**
 * Run Debug Query
 */
export const runDebugQuery = <ThrowOnError extends boolean = false>(options: Options<RunDebugQueryData, ThrowOnError>): RequestResult<RunDebugQueryResponses, RunDebugQueryErrors, ThrowOnError> => (options.client ?? client).post<RunDebugQueryResponses, RunDebugQueryErrors, ThrowOnError>({
  url: '/check/debug',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Read Fas Classifications
 *
 * Read FAS ledger accounts and choices from their assigned published FAS tree.
 */
export const readFasClassifications = <ThrowOnError extends boolean = false>(options: Options<ReadFasClassificationsData, ThrowOnError>): RequestResult<ReadFasClassificationsResponses, ReadFasClassificationsErrors, ThrowOnError> => (options.client ?? client).get<ReadFasClassificationsResponses, ReadFasClassificationsErrors, ThrowOnError>({ url: '/organization/{org_id}/fas/{project_id}/classifications', ...options });

/**
 * Save Fas Classifications
 *
 * Save manual account overrides locally without changing warehouse source classifications.
 */
export const saveFasClassifications = <ThrowOnError extends boolean = false>(options: Options<SaveFasClassificationsData, ThrowOnError>): RequestResult<SaveFasClassificationsResponses, SaveFasClassificationsErrors, ThrowOnError> => (options.client ?? client).post<SaveFasClassificationsResponses, SaveFasClassificationsErrors, ThrowOnError>({
  url: '/organization/{org_id}/fas/{project_id}/classifications',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Predict Fas Classifications
 *
 * Preview typed predictions for unclassified accounts against the assigned FAS tree.
 */
export const predictFasClassifications = <ThrowOnError extends boolean = false>(options: Options<PredictFasClassificationsData, ThrowOnError>): RequestResult<PredictFasClassificationsResponses, PredictFasClassificationsErrors, ThrowOnError> => (options.client ?? client).post<PredictFasClassificationsResponses, PredictFasClassificationsErrors, ThrowOnError>({ url: '/organization/{org_id}/fas/{project_id}/classifications/predict', ...options });

/**
 * Accept Fas Predictions
 *
 * Accept server-issued predictions against the acceptance-time source read and local revisions.
 */
export const acceptFasPredictions = <ThrowOnError extends boolean = false>(options: Options<AcceptFasPredictionsData, ThrowOnError>): RequestResult<AcceptFasPredictionsResponses, AcceptFasPredictionsErrors, ThrowOnError> => (options.client ?? client).post<AcceptFasPredictionsResponses, AcceptFasPredictionsErrors, ThrowOnError>({
  url: '/organization/{org_id}/fas/{project_id}/classifications/predict/accept',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Preview
 */
export const getPreview = <ThrowOnError extends boolean = false>(options: Options<GetPreviewData, ThrowOnError>): RequestResult<GetPreviewResponses, GetPreviewErrors, ThrowOnError> => (options.client ?? client).get<GetPreviewResponses, GetPreviewErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource/{datasource_id}/preview', ...options });

/**
 * Get Datasource File
 *
 * Stream the file a blob-backed datasource was created from.
 */
export const getDatasourceFile = <ThrowOnError extends boolean = false>(options: Options<GetDatasourceFileData, ThrowOnError>): RequestResult<GetDatasourceFileResponses, GetDatasourceFileErrors, ThrowOnError> => (options.client ?? client).get<GetDatasourceFileResponses, GetDatasourceFileErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource/{datasource_id}/file', ...options });

/**
 * Export Datasource
 *
 * Stream every row of a view-backed datasource as CSV.
 */
export const exportDatasource = <ThrowOnError extends boolean = false>(options: Options<ExportDatasourceData, ThrowOnError>): RequestResult<ExportDatasourceResponses, ExportDatasourceErrors, ThrowOnError> => (options.client ?? client).get<ExportDatasourceResponses, ExportDatasourceErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource/{datasource_id}/export', ...options });

/**
 * Get Datasources Page
 *
 * One page of the datasources the list endpoint returns, with the same filters and access rules.
 *
 * The authorized relation is the base, and the filters, the sort and the page
 * are layered on top of it: there is no wider statement to page by accident,
 * and `total` counts the same relation after the caller's own filters rather
 * than the table.
 *
 * Sorting happens here rather than in the client so the order holds across
 * pages.
 */
export const getDatasourcesPage = <ThrowOnError extends boolean = false>(options: Options<GetDatasourcesPageData, ThrowOnError>): RequestResult<GetDatasourcesPageResponses, GetDatasourcesPageErrors, ThrowOnError> => (options.client ?? client).get<GetDatasourcesPageResponses, GetDatasourcesPageErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource/page', ...options });

/**
 * Get Datasource Filters
 *
 * Return the filter options the UI offers for data-management datasources.
 *
 * Only considers datasources the user can see, and excludes any linked to an
 * audit client (those belong to the dossier context).
 */
export const getDatasourceFilters = <ThrowOnError extends boolean = false>(options: Options<GetDatasourceFiltersData, ThrowOnError>): RequestResult<GetDatasourceFiltersResponses, GetDatasourceFiltersErrors, ThrowOnError> => (options.client ?? client).get<GetDatasourceFiltersResponses, GetDatasourceFiltersErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource/filters', ...options });

/**
 * Get Datasource By Id
 *
 * Return a datasource by ID, honouring both RBAC and audit-member access paths.
 *
 * Access is granted through two paths:
 *
 * - **Data management (RBAC):** owner, explicit per-resource grant, role-level
 *   wildcard, or superuser.
 * - **Project membership:** the caller holds a project-scoped audit role on a
 *   project that links to this datasource via `ProjectDatasource`.
 *   This lets audit executors open datasources for document analysis without
 *   requiring explicit RBAC shares.
 *
 * Raises:
 *     DatasourceNotFoundException: If the datasource is not found or user lacks access.
 */
export const getDatasourceById = <ThrowOnError extends boolean = false>(options: Options<GetDatasourceByIdData, ThrowOnError>): RequestResult<GetDatasourceByIdResponses, GetDatasourceByIdErrors, ThrowOnError> => (options.client ?? client).get<GetDatasourceByIdResponses, GetDatasourceByIdErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource/{datasource_id}', ...options });

/**
 * Update Datasource
 *
 * Rename a datasource, retype its data, or replace its context block.
 *
 * The gate answered about a snapshot, so the row is locked and
 * `update_datasource` proved again on the version that got locked: concurrent
 * PATCHes serialize and a caller whose tier was withdrawn in between writes
 * nothing.
 */
export const updateDatasource = <ThrowOnError extends boolean = false>(options: Options<UpdateDatasourceData, ThrowOnError>): RequestResult<UpdateDatasourceResponses, UpdateDatasourceErrors, ThrowOnError> => (options.client ?? client).patch<UpdateDatasourceResponses, UpdateDatasourceErrors, ThrowOnError>({
  url: '/organization/{org_id}/datasource/{datasource_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Datasources
 *
 * Soft-delete every named datasource, or none of them.
 *
 * The gate is all-or-nothing over the whole query list, which is the per-id
 * refusal the loop here used to do in N reads. Two things it cannot answer are
 * left, and both are read here rather than in the gate because both are
 * product state rather than authority.
 *
 * **A repeated id.** The gate keys its rows by id, so duplicates collapse. The
 * loop this replaced compared the count of rows it loaded against the count of
 * ids it was given, so `?datasource_ids=X&datasource_ids=X` answered 404 with
 * an empty id list. Reproducing that comparison here is what keeps the answer
 * the one callers already get; it runs after the gate because nothing of the
 * handler's own may resolve before a gate does, and the precedence is
 * unchanged either way (the old loop authorized first too).
 *
 * **`deleted_at`.** The tenant select deliberately keeps a soft-deleted row
 * (see the policy), so an already-deleted id passes the gate. It is checked on
 * the **locked** rows, not on the gate's snapshot: `soft_delete_datasources`
 * ignores a row that is already gone, so a caller whose authority survives the
 * delete - a blanket YAML grant, where a tier is wiped with the row - would
 * otherwise be told a delete succeeded that did nothing.
 *
 * Each row is locked in id order and `delete_datasource` proved again on the
 * locked version, so a revocation committing between the gate and the write
 * cannot be overtaken. One order for every writer of several datasources,
 * which is what stops two bulk deletes deadlocking.
 */
export const deleteDatasources = <ThrowOnError extends boolean = false>(options: Options<DeleteDatasourcesData, ThrowOnError>): RequestResult<DeleteDatasourcesResponses, DeleteDatasourcesErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDatasourcesResponses, DeleteDatasourcesErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource', ...options });

/**
 * Create Datasource
 *
 * Create a new datasource within the specified organization.
 */
export const createDatasource = <ThrowOnError extends boolean = false>(options: Options<CreateDatasourceData, ThrowOnError>): RequestResult<CreateDatasourceResponses, CreateDatasourceErrors, ThrowOnError> => (options.client ?? client).post<CreateDatasourceResponses, CreateDatasourceErrors, ThrowOnError>({
  url: '/organization/{org_id}/datasource',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Shared Datasource
 *
 * Return tiered grantees plus the caller's own effective tier.
 *
 * `users` and `roles` are the revocable surfaces (per-user scoped tiers and
 * group grants); `role_derived_users` is informational so the UI can explain
 * why a user has access without offering a no-op revoke.
 */
export const getSharedDatasource = <ThrowOnError extends boolean = false>(options: Options<GetSharedDatasourceData, ThrowOnError>): RequestResult<GetSharedDatasourceResponses, GetSharedDatasourceErrors, ThrowOnError> => (options.client ?? client).get<GetSharedDatasourceResponses, GetSharedDatasourceErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource/{datasource_id}/share', ...options });

/**
 * Patch Shared Datasource
 *
 * Apply tier deltas to user grants and role grants, enforcing Rule B.
 *
 * The gate decides whether the caller may share at all; Rule B decides what
 * they may hand out, and the two are not interchangeable. Between them comes
 * the shared write step: the departments this delta writes grants for are
 * taken exclusively, the datasource row is locked, and `share_datasource` is
 * proved again on the version that got locked - so concurrent PATCHes
 * serialize and a caller whose own tier was withdrawn in between confers
 * nothing.
 */
export const patchSharedDatasource = <ThrowOnError extends boolean = false>(options: Options<PatchSharedDatasourceData, ThrowOnError>): RequestResult<PatchSharedDatasourceResponses, PatchSharedDatasourceErrors, ThrowOnError> => (options.client ?? client).patch<PatchSharedDatasourceResponses, PatchSharedDatasourceErrors, ThrowOnError>({
  url: '/organization/{org_id}/datasource/{datasource_id}/share',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Document Analysis Settings
 *
 * Read the document's page scope for future statement extractions.
 */
export const getDocumentAnalysisSettings = <ThrowOnError extends boolean = false>(options: Options<GetDocumentAnalysisSettingsData, ThrowOnError>): RequestResult<GetDocumentAnalysisSettingsResponses, GetDocumentAnalysisSettingsErrors, ThrowOnError> => (options.client ?? client).get<GetDocumentAnalysisSettingsResponses, GetDocumentAnalysisSettingsErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource/{datasource_id}/analysis-settings', ...options });

/**
 * Update Document Analysis Settings
 *
 * Save page selection without changing results or scheduling work.
 */
export const updateDocumentAnalysisSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateDocumentAnalysisSettingsData, ThrowOnError>): RequestResult<UpdateDocumentAnalysisSettingsResponses, UpdateDocumentAnalysisSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateDocumentAnalysisSettingsResponses, UpdateDocumentAnalysisSettingsErrors, ThrowOnError>({
  url: '/organization/{org_id}/datasource/{datasource_id}/analysis-settings',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Collection Filters
 *
 * Return available filter values scoped to the collections the user can read.
 */
export const getCollectionFilters = <ThrowOnError extends boolean = false>(options: Options<GetCollectionFiltersData, ThrowOnError>): RequestResult<GetCollectionFiltersResponses, GetCollectionFiltersErrors, ThrowOnError> => (options.client ?? client).get<GetCollectionFiltersResponses, GetCollectionFiltersErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource-collection/filters', ...options });

/**
 * Create Collection
 *
 * Create a new datasource collection; the creator becomes its admin.
 */
export const createCollection = <ThrowOnError extends boolean = false>(options: Options<CreateCollectionData, ThrowOnError>): RequestResult<CreateCollectionResponses, CreateCollectionErrors, ThrowOnError> => (options.client ?? client).post<CreateCollectionResponses, CreateCollectionErrors, ThrowOnError>({
  url: '/organization/{org_id}/datasource-collection',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * List Collections Page
 *
 * One page of the collections the user can read, with the list's filters.
 *
 * `datasource_ids` keeps collections holding any of those datasources. Access is
 * narrowed in the query, so `total` counts only readable collections.
 */
export const listCollectionsPage = <ThrowOnError extends boolean = false>(options: Options<ListCollectionsPageData, ThrowOnError>): RequestResult<ListCollectionsPageResponses, ListCollectionsPageErrors, ThrowOnError> => (options.client ?? client).get<ListCollectionsPageResponses, ListCollectionsPageErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource-collection/page', ...options });

/**
 * Delete Collection
 *
 * Delete a datasource collection and its per-resource grants.
 */
export const deleteCollection = <ThrowOnError extends boolean = false>(options: Options<DeleteCollectionData, ThrowOnError>): RequestResult<DeleteCollectionResponses, DeleteCollectionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCollectionResponses, DeleteCollectionErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource-collection/{collection_id}', ...options });

/**
 * Get Collection
 *
 * Get a single datasource collection by ID.
 */
export const getCollection = <ThrowOnError extends boolean = false>(options: Options<GetCollectionData, ThrowOnError>): RequestResult<GetCollectionResponses, GetCollectionErrors, ThrowOnError> => (options.client ?? client).get<GetCollectionResponses, GetCollectionErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource-collection/{collection_id}', ...options });

/**
 * Update Collection
 *
 * Update a datasource collection (name and datasource membership).
 *
 * Membership is a datasource-exposure door, so the datasources joining the
 * collection keep their own guard: a caller must already hold `read_datasource`
 * on each one. That is a different contract from reaching this collection, and
 * routing it through the collection policy would make a collection grant the
 * key to every datasource anyone adds to it (RFC 0001 section 5.5).
 */
export const updateCollection = <ThrowOnError extends boolean = false>(options: Options<UpdateCollectionData, ThrowOnError>): RequestResult<UpdateCollectionResponses, UpdateCollectionErrors, ThrowOnError> => (options.client ?? client).put<UpdateCollectionResponses, UpdateCollectionErrors, ThrowOnError>({
  url: '/organization/{org_id}/datasource-collection/{collection_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Collection Share
 *
 * Return tiered grantees plus the caller's own effective tier on the collection.
 */
export const getCollectionShare = <ThrowOnError extends boolean = false>(options: Options<GetCollectionShareData, ThrowOnError>): RequestResult<GetCollectionShareResponses, GetCollectionShareErrors, ThrowOnError> => (options.client ?? client).get<GetCollectionShareResponses, GetCollectionShareErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource-collection/{collection_id}/share', ...options });

/**
 * Patch Collection Share
 *
 * Apply tier deltas to collection grants and cascade them onto its datasources.
 *
 * The gate answered about a snapshot, so the row is locked and
 * `share_datasource_collection` proved again on the version that got locked:
 * concurrent PATCHes serialize and a caller whose own tier was withdrawn in
 * between confers nothing. Then org membership of grantees and known role names
 * are validated, Rule B is enforced on the collection, and the caller must be
 * able to confer the mirrored tier on every datasource in it (strict block, no
 * partial writes).
 */
export const patchCollectionShare = <ThrowOnError extends boolean = false>(options: Options<PatchCollectionShareData, ThrowOnError>): RequestResult<PatchCollectionShareResponses, PatchCollectionShareErrors, ThrowOnError> => (options.client ?? client).patch<PatchCollectionShareResponses, PatchCollectionShareErrors, ThrowOnError>({
  url: '/organization/{org_id}/datasource-collection/{collection_id}/share',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * List Origins
 */
export const listOrigins = <ThrowOnError extends boolean = false>(options: Options<ListOriginsData, ThrowOnError>): RequestResult<ListOriginsResponses, ListOriginsErrors, ThrowOnError> => (options.client ?? client).get<ListOriginsResponses, ListOriginsErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource-origin', ...options });

/**
 * Create Origin
 */
export const createOrigin = <ThrowOnError extends boolean = false>(options: Options<CreateOriginData, ThrowOnError>): RequestResult<CreateOriginResponses, CreateOriginErrors, ThrowOnError> => (options.client ?? client).post<CreateOriginResponses, CreateOriginErrors, ThrowOnError>({
  url: '/organization/{org_id}/datasource-origin',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Origin
 */
export const deleteOrigin = <ThrowOnError extends boolean = false>(options: Options<DeleteOriginData, ThrowOnError>): RequestResult<DeleteOriginResponses, DeleteOriginErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOriginResponses, DeleteOriginErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource-origin/{origin_id}', ...options });

/**
 * Get Origin
 */
export const getOrigin = <ThrowOnError extends boolean = false>(options: Options<GetOriginData, ThrowOnError>): RequestResult<GetOriginResponses, GetOriginErrors, ThrowOnError> => (options.client ?? client).get<GetOriginResponses, GetOriginErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource-origin/{origin_id}', ...options });

/**
 * Update Origin
 */
export const updateOrigin = <ThrowOnError extends boolean = false>(options: Options<UpdateOriginData, ThrowOnError>): RequestResult<UpdateOriginResponses, UpdateOriginErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOriginResponses, UpdateOriginErrors, ThrowOnError>({
  url: '/organization/{org_id}/datasource-origin/{origin_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * List Origin Tables
 *
 * List schemas & tables on a MSSQL origin, marking which are already datasources.
 *
 * `already_used=True` + `datasource_id` lets the UI link existing picks back to
 * their datasource and grey them out on the select list without a second
 * round-trip.
 */
export const listOriginTables = <ThrowOnError extends boolean = false>(options: Options<ListOriginTablesData, ThrowOnError>): RequestResult<ListOriginTablesResponses, ListOriginTablesErrors, ThrowOnError> => (options.client ?? client).get<ListOriginTablesResponses, ListOriginTablesErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource-origin/{origin_id}/tables', ...options });

/**
 * Bulk Create Origin Datasources
 *
 * Bulk-create MSSQL datasources that reuse an existing origin.
 *
 * Unlike `POST /datasource`, this does NOT create a new origin per datasource.
 * The batch is atomic: if any table conflicts with an existing active
 * datasource on this origin, the whole request is rejected with 409 and the
 * list of conflicts.
 */
export const bulkCreateOriginDatasources = <ThrowOnError extends boolean = false>(options: Options<BulkCreateOriginDatasourcesData, ThrowOnError>): RequestResult<BulkCreateOriginDatasourcesResponses, BulkCreateOriginDatasourcesErrors, ThrowOnError> => (options.client ?? client).post<BulkCreateOriginDatasourcesResponses, BulkCreateOriginDatasourcesErrors, ThrowOnError>({
  url: '/organization/{org_id}/datasource-origin/{origin_id}/datasources',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Test Origin Connection
 *
 * Probe connectivity to a MSSQL origin by running `SELECT 1`.
 *
 * Always returns HTTP 200 even when the probe itself fails; the outcome is
 * carried in `ok`, so the UI can render a status chip from a uniform shape.
 * Engine creation / connection errors are captured into `error` rather than
 * bubbled up to the global exception handler.
 */
export const testOriginConnection = <ThrowOnError extends boolean = false>(options: Options<TestOriginConnectionData, ThrowOnError>): RequestResult<TestOriginConnectionResponses, TestOriginConnectionErrors, ThrowOnError> => (options.client ?? client).post<TestOriginConnectionResponses, TestOriginConnectionErrors, ThrowOnError>({ url: '/organization/{org_id}/datasource-origin/{origin_id}/test', ...options });

/**
 * Get Dashboards
 */
export const getDashboards = <ThrowOnError extends boolean = false>(options: Options<GetDashboardsData, ThrowOnError>): RequestResult<GetDashboardsResponses, GetDashboardsErrors, ThrowOnError> => (options.client ?? client).get<GetDashboardsResponses, GetDashboardsErrors, ThrowOnError>({ url: '/organization/{org_id}/dashboards', ...options });

/**
 * Create Dashboard
 */
export const createDashboard = <ThrowOnError extends boolean = false>(options: Options<CreateDashboardData, ThrowOnError>): RequestResult<CreateDashboardResponses, CreateDashboardErrors, ThrowOnError> => (options.client ?? client).post<CreateDashboardResponses, CreateDashboardErrors, ThrowOnError>({
  url: '/organization/{org_id}/dashboards',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Dashboard
 */
export const deleteDashboard = <ThrowOnError extends boolean = false>(options: Options<DeleteDashboardData, ThrowOnError>): RequestResult<DeleteDashboardResponses, DeleteDashboardErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDashboardResponses, DeleteDashboardErrors, ThrowOnError>({ url: '/organization/{org_id}/dashboards/{dashboard_id}', ...options });

/**
 * Get Dashboard
 */
export const getDashboard = <ThrowOnError extends boolean = false>(options: Options<GetDashboardData, ThrowOnError>): RequestResult<GetDashboardResponses, GetDashboardErrors, ThrowOnError> => (options.client ?? client).get<GetDashboardResponses, GetDashboardErrors, ThrowOnError>({ url: '/organization/{org_id}/dashboards/{dashboard_id}', ...options });

/**
 * Update Dashboard
 */
export const updateDashboard = <ThrowOnError extends boolean = false>(options: Options<UpdateDashboardData, ThrowOnError>): RequestResult<UpdateDashboardResponses, UpdateDashboardErrors, ThrowOnError> => (options.client ?? client).put<UpdateDashboardResponses, UpdateDashboardErrors, ThrowOnError>({
  url: '/organization/{org_id}/dashboards/{dashboard_id}',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Create Dashboard Widget
 */
export const createDashboardWidget = <ThrowOnError extends boolean = false>(options: Options<CreateDashboardWidgetData, ThrowOnError>): RequestResult<CreateDashboardWidgetResponses, CreateDashboardWidgetErrors, ThrowOnError> => (options.client ?? client).post<CreateDashboardWidgetResponses, CreateDashboardWidgetErrors, ThrowOnError>({
  url: '/organization/{org_id}/dashboards/{dashboard_id}/widgets',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Create Dashboard Chain Widget
 *
 * Pin a chat chart/table as a live widget by capturing its tool-call chain.
 *
 * The chain is extracted deterministically from the conversation's dataframe
 * lineage (no LLM), then replayed once to populate the widget.
 *
 * The replay runs before the lock, not under it. It may spin up a sandbox, so
 * holding the dashboard across it would block every other write on that
 * dashboard for the length of a foreign round trip. The authority is proved
 * again immediately before the one write, which is what it has to be newer
 * than.
 */
export const createDashboardChainWidget = <ThrowOnError extends boolean = false>(options: Options<CreateDashboardChainWidgetData, ThrowOnError>): RequestResult<CreateDashboardChainWidgetResponses, CreateDashboardChainWidgetErrors, ThrowOnError> => (options.client ?? client).post<CreateDashboardChainWidgetResponses, CreateDashboardChainWidgetErrors, ThrowOnError>({
  url: '/organization/{org_id}/dashboards/{dashboard_id}/widgets/chain',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Delete Dashboard Widget
 */
export const deleteDashboardWidget = <ThrowOnError extends boolean = false>(options: Options<DeleteDashboardWidgetData, ThrowOnError>): RequestResult<DeleteDashboardWidgetResponses, DeleteDashboardWidgetErrors, ThrowOnError> => (options.client ?? client).delete<DeleteDashboardWidgetResponses, DeleteDashboardWidgetErrors, ThrowOnError>({ url: '/organization/{org_id}/dashboards/{dashboard_id}/widgets/{widget_id}', ...options });

/**
 * Update Dashboard Widget Position
 */
export const updateDashboardWidgetPosition = <ThrowOnError extends boolean = false>(options: Options<UpdateDashboardWidgetPositionData, ThrowOnError>): RequestResult<UpdateDashboardWidgetPositionResponses, UpdateDashboardWidgetPositionErrors, ThrowOnError> => (options.client ?? client).put<UpdateDashboardWidgetPositionResponses, UpdateDashboardWidgetPositionErrors, ThrowOnError>({ url: '/organization/{org_id}/dashboards/{dashboard_id}/widgets/{widget_id}/position', ...options });

/**
 * Update Dashboard Widget Name
 */
export const updateDashboardWidgetName = <ThrowOnError extends boolean = false>(options: Options<UpdateDashboardWidgetNameData, ThrowOnError>): RequestResult<UpdateDashboardWidgetNameResponses, UpdateDashboardWidgetNameErrors, ThrowOnError> => (options.client ?? client).put<UpdateDashboardWidgetNameResponses, UpdateDashboardWidgetNameErrors, ThrowOnError>({ url: '/organization/{org_id}/dashboards/{dashboard_id}/widgets/{widget_id}/rename', ...options });

/**
 * Update Dashboard Widget Type
 *
 * Only allow changing between chart types, not between chart and table.
 */
export const updateDashboardWidgetType = <ThrowOnError extends boolean = false>(options: Options<UpdateDashboardWidgetTypeData, ThrowOnError>): RequestResult<UpdateDashboardWidgetTypeResponses, UpdateDashboardWidgetTypeErrors, ThrowOnError> => (options.client ?? client).patch<UpdateDashboardWidgetTypeResponses, UpdateDashboardWidgetTypeErrors, ThrowOnError>({
  url: '/organization/{org_id}/dashboards/{dashboard_id}/widgets/{widget_id}/type',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Refresh Dashboard
 *
 * Re-execute every widget in a dashboard and update its data.
 *
 * SQL widgets re-run their query; chain widgets replay their tool calls. Each
 * widget refreshes one at a time on purpose: chain widgets may spin up a
 * sandbox per replay, and the datasources are bound to the request session
 * (lazy `origin` loads), which is not concurrency-safe. A broken widget is
 * isolated so it doesn't abort the rest.
 *
 * The write authorization is rechecked at the end rather than up front. The
 * refresh loop releases the request transaction and then runs external queries
 * and sandbox replays, so a lock taken before it would either be dropped by
 * that release or held across minutes of foreign I/O.
 *
 * So the loop produces values rather than writes. Its results are staged, the
 * in-memory mutations are discarded, and only then does the request take its
 * locks - the dashboard for the authority recheck, then each refreshed widget -
 * and replay the staged fields onto the rows it is holding. A widget edit locks
 * the widget and not the dashboard, so persisting the loop's objects directly
 * would write a stale title or type over a rename that committed while the
 * loop ran, and would try to persist a widget that was deleted in the same
 * window.
 */
export const refreshDashboard = <ThrowOnError extends boolean = false>(options: Options<RefreshDashboardData, ThrowOnError>): RequestResult<RefreshDashboardResponses, RefreshDashboardErrors, ThrowOnError> => (options.client ?? client).put<RefreshDashboardResponses, RefreshDashboardErrors, ThrowOnError>({ url: '/organization/{org_id}/dashboards/{dashboard_id}/refresh', ...options });

/**
 * Refresh Dashboard Widget
 *
 * Refresh a single widget: re-run its SQL query or replay its tool-call chain.
 *
 * The query or the replay runs before the lock, for the same reason the
 * dashboard-wide refresh does: it is external work of unbounded length, and
 * holding the widget and its dashboard across it would block every other write
 * on either. So the result is staged, the in-memory mutation is dropped, and
 * the request takes its locks and replays only the refreshed fields - which is
 * also what keeps a rename that landed meanwhile.
 */
export const refreshDashboardWidget = <ThrowOnError extends boolean = false>(options: Options<RefreshDashboardWidgetData, ThrowOnError>): RequestResult<RefreshDashboardWidgetResponses, RefreshDashboardWidgetErrors, ThrowOnError> => (options.client ?? client).put<RefreshDashboardWidgetResponses, RefreshDashboardWidgetErrors, ThrowOnError>({ url: '/organization/{org_id}/dashboards/{dashboard_id}/widgets/{widget_id}/refresh', ...options });

/**
 * Get Shared Dashboard
 *
 * Return tiered grantees plus the caller's own effective tier.
 *
 * `users` and `roles` are the revocable surfaces; `role_derived_users` is
 * informational so the UI can explain access without offering a no-op revoke.
 */
export const getSharedDashboard = <ThrowOnError extends boolean = false>(options: Options<GetSharedDashboardData, ThrowOnError>): RequestResult<GetSharedDashboardResponses, GetSharedDashboardErrors, ThrowOnError> => (options.client ?? client).get<GetSharedDashboardResponses, GetSharedDashboardErrors, ThrowOnError>({ url: '/organization/{org_id}/dashboards/{dashboard_id}/share', ...options });

/**
 * Patch Shared Dashboard
 *
 * Apply tier deltas to user and role grants, enforcing Rule B.
 *
 * The gate answered about a snapshot, so the row is locked and `share_dashboard`
 * proved again on the version that got locked: concurrent PATCHes serialize and
 * a caller whose own tier was withdrawn in between confers nothing. Then org
 * membership and known role names are validated, and Rule B enforces "grant at
 * most your own tier" (admin only to users) over both grants and revokes; any
 * violation rejects the whole request.
 */
export const patchSharedDashboard = <ThrowOnError extends boolean = false>(options: Options<PatchSharedDashboardData, ThrowOnError>): RequestResult<PatchSharedDashboardResponses, PatchSharedDashboardErrors, ThrowOnError> => (options.client ?? client).patch<PatchSharedDashboardResponses, PatchSharedDashboardErrors, ThrowOnError>({
  url: '/organization/{org_id}/dashboards/{dashboard_id}/share',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Create Widget Chat
 *
 * Create a new chat conversation with a widget's data prefilled.
 *
 * No row lock: this mutates neither the dashboard nor the widget, it creates a
 * conversation seeded from them, so there is no write whose authority could go
 * stale between the gate and the commit.
 */
export const createWidgetChat = <ThrowOnError extends boolean = false>(options: Options<CreateWidgetChatData, ThrowOnError>): RequestResult<CreateWidgetChatResponses, CreateWidgetChatErrors, ThrowOnError> => (options.client ?? client).post<CreateWidgetChatResponses, CreateWidgetChatErrors, ThrowOnError>({ url: '/organization/{org_id}/dashboards/{dashboard_id}/widgets/{widget_id}/chat', ...options });

/**
 * Submit a bug report
 *
 * Submits a new bug report for the provided project context and optionally uploads attachments.
 */
export const createBugReport = <ThrowOnError extends boolean = false>(options: Options<CreateBugReportData, ThrowOnError>): RequestResult<CreateBugReportResponses, CreateBugReportErrors, ThrowOnError> => (options.client ?? client).post<CreateBugReportResponses, CreateBugReportErrors, ThrowOnError>({
  ...formDataBodySerializer,
  url: '/organization/{org_id}/reports/bug-reports/',
  ...options,
  headers: {
    'Content-Type': null,
    ...options.headers
  }
});

/**
 * List Promotion Requests
 */
export const listPromotionRequests = <ThrowOnError extends boolean = false>(options: Options<ListPromotionRequestsData, ThrowOnError>): RequestResult<ListPromotionRequestsResponses, ListPromotionRequestsErrors, ThrowOnError> => (options.client ?? client).get<ListPromotionRequestsResponses, ListPromotionRequestsErrors, ThrowOnError>({ url: '/organization/{org_id}/promotion-requests', ...options });

/**
 * Create Promotion Request
 */
export const createPromotionRequest = <ThrowOnError extends boolean = false>(options: Options<CreatePromotionRequestData, ThrowOnError>): RequestResult<CreatePromotionRequestResponses, CreatePromotionRequestErrors, ThrowOnError> => (options.client ?? client).post<CreatePromotionRequestResponses, CreatePromotionRequestErrors, ThrowOnError>({
  url: '/organization/{org_id}/promotion-requests',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Get Pending Document Analysis Template For Promotion Review
 *
 * Read the exact pending document-analysis template an approver may decide.
 */
export const getPendingDocumentAnalysisTemplateForPromotionReview = <ThrowOnError extends boolean = false>(options: Options<GetPendingDocumentAnalysisTemplateForPromotionReviewData, ThrowOnError>): RequestResult<GetPendingDocumentAnalysisTemplateForPromotionReviewResponses, GetPendingDocumentAnalysisTemplateForPromotionReviewErrors, ThrowOnError> => (options.client ?? client).get<GetPendingDocumentAnalysisTemplateForPromotionReviewResponses, GetPendingDocumentAnalysisTemplateForPromotionReviewErrors, ThrowOnError>({ url: '/organization/{org_id}/promotion-requests/{promotion_request_id}/document-analysis-template', ...options });

/**
 * Update Pending Document Analysis Template For Promotion Review
 *
 * Version a pending review resource without closing or superseding its request.
 */
export const updatePendingDocumentAnalysisTemplateForPromotionReview = <ThrowOnError extends boolean = false>(options: Options<UpdatePendingDocumentAnalysisTemplateForPromotionReviewData, ThrowOnError>): RequestResult<UpdatePendingDocumentAnalysisTemplateForPromotionReviewResponses, UpdatePendingDocumentAnalysisTemplateForPromotionReviewErrors, ThrowOnError> => (options.client ?? client).put<UpdatePendingDocumentAnalysisTemplateForPromotionReviewResponses, UpdatePendingDocumentAnalysisTemplateForPromotionReviewErrors, ThrowOnError>({
  url: '/organization/{org_id}/promotion-requests/{promotion_request_id}/document-analysis-template',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Cancel Promotion Request
 */
export const cancelPromotionRequest = <ThrowOnError extends boolean = false>(options: Options<CancelPromotionRequestData, ThrowOnError>): RequestResult<CancelPromotionRequestResponses, CancelPromotionRequestErrors, ThrowOnError> => (options.client ?? client).delete<CancelPromotionRequestResponses, CancelPromotionRequestErrors, ThrowOnError>({ url: '/organization/{org_id}/promotion-requests/{promotion_request_id}', ...options });

/**
 * Get Promotion Request
 */
export const getPromotionRequest = <ThrowOnError extends boolean = false>(options: Options<GetPromotionRequestData, ThrowOnError>): RequestResult<GetPromotionRequestResponses, GetPromotionRequestErrors, ThrowOnError> => (options.client ?? client).get<GetPromotionRequestResponses, GetPromotionRequestErrors, ThrowOnError>({ url: '/organization/{org_id}/promotion-requests/{promotion_request_id}', ...options });

/**
 * Approve Promotion Request
 */
export const approvePromotionRequest = <ThrowOnError extends boolean = false>(options: Options<ApprovePromotionRequestData, ThrowOnError>): RequestResult<ApprovePromotionRequestResponses, ApprovePromotionRequestErrors, ThrowOnError> => (options.client ?? client).post<ApprovePromotionRequestResponses, ApprovePromotionRequestErrors, ThrowOnError>({
  url: '/organization/{org_id}/promotion-requests/{promotion_request_id}/approve',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Reject Promotion Request
 */
export const rejectPromotionRequest = <ThrowOnError extends boolean = false>(options: Options<RejectPromotionRequestData, ThrowOnError>): RequestResult<RejectPromotionRequestResponses, RejectPromotionRequestErrors, ThrowOnError> => (options.client ?? client).post<RejectPromotionRequestResponses, RejectPromotionRequestErrors, ThrowOnError>({
  url: '/organization/{org_id}/promotion-requests/{promotion_request_id}/reject',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Revert Promotion Request
 *
 * Undo an approved promotion, restoring the resource's pre-promotion scope.
 *
 * Requires `delete_promotion_request` on the request's target scope (the
 * same authority as a hard delete). Only approved requests carrying a
 * captured snapshot can be reverted, and only while the resource still
 * sits at the scope this request promoted it to.
 */
export const revertPromotionRequest = <ThrowOnError extends boolean = false>(options: Options<RevertPromotionRequestData, ThrowOnError>): RequestResult<RevertPromotionRequestResponses, RevertPromotionRequestErrors, ThrowOnError> => (options.client ?? client).post<RevertPromotionRequestResponses, RevertPromotionRequestErrors, ThrowOnError>({ url: '/organization/{org_id}/promotion-requests/{promotion_request_id}/revert', ...options });

/**
 * Hard Delete Promotion Request
 *
 * Permanently remove a promotion request row.
 *
 * Requires `delete_promotion_request` on the request's target scope;
 * granted to `project_admin` on `project_type.*` (and to project-scoped
 * admins via the `project.*: *` wildcard). Distinct from the soft-cancel
 * `DELETE /promotion-requests/{id}` endpoint: this erases the audit row
 * entirely. Works on pending/rejected/cancelled/superseded rows, but an
 * approved request must be reverted (`POST .../revert`) instead; deleting
 * it would orphan the applied scope swap.
 */
export const hardDeletePromotionRequest = <ThrowOnError extends boolean = false>(options: Options<HardDeletePromotionRequestData, ThrowOnError>): RequestResult<HardDeletePromotionRequestResponses, HardDeletePromotionRequestErrors, ThrowOnError> => (options.client ?? client).delete<HardDeletePromotionRequestResponses, HardDeletePromotionRequestErrors, ThrowOnError>({ url: '/organization/{org_id}/promotion-requests/{promotion_request_id}/permanent', ...options });

/**
 * Workos Authorize
 */
export const workosAuthorize = <ThrowOnError extends boolean = false>(options?: Options<WorkosAuthorizeData, ThrowOnError>): RequestResult<WorkosAuthorizeResponses, WorkosAuthorizeErrors, ThrowOnError> => (options?.client ?? client).get<WorkosAuthorizeResponses, WorkosAuthorizeErrors, ThrowOnError>({ url: '/auth/workos/authorize', ...options });

/**
 * Workos Callback
 */
export const workosCallback = <ThrowOnError extends boolean = false>(options: Options<WorkosCallbackData, ThrowOnError>): RequestResult<WorkosCallbackResponses, WorkosCallbackErrors, ThrowOnError> => (options.client ?? client).post<WorkosCallbackResponses, WorkosCallbackErrors, ThrowOnError>({
  url: '/auth/workos/callback',
  ...options,
  headers: {
    'Content-Type': 'application/json',
    ...options.headers
  }
});

/**
 * Workos Refresh
 */
export const workosRefresh = <ThrowOnError extends boolean = false>(options?: Options<WorkosRefreshData, ThrowOnError>): RequestResult<WorkosRefreshResponses, WorkosRefreshErrors, ThrowOnError> => (options?.client ?? client).post<WorkosRefreshResponses, WorkosRefreshErrors, ThrowOnError>({ url: '/auth/workos/refresh', ...options });

/**
 * Workos Logout
 */
export const workosLogout = <ThrowOnError extends boolean = false>(options?: Options<WorkosLogoutData, ThrowOnError>): RequestResult<WorkosLogoutResponses, WorkosLogoutErrors, ThrowOnError> => (options?.client ?? client).post<WorkosLogoutResponses, WorkosLogoutErrors, ThrowOnError>({ url: '/auth/workos/logout', ...options });
